{
  "imageUpload": {
    "preparing": "Preparando imagen…",
    "uploading": "Subiendo imagen…",
    "retrying": "Reintentando subida…",
    "failed": "No se pudo subir la imagen",
    "failedTooLarge": "La imagen es demasiado grande",
    "failedUnsupported": "Formato de imagen no admitido",
    "failedNetwork": "Sin conexión con el servidor",
    "failedPrepare": "No se pudo procesar la imagen",
    "retry": "Reintentar",
    "pendingWarning": "Hay {{count}} imagen(es) que solo existen en este navegador y no se han guardado en el servidor. Se perderán si cierras o recargas la página."
  },
  "super": {
    "title": "Administración",
    "issuesTitle": "Reportes e ideas",
    "issuesSubtitle": "Revisa las incidencias y sugerencias enviadas por los usuarios",
    "brandsTab": "Marcas",
    "brandsTitle": "Marcas y distribuidores",
    "brandsSubtitle": "Quién nos trae cada cliente y qué ve al entrar",
    "packagesTab": "Paquetes",
    "packagesTitle": "Paquetes de funcionalidades",
    "packagesSubtitle": "Qué incluye cada paquete y cuántos informes al mes"
  },
  "packages": {
    "modalSubtitle": "Define la bolsa de informes y las funcionalidades incluidas.",
    "create": "Crear paquete",
    "optional": "Opcional",
    "activeLabel": "Paquete activo",
    "informesPerMonth": "Informes / mes",
    "informesPlaceholder": "p. ej. 500",
    "plazoLabel": "Plazo del lote",
    "days": "días",
    "overageTitle": "Al agotar la bolsa",
    "policyOption": {
      "charge": "Cobrar extra",
      "block": "Bloquear IA"
    },
    "policyHint": {
      "charge": "Cada informe por encima de la bolsa se factura aparte.",
      "block": "Al agotar la bolsa se detiene la IA hasta el mes siguiente."
    },
    "priceLabel": "Precio por informe extra",
    "capPlaceholder": "Sin tope",
    "capHint": "Vacío = sin límite.",
    "selectedCount_one": "{{count}} seleccionada",
    "selectedCount_other": "{{count}} seleccionadas",
    "requestFeaturesHint": "Consumen iteraciones",
    "toggleFeaturesHint": "No consumen iteraciones",
    "imagingWarningRich": "Sin <strong>Modalidad de imagen</strong> el guardado no clasifica la modalidad y la facturación por modalidad de estas cuentas quedará vacía.",
    "section": {
      "identity": "Identificación",
      "pool": "Bolsa mensual",
      "overage": "Exceso",
      "features": "Funcionalidades"
    },
    "pool": {
      "unlimited": "Informes ilimitados: sin bolsa ni exceso.",
      "empty": "Indica informes e iteraciones para ver la bolsa.",
      "suffix": "iteraciones al mes"
    },
    "title": "Paquetes",
    "hint": "Cada paquete fija las funcionalidades de una institución y los informes mensuales incluidos (1 informe = 3 iteraciones). Una cuenta sin paquete asignado lo tiene todo gratis.",
    "new": "Nuevo paquete",
    "newTitle": "Nuevo paquete",
    "editTitle": "Editar paquete",
    "edit": "Editar",
    "empty": "Todavía no hay paquetes.",
    "loading": "Cargando paquetes…",
    "loadError": "No se han podido cargar los paquetes. Vuelve a intentarlo.",
    "retry": "Reintentar",
    "key": "Clave",
    "keyHint": "Minúsculas, números, - y _. No se puede cambiar.",
    "name": "Nombre",
    "description": "Descripción",
    "status": "Estado",
    "active": "Activo",
    "inactive": "Inactivo",
    "activeHint": "Un paquete inactivo no se puede asignar a cuentas nuevas; las que ya lo tienen lo conservan.",
    "informes": "Informes/mes",
    "informesHint": "Bolsa de la institución. Caduca al cerrar el mes.",
    "unlimited": "Ilimitado",
    "iteraciones": "Iteraciones por informe",
    "plazo": "Plazo del lote (días)",
    "overage": "Exceso",
    "overageHint": "Cobrar: se factura cada informe extra. Bloquear: al agotar la bolsa se detiene la IA.",
    "price": "Precio por informe extra (€)",
    "cap": "Tope de informes extra",
    "features": "Funcionalidades",
    "requestFeatures": "Peticiones de IA",
    "toggleFeatures": "Activables",
    "imagingWarning": "Sin «Modalidad de imagen» el guardado no clasifica la modalidad y la facturación por modalidad de estas cuentas quedará vacía.",
    "policy": {
      "charge": "Cobrar",
      "block": "Bloquear"
    },
    "created": "Paquete creado.",
    "updated": "Paquete actualizado.",
    "saveError": "No se ha podido guardar el paquete.",
    "cancel": "Cancelar",
    "save": "Guardar",
    "saving": "Guardando…",
    "errors": {
      "key": "Clave no válida: 2-40 caracteres en minúsculas, números, - o _.",
      "name": "El nombre es obligatorio.",
      "informes": "Indica un número entero de informes o marca «Ilimitado».",
      "iteraciones": "Entre 1 y 100.",
      "plazo": "Entre 1 y 365 días.",
      "price": "Precio no válido.",
      "cap": "Número entero no válido."
    },
    "feature": {
      "magic_dictation": "Dictado mágico",
      "magic_writing": "Escritura mágica",
      "direct_generation": "Generación directa",
      "traditional_dictation": "Dictado tradicional",
      "classification": "Clasificación",
      "patient_summary": "Resumen del paciente",
      "presave_check": "Revisión antes de guardar",
      "few_shot": "Ejemplos (few-shot)",
      "snomed": "SNOMED",
      "anatomic_regions": "Regiones anatómicas",
      "imaging_modality": "Modalidad de imagen",
      "faq": "Asistente de dudas",
      "template_import": "Importar plantillas",
      "template_name_variants": "Variantes de nombre de plantilla",
      "batch_dictation": "Dictado por lotes"
    }
  },
  "subscription": {
    "title": "Paquete y facturación",
    "none": "Sin paquete: la cuenta tiene todas las funcionalidades gratis y no se mide su consumo.",
    "future": "Paquete «{{name}}» desde el {{date}}. Hasta entonces, todo gratis.",
    "inForce": "Paquete «{{name}}» en vigor desde el {{date}}. El ciclo empieza cada día {{day}} ({{tz}}).",
    "loadError": "No se ha podido cargar el paquete de la cuenta.",
    "package": "Paquete",
    "choose": "— Elige un paquete —",
    "reportsPerMonth": "informes/mes",
    "startsAt": "Inicio del ciclo de facturación",
    "startsAtHint": "Vacío = ahora. Antes de esta fecha la cuenta sigue con todo gratis.",
    "startsAtInForceHint": "Si no cambias la fecha, el paquete nuevo se aplica desde ahora y se mantiene el d?a de corte.",
    "anchorDay": "Día de corte",
    "anchorDayPlaceholder": "día de inicio",
    "anchorDayHint": "1–31. Vacío = el día del inicio. En meses más cortos se usa el último día.",
    "timezone": "Zona horaria",
    "enforcement": "Modo",
    "enforcementHint": "Observación: se mide pero no se bloquea. Aplicar: se bloquea lo que no está en el paquete.",
    "mode": {
      "shadow": "Observación",
      "enforce": "Aplicar"
    },
    "overrides": "Excepciones de esta cuenta",
    "free": "Gratis (no se factura)",
    "informesOverride": "Informes/mes (vacío = los del paquete)",
    "overageOverride": "Exceso",
    "overageFromPackage": "Exceso: el del paquete",
    "assign": "Asignar paquete",
    "reassign": "Cambiar paquete",
    "remove": "Quitar paquete",
    "removeConfirm": "¿Quitar el paquete? La cuenta pasará a tenerlo todo gratis.",
    "assigned": "Paquete asignado.",
    "removed": "Paquete retirado.",
    "saveError": "No se ha podido asignar el paquete.",
    "errors": {
      "package": "Elige un paquete.",
      "startsAt": "Fecha no válida.",
      "anchorDay": "El día de corte debe estar entre 1 y 31.",
      "timezone": "Indica la zona horaria.",
      "informes": "Número entero no válido."
    }
  },
  "radiologyStyle": {
    "title": "Tu estilo radiológico",
    "description": "Crea una lista con tus preferencias sobre cómo te gusta redactar tus informes. Por ejemplo: «Quiero que todos los hallazgos estén en negrita».",
    "menuLabel": "Tu estilo radiológico",
    "settingsTitle": "Tu estilo radiológico",
    "settingsDescription": "Define cómo te gusta redactar tus informes con una lista de preferencias personales",
    "settingsText": "Crea y edita tu lista de preferencias de estilo. Por ejemplo: «Quiero que todos los hallazgos estén en negrita».",
    "settingsButton": "Editar mi estilo",
    "empty": "Aún no has añadido ninguna preferencia de estilo.",
    "placeholder": "Ej: Quiero que todos los hallazgos estén en negrita",
    "addRule": "Añadir preferencia",
    "removeRule": "Eliminar preferencia",
    "saving": "Guardando…",
    "saved": "Tu estilo radiológico se guardó correctamente",
    "saveError": "No se pudo guardar tu estilo radiológico",
    "limitHint": "Hasta {{maxRules}} preferencias de {{maxLength}} caracteres cada una.",
    "maxRulesReached": "Has llegado al máximo de {{maxRules}} preferencias",
    "ruleTooLong": "Una preferencia supera los {{maxLength}} caracteres: acórtala para guardar"
  },
  "common": {
    "welcome": "Bienvenido",
    "unknownModality": "Modalidad desconocida",
    "unknownRegion": "Región desconocida",
    "professionalTitleDefault": "Dr.",
    "login": "Iniciar sesión",
    "logout": "Cerrar sesión",
    "save": "Guardar",
    "cancel": "Cancelar",
    "delete": "Eliminar",
    "edit": "Editar",
    "view": "Ver",
    "close": "Cerrar",
    "search": "Buscar",
    "loading": "Cargando...",
    "sending": "Enviando...",
    "error": "Error",
    "success": "Éxito",
    "email": "Correo electrónico",
    "password": "Contraseña",
    "submit": "Enviar",
    "back": "Volver",
    "continue": "Continuar",
    "next": "Siguiente",
    "previous": "Anterior",
    "confirm": "Confirmar",
    "yes": "Sí",
    "no": "No",
    "goHome": "Ir al inicio",
    "home": "Inicio",
    "myInsights": "Mis estadísticas",
    "groupReports": "Historial de trabajo",
    "createReport": "Crear informe",
    "templates": "Plantillas",
    "accounts": "Cuentas",
    "users": "Usuarios",
    "issues": "Problemas",
    "adminPanel": "Panel admin",
    "orgAdmin": "Organización",
    "configuration": "Configuración",
    "parameters": "Parámetros",
    "openMenu": "Abrir menú",
    "collapseMenu": "Colapsar menú",
    "expandMenu": "Expandir menú",
    "writeHere": "Escribe aquí...",
    "headingPlaceholder": "Título",
    "selectButtonsToExport": "Seleccionar botones para exportar",
    "exportSelection": "Exportar selección",
    "configureButtons": "Configurar botones para exportar",
    "searchPlaceholder": "Buscar...",
    "clearSelection": "Limpiar selección",
    "noResults": "No se encontraron resultados",
    "commands": "Comandos",
    "insert": "Insertar",
    "update": "Actualizar",
    "generate": "Generar",
    "select": "Seleccionar",
    "dictate": "Dictar",
    "language": "Idioma",
    "showing": "Mostrando",
    "of": "de",
    "or": "o",
    "page": "Página",
    "item": "elemento",
    "items": "elementos",
    "copy": "Copiar",
    "clear": "Limpiar",
    "share": "Compartir",
    "discard": "Descartar",
    "deleting": "Eliminando...",
    "enabled": "Activado",
    "disabled": "Desactivado",
    "send": "Enviar",
    "pause": "Pausar",
    "resume": "Reanudar",
    "showLaterality": "Mostrar lateralidad",
    "hideLaterality": "Ocultar lateralidad",
    "laterality": {
      "left": "Izquierda",
      "right": "Derecha",
      "both": "Bilateral"
    },
    "groups": "Grupos"
  },
  "commandPalette": {
    "searchPlaceholder": "Escribe un comando...",
    "results": "Resultados",
    "searching": "Buscando...",
    "noTemplatesFound": "No se encontraron plantillas",
    "suggestions": "Sugerencias",
    "createTemplate": "Crear plantilla",
    "startDictation": "Iniciar dictado",
    "generateReport": "Generar informe",
    "recentTemplates": "Plantillas recientes",
    "errorLoadingTemplates": "Error al cargar plantillas",
    "errorSearching": "Error al buscar plantillas",
    "mustUseWithinProvider": "useCommandPalette debe usarse dentro de CommandPaletteProvider"
  },
  "auth": {
    "welcomeHello": "Hola,",
    "welcomeBack": "Bienvenido",
    "launchSignInNeeded": "Tu estudio está esperando. Inicia sesión para continuar.",
    "launchIdentityRefused": "No se ha podido abrir la sesión automáticamente: tu usuario no está autorizado en la instalación desde la que se ha lanzado el estudio. Pide a tu administrador que te añada. Mientras tanto, puedes iniciar sesión aquí.",
    "emailLabel": "Correo electrónico",
    "passwordLabel": "Contraseña",
    "loginTitle": "Iniciar sesión en Ainovis",
    "loginSubtitle": "Ingresa tus credenciales para acceder",
    "forgotPassword": "¿Olvidaste tu contraseña?",
    "rememberMe": "Recordarme",
    "noAccount": "¿No tienes cuenta?",
    "signUp": "Registrarse",
    "alreadyHaveAccount": "¿Ya tienes cuenta?",
    "signIn": "Iniciar sesión",
    "verifyEmail": "Verificar correo electrónico",
    "verifyEmailText": "Hemos enviado un correo de verificación a tu dirección de email",
    "resetPassword": "Restablecer contraseña",
    "resetPasswordText": "Ingresa tu nueva contraseña",
    "newPassword": "Nueva contraseña",
    "confirmPassword": "Confirmar contraseña",
    "sendResetLink": "Enviar enlace de restablecimiento",
    "backToLogin": "Volver al inicio de sesión",
    "googleLogin": "Continuar con Google",
    "microsoftLogin": "Continuar con Microsoft",
    "orLoginWith": "O iniciar sesión con",
    "authenticatingMicrosoft": "Autenticando con Microsoft...",
    "processingAuth": "Procesando autenticación...",
    "resetPasswordTitle": "Restablecer contraseña",
    "resetPasswordDescription": "Introduce tu nueva contraseña",
    "resetting": "Restableciendo...",
    "resetPasswordButton": "Restablecer contraseña",
    "invalidToken": "Token inválido o expirado",
    "completeAllFields": "Por favor, completa todos los campos",
    "passwordsDoNotMatch": "Las contraseñas no coinciden",
    "passwordMinLength": "La contraseña debe tener al menos 6 caracteres",
    "passwordResetSuccess": "Contraseña restablecida exitosamente",
    "enterButton": "Entrar",
    "emailPlaceholder": "Email",
    "passwordPlaceholder": "Contraseña",
    "completeCaptcha": "Por favor, completa el captcha",
    "continueWith": "o iniciar sesión con",
    "continueWithMicrosoft": "Continuar con Microsoft",
    "forgotPasswordTitle": "¿Olvidaste tu contraseña?",
    "forgotPasswordDescription": "No te preocupes, te enviaremos instrucciones para restablecerla",
    "sendInstructions": "Enviar instrucciones",
    "emailSentTitle": "Correo enviado",
    "emailSentMessage": "Hemos enviado un correo a {{email}} con las instrucciones para restablecer tu contraseña",
    "checkSpam": "Si no recibes el correo en unos minutos, revisa tu carpeta de spam"
  },
  "notFound": {
    "title": "404",
    "subtitle": "Página no encontrada",
    "message": "Lo sentimos, la página que estás buscando no existe o ha sido movida"
  },
  "dashboard": {
    "title": "Panel de Control",
    "reports": "Informes",
    "recentReports": "Tus informes diagnósticos",
    "createReport": "Crear informe",
    "viewAll": "Ver todos",
    "statistics": "Estadísticas",
    "totalReports": "Total de informes",
    "pendingReports": "Informes pendientes",
    "completedReports": "Informes completados"
  },
  "reports": {
    "deselectAll": "Deseleccionar todos",
    "allSelected": "Todos seleccionados ({{count}})",
    "tapToSelectAll": "Seleccionar todos",
    "selectedCountHint": "· {{count}} seleccionados",
    "selectedCountHint_one": "· {{count}} seleccionado",
    "selectedCountHint_other": "· {{count}} seleccionados",
    "signReport": "Firmar",
    "signedBy": "Firmado por:",
    "licenseNumber": "Nº colegiado",
    "sendBusy": "Espera a que termine el proceso en curso",
    "requestEdit": "Solicitar permiso de edición",
    "requestEditSent": "Solicitud enviada",
    "requestEditError": "No se pudo enviar la solicitud. Inténtalo de nuevo.",
    "editRequestToast": "{{name}} solicita permiso de edición.",
    "editRequestManage": "Gestionar",
    "editRequestSomeone": "Un usuario",
    "title": "Informes",
    "newReport": "Nuevo informe",
    "reportList": "Lista de informes",
    "reportDetails": "Detalles del informe",
    "status": "Estado",
    "createdAt": "Creado el",
    "updatedAt": "Actualizado el",
    "createdBy": "Creado por",
    "draft": "Borrador",
    "published": "Publicado",
    "archived": "Archivado",
    "noReports": "No hay informes disponibles",
    "savedVersionLabel": "Versión {{n}}", "savedVersionCorrected": "Corregido", "savedVersionAddendum": "Con adenda", "savedVersionSelector": "Versión",
    "editSentReport": "Corregir informe", "revisionBanner": "Corrigiendo informe enviado v{{n}}", "pacsRevisionBanner": "Corrigiendo el informe del PACS", "pacsAddendumBanner": "Adenda al informe del PACS", "correctionBadge": "Corrección {{date}}", "revisionOpenError": "No se pudo abrir la corrección del informe", "revisionPolicyDenied": "Tu cuenta no permite corregir informes enviados.", "revisionVersionConflict": "Este informe ya tiene una versión más reciente. Recarga la lista.", "revisionNoChanges": "No hay cambios respecto al informe enviado.", "revisionAccessDenied": "Solo el autor puede corregir este informe.", "revisionNotFound": "El informe ya no existe.",
    "addAddendum": "Añadir adenda", "addendumBadge": "Adenda {{date}}",
    "savedVersionMarked": "Cambios marcados", "pacsReportUnavailable": "No se pudo traer el informe del PACS. El informe no se ha enviado: inténtalo de nuevo.", "pacsRevisionInProgress": "Otra persona ya está revisando el informe de este estudio.", "revisionKindConflict": "Ya tienes un borrador abierto de este informe con otro tipo de revisión. Envíalo o descártalo en Borradores.", "revisionUnmarkedDeletion": "Hay texto del informe original borrado sin marcar como tachado.", "editMarkedReport": "Editar con cambios marcados", "markedBanner": "Cambios marcados sobre el informe enviado v{{n}}: lo que borres quedará tachado", "markedRestore": "Restaurar",
    "deleteConfirm": "¿Estás seguro de que deseas eliminar este informe?",
    "studyDescription": "Descripción del estudio",
    "studyDescriptionPlaceholder": "Escriba la descripción del estudio",
    "reasonForRequestedProcedure": "Motivo de petición",
    "reportGeneration": "Generación",
    "automatic": "Automática",
    "manual": "Manual",
    "automaticTooltip": "Genera el informe automáticamente",
    "manualTooltip": "Genera el informe a partir de la plantilla seleccionada",
    "reportFormat": "Tipo de informe",
    "inside": "Inside",
    "first": "First",
    "insideTooltip": "Se repartirán uniformemente los hallazgos dentro del apartado 'Hallazgos'",
    "firstTooltip": "Se dispondrán los hallazgos al principio del apartado 'Hallazgos'",
    "selectedTemplate": "Plantilla seleccionada",
    "templateList": "Lista de Plantillas",
    "auto": "Auto",
    "automatic2": "Automática",
    "enterDescription": "Por favor, ingrese una descripción del estudio",
    "reportCopied": "Informe copiado correctamente",
    "reportGenerated": "Informe generado correctamente",
    "reportSaved": "Informe guardado correctamente",
    "noReportToSave": "No hay ningún informe generado para guardar",
    "missingReportInfo": "Falta información del reporte",
    "timeoutError": "La generación tardó demasiado. Intenta con una descripción más corta",
    "generateButton": "Generar informe",
    "generating": "Generando...",
    "thinking": "Pensando...",
    "saveButton": "Guardar informe",
    "saving": "Guardando...",
    "generatingMessage": "Generando informe...",
    "savingMessage": "Guardando informe...",
    "editorPlaceholder": "El informe generado aparecerá aquí",
    "activateDictation": "Activar dictado por voz",
    "holdMicSendHint": "Suelta para enviar · Esc para cancelar",
    "holdMicCancelHint": "Suelta para cancelar",
    "keepAllContent": "Mantener todo el contenido marcado",
    "keepContentDesc": "Mantener el contenido marcado (fusionar sin eliminar)",
    "deleteAllContent": "Eliminar todo el contenido marcado",
    "keepOriginal": "Mantener texto original",
    "keepOriginalDesc": "Mantener el texto original (descartar cambios)",
    "applyUpdates": "Aplicar todas las actualizaciones",
    "generateReport": "Generar informe",
    "basedOnRecentActivity": "Basado en su actividad reciente",
    "aiDisclaimer": "Ainovis puede cometer errores. Considera verificar información importante",
    "reportContent": "Parámetros del informe",
    "continueWithBaseTemplate": "Continuar con plantilla base",
    "blocksDetected": "Bloques detectados",
    "selectBlockHint": "Selecciona un bloque o continúa con la plantilla base",
    "continueWithNormalTemplate": "Continuar sin bloques",
    "referenceSelected": "Referencia seleccionada ✓",
    "blockSelected": "Bloque seleccionado ✓",
    "blockSkipped": "Continuando sin bloque ✓",
    "description": "Descriptivo",
    "detectedProcedures": "Procedimientos detectados",
    "noProceduresDetected": "No se han detectado procedimientos",
    "detectedLaterality": "Lateralidad detectada",
    "noLateralityFound": "No se ha encontrado lateralidad",
    "searchLaterality": "Alinear lateralidad",
    "lateralityUpdated": "Lateralidad actualizada",
    "errorSearchingLaterality": "Error al detectar lateralidad",
    "findingsFirst": "Hallazgos al inicio",
    "findingsInside": "Hallazgos dentro del texto",
    "welcome": "Bienvenido {{title}} {{surname}}",
    "searchTemplate": "Buscar plantilla...",
    "loadingTemplate": "Cargando plantilla...",
    "multipleReferencesDetected": "Múltiples referencias detectadas",
    "selectReferenceHint": "Selecciona una opción para continuar con la generación",
    "generateManualReport": "Generar informe manual",
    "blankCanvas": "Lienzo en blanco",
    "createTemplate": "Crear plantilla",
    "viewPowerBI": "Ver Estadísticas",
    "uploadAudio": "Procesar audio en lotes",
    "noTemplatesFound": "No se encontraron plantillas",
    "errorCreatingBlankCanvas": "Error al crear lienzo en blanco",
    "manualModePlaceholder": "Escribe la plantilla que quieres usar",
    "navigate": "navegar",
    "select": "seleccionar",
    "close": "cerrar",
    "loadingTemplates": "Cargando plantillas...",
    "searchPlaceholder": "Buscar informe...",
    "reportsHistorySidebarTitle": "Historial de reportes",
    "reportsHistorySidebarTitleSaved": "Reportes enviados",
    "reportsHistoryPreviewStamp": "Reporte enviado",
    "versionHistoryPreviewStamp": "Versión previa",
    "reportsHistorySidebarClose": "Cerrar panel de historial",
    "reportsHistoryLoading": "Cargando…",
    "reportsHistoryError": "No se pudo cargar el historial",
    "reportsHistoryNoResults": "Sin resultados",
    "reportsHistoryDraftsEmpty": "No tienes borradores",
    "reportsHistorySavedEmpty": "No tienes reportes enviados",
    "reportsHistoryUntitled": "Sin título",
    "reportsHistoryTabDrafts": "Borradores",
    "reportsHistoryTabSaved": "Enviados",
    "createReport": "Crear informe",
    "currentStatus": "Estado actual",
    "pendingReview": "Informes pendientes de revisión",
    "savedToday": "Informes guardados hoy",
    "draftReports": "Informes en borrador",
    "recentReports": "Tus informes",
    "drafts": "Borradores",
    "saved": "Enviados",
    "sharedWithMe": "Compartidos conmigo",
    "ownedByMe": "Soy el propietario",
    "noOwnedDrafts": "No hay borradores de los que seas propietario",
    "countOwned": "{{count}} propios",
    "diagnosis": "Conclusión",
    "versions": "Versiones",
    "version": "versión",
    "lastUpdate": "Última actualización",
    "actions": "Acciones",
    "noDrafts": "No hay borradores",
    "noSharedDrafts": "No hay informes compartidos contigo",
    "noDiagnosis": "(Sin diagnóstico)",
    "loadingVersions": "Cargando versiones...",
    "owner": "Propietario",
    "modalities": "Modalidades",
    "procedure": "Procedimiento",
    "procedures": "Procedimientos",
    "time": "Hora",
    "draftVersionsInfo": "Este borrador tiene {{count}} versión(es) guardada(s)",
    "report": "informe",
    "reports": "informes",
    "yourPerformance": "Tu rendimiento",
    "last7Days": "Últimos 7 días",
    "thisWeek": "Esta semana",
    "thisMonth": "Este mes",
    "today": "Hoy",
    "yesterday": "Ayer",
    "last30Days": "Últimos 30 días",
    "older": "Anteriores",
    "totalReports": "Total",
    "deleteDraftTitle": "Eliminar borrador",
    "leaveDraft": "Abandonar borrador",
    "leaveDraftTitle": "Abandonar borrador",
    "leaveDraftConfirm": "Abandonar",
    "leaveDraftMessage": "Dejarás de tener acceso a este borrador compartido. El propietario podrá volver a compartirlo contigo.",
    "deleteReportTitle": "Eliminar informe",
    "deleteDraftMessage": "¿Está seguro de que desea eliminar este borrador y todas sus versiones? Esta acción no se puede deshacer.",
    "deleteReportMessage": "¿Está seguro de que desea eliminar este informe guardado? Esta acción no se puede deshacer.",
    "deleteBatchTitle": "Eliminar lote",
    "deleteBatchMessage": "¿Está seguro de que desea eliminar este lote y todos sus estudios? Esta acción no se puede deshacer.",
    "errorLoadingReport": "Error al cargar el informe",
    "noContentToCopy": "No hay contenido para copiar",
    "contentCopied": "Contenido copiado al portapapeles",
    "errorCopying": "Error al copiar el contenido",
    "errorPreSaveValidation": "Error al validar antes de guardar",
    "preSaveInconsistencies": "Inconsistencias detectadas",
    "preSaveVersions": "Múltiples versiones",
    "preSaveVersionsMsg": "Se guardará únicamente la versión actual y se descartarán las {{count}} restantes.",
    "errorSavingReport": "Error al guardar el informe",
    "errorSavingDraft": "Error al guardar el borrador",
    "draftDeleted": "Borrador eliminado correctamente",
    "errorDeletingDraft": "Error al eliminar el borrador",
    "emptyTechnique": "La técnica está vacía",
    "proceduresFound": "Procedimientos actualizados",
    "errorSearchingProcedures": "Error al buscar procedimientos",
    "blankVersionCreated": "Lienzo en blanco creado",
    "errorCreatingBlankVersion": "Error al crear lienzo en blanco",
    "loadingReport": "Cargando informe...",
    "deletingMessage": "Eliminando borrador...",
    "searchingProcedures": "Buscando procedimientos...",
    "searchingLaterality": "Detectando lateralidad...",
    "hideProcedures": "Ocultar procedimientos",
    "searchProcedures": "Buscar procedimientos",
    "showProcedures": "Mostrar procedimientos",
    "confirmDeleteDraft": "¿Estás seguro de que deseas eliminar este borrador? Esta acción no se puede deshacer.",
    "inconsistency": "Inconsistencia",
    "show": "Mostrar",
    "preSaveTitle": "Antes de guardar",
    "preSaveSubtitle": "Se han detectado las siguientes advertencias:",
    "confirmSave": "Enviar igualmente",
    "unsavedChanges": "Cambios sin guardar",
    "unsavedChangesMessage": "\"{{title}}\" tiene cambios sin guardar. ¿Descartar cambios?",
    "maxVersionsReached": "Máximo de informes alcanzado",
    "settings": "Configuración",
    "reportType": "Tipo de informe",
    "noTemplateSelected": "Detección automática",
    "useAnotherTemplate": "Usar otra plantilla",
    "change": "Cambiar",
    "changeTemplate": "Cambiar plantilla",
    "backToAutoDetection": "Volver a detección automática",
    "autoDetection": "Detección automática",
    "noDescription": "Sin descripción",
    "resume": "Reanudar",
    "pause": "Pausar",
    "process": "Procesar",
    "processingAudio": "Procesando audio...",
    "analyzingVoice": "Analizando tu voz...",
    "transcribingAudio": "Transcribiendo audio...",
    "interpretingCommands": "Interpretando comandos...",
    "preparingResult": "Preparando resultado...",
    "analyzingText": "Analizando tu texto...",
    "understandingIntent": "Entendiendo la intención...",
    "readingContext": "Leyendo el contexto...",
    "identifyingSections": "Identificando secciones...",
    "writing": "Escribiendo...",
    "fillingReport": "Rellenando el informe...",
    "writingSections": "Redactando secciones...",
    "addingFindings": "Añadiendo hallazgos...",
    "refiningContent": "Puliendo el contenido...",
    "applyingClassifications": "Aplicando clasificaciones...",
    "evaluatingCriteria": "Evaluando criterios...",
    "calculatingResults": "Calculando resultados...",
    "finalizingReport": "Finalizando...",
    "aiAssistantPlaceholder": "Escribe un texto o dicta con el micrófono...",
    "sendToDescriptive": "Al descriptivo",
    "aiChatEmpty": "Envía un mensaje para comenzar la conversación",
    "carolinaAssistance": "Carolina Assistance",
    "send": "Enviar",
    "record": "Grabar",
    "generate": "Generar",
    "selectReference": "Selecciona una de las referencias para continuar",
    "errorGenerating": "Error al generar el informe",
    "noTemplateDetected": "No se detectó plantilla",
    "reportGeneratedWithReference": "Informe generado con la referencia seleccionada",
    "versionCreated": "Nueva versión creada correctamente",
    "errorCreatingVersion": "Error al crear la versión",
    "emptyRecording": "La grabación está vacía",
    "invalidServerResponse": "Error: respuesta del servidor inválida",
    "noAudioDetected": "No se detectó audio",
    "commandExecuted": "Comando ejecutado correctamente",
    "audioTranscribed": "Audio transcrito correctamente",
    "audioProcessingError": "Error al procesar el audio",
    "microphoneAccessError": "No se pudo acceder al micrófono",
    "descriptionRequired": "Debes escribir una descripción",
    "errorLoadingTemplates": "No se pudieron cargar las plantillas",
    "patient": "Paciente",
    "patientId": "ID Paciente",
    "patientIdPlaceholder": "ID...",
    "patientAge": "Edad",
    "patientAgePlaceholder": "Años",
    "patientSex": "Sexo",
    "patientSexPlaceholder": "Seleccionar...",
    "sexMale": "Masculino",
    "sexFemale": "Femenino",
    "studyDate": "Fecha estudio",
    "requestReason": "Motivo de petición",
    "patientNamePlaceholder": "Apellidos, Nombre",
    "requestReasonPlaceholder": "Descripción del motivo...",
    "cancel": "Cancelar",
    "cancelEditing": "Cancelar edición",
    "patientNameRequired": "El nombre del paciente es obligatorio",
    "confirmHint": "Enter para confirmar · Esc para cancelar",
    "editPatient": "Editar paciente",
    "deletePatient": "Borrar paciente",
    "contractReason": "Contraer motivo",
    "expandReason": "Expandir motivo",
    "years": "Años",
    "modality": "Modalidad",
    "accessionNumber": "Nº Acceso",
    "referringPhysician": "Médico solicitante",
    "previousStudiesTitle": "Estudios Previos",
    "previousStudiesHint": "Consulta y compara con estudios anteriores del paciente",
    "allProcedures": "Todos los procedimientos",
    "study": "estudio",
    "studiesCount": "estudios",
    "studyPlural": "estudios",
    "batches": "Lotes",
    "batchStudies": "Estudios",
    "noBatches": "No hay lotes pendientes",
    "continueBatch": "Continuar",
    "noStudiesFound": "No se encontraron estudios previos",
    "studyStatus_completed": "Completado",
    "studyStatus_pending": "Pendiente",
    "studyStatus_cancelled": "Cancelado",
    "loadPrevStudies": "Cargar estudios previos",
    "reportClinicalInfo": "Información clínica",
    "reportTechnique": "Técnica",
    "reportFindings": "Hallazgos",
    "reportConclusion": "Conclusión",
    "conclusionType": "Conclusión",
    "conclusionBrief": "Conclusión breve",
    "conclusionNormal": "Conclusión normal",
    "conclusionExtensive": "Conclusión extensa",
    "conclusionBriefShort": "Resumida",
    "conclusionNormalShort": "Normal",
    "conclusionExtensiveShort": "Extensa",
    "speedMode": "Modo de velocidad",
    "fast": "Rápido",
    "accurate": "Preciso",
    "fastModeDesc": "Generación rápida",
    "accurateModeDesc": "Mayor precisión",
    "loadTemplate": "Cargar informe sin cambios",
    "templateNotes": "¿Quieres modificar algo al generar el nuevo informe?",
    "templateNotesPlaceholder": "Ej: Cambiar hallazgos en hígado, añadir nódulo pulmonar de 8mm…",
    "needDescriptive": "Escribe algo en el campo de texto para poder generar",
    "useAsTemplate": "Generar usando esto como plantilla",
    "noReportContent": "No hay contenido de informe disponible",
    "searchStudies": "Buscar por procedimiento o fecha…",
    "previousStudy": "Estudio previo",
    "makeChanges": "Realizar cambios",
    "makeChangesPlaceholder": "Describe los cambios que deseas realizar en el informe comparativo…",
    "classificationSectionsEmpty": "Las secciones de técnica, hallazgos y conclusión deben estar completas para clasificar",
    "classificationSuccess": "Clasificación realizada correctamente",
    "classificationError": "Error al realizar la clasificación",
    "editorNotReady": "El editor no está listo",
    "classificationUnchanged": "El contenido del reporte no ha cambiado desde la última clasificación.",
    "classificationNoFindings": "No se han localizado hallazgos compatibles para esta clasificación",
    "classificationInResearch": "Esta funcionalidad está en fase de investigación. Si desea utilizarla, solicítela a su administrador.",
    "classifications": "Clasificaciones",
    "classificationsTitle": "Clasificaciones",
    "fleischnerClassification": "Clasificación de Fleischner",
    "fleischnerDesc": "Nódulos pulmonares incidentales — Fleischner 2017",
    "analyzing": "Analizando…",
    "classify": "Clasificar",
    "results": "Resultados",
    "table": "Tabla",
    "fleischnerCriteria": "Criterios de Fleischner",
    "fleischner_toggleHighlight": "Mostrar/ocultar resaltado",
    "fleischnerDescription": "Guías de seguimiento para nódulos pulmonares incidentales detectados por TC, según tamaño, número y tipo de nódulo.",
    "singleSolidNodule": "Nódulo sólido único",
    "multipleSolidNodules": "Múltiples nódulos sólidos",
    "subsolidNodules": "Nódulos subsólidos",
    "pureGroundGlass": "Vidrio deslustrado puro",
    "partSolidNodule": "Nódulo parcialmente sólido",
    "size": "Tamaño",
    "lowRisk": "Bajo riesgo",
    "highRisk": "Alto riesgo",
    "followUp": "Seguimiento",
    "noFollowUp": "No seguimiento",
    "partSolidNote": "Si la parte sólida ≥ 6 mm, considerar PET-TC o resección.",
    "reference": "Referencia: MacMahon H et al.",
    "singleLt6LowRisk": "No seguimiento",
    "singleLt6HighRisk": "TC a 12 meses (opcional)",
    "single6to8LowRisk": "TC a 6–12 meses → considerar a 18–24 meses",
    "single6to8HighRisk": "TC a 6–12 meses → repetir a 18–24 meses",
    "singleGt8LowRisk": "Considerar TC a 3 meses, PET-TC o biopsia",
    "singleGt8HighRisk": "Igual que bajo riesgo",
    "multipleLt6LowRisk": "No seguimiento",
    "multipleLt6HighRisk": "TC a 12 meses",
    "multipleGte6LowRisk": "TC a 3–6 meses → considerar a 18–24 meses",
    "multipleGte6HighRisk": "TC a 3–6 meses → repetir a 18–24 meses",
    "ggLt6": "No seguimiento",
    "ggGte6": "TC a 6–12 meses → luego cada 2 años hasta 5 años",
    "psLt6": "No seguimiento",
    "psGte6": "TC a 3–6 meses → si persiste, control anual hasta 5 años",
    "conclusionNoFollowUp": "No requiere seguimiento según criterios de Fleischner 2017.",
    "conclusionOptionalCT12": "Se recomienda control opcional con TC a los 12 meses según criterios de Fleischner 2017.",
    "conclusionCT6to12Consider18to24": "Se recomienda control con TC a los 6-12 meses, considerando seguimiento adicional a los 18-24 meses según criterios de Fleischner 2017.",
    "conclusionCT6to12Repeat18to24": "Se recomienda control con TC a los 6-12 meses, con seguimiento adicional a los 18-24 meses según criterios de Fleischner 2017.",
    "conclusionConsiderCT3PetBiopsy": "Se recomienda considerar TC a los 3 meses, PET-TC o biopsia según criterios de Fleischner 2017.",
    "conclusionCT12": "Se recomienda control con TC a los 12 meses según criterios de Fleischner 2017.",
    "conclusionCT3to6Consider18to24": "Se recomienda control con TC a los 3-6 meses, considerando seguimiento adicional a los 18-24 meses según criterios de Fleischner 2017.",
    "conclusionCT3to6Repeat18to24": "Se recomienda control con TC a los 3-6 meses, con seguimiento adicional a los 18-24 meses según criterios de Fleischner 2017.",
    "conclusionCT6to12Every2y5y": "Se recomienda control con TC a los 6-12 meses, seguido de controles cada 2 años hasta completar 5 años según criterios de Fleischner 2017.",
    "conclusionCT3to6Annual5y": "Se recomienda control con TC a los 3-6 meses y, si persiste, seguimiento anual durante 5 años según criterios de Fleischner 2017.",
    "tirads_classification": "Clasificación TI-RADS",
    "tirads_desc": "Nódulos tiroideos — ACR TI-RADS 2017",
    "tirads_criteria": "Criterios ACR TI-RADS",
    "tirads_description": "Sistema de puntuación para nódulos tiroideos detectados por ecografía, basado en composición, ecogenicidad, forma, márgenes y focos ecogénicos.",
    "tirads_composition": "Composición",
    "tirads_echogenicity": "Ecogenicidad",
    "tirads_shape": "Forma",
    "tirads_margin": "Márgenes",
    "tirads_echogenicFoci": "Focos ecogénicos",
    "tirads_feature": "Característica",
    "tirads_points": "Puntos",
    "tirads_compositionCystic": "Quístico o casi completamente quístico",
    "tirads_compositionSpongiform": "Espongiforme",
    "tirads_compositionMixed": "Mixto quístico y sólido",
    "tirads_compositionSolid": "Sólido o casi completamente sólido",
    "tirads_echogenicityAnechoic": "Anecoico",
    "tirads_echogenicityHyperIso": "Hiperecogénico o isoecoico",
    "tirads_echogenicityHypo": "Hipoecoico",
    "tirads_echogenicityVeryHypo": "Muy hipoecoico",
    "tirads_shapeWider": "Más ancho que alto",
    "tirads_shapeTaller": "Más alto que ancho",
    "tirads_marginSmooth": "Liso",
    "tirads_marginIllDefined": "Mal definido",
    "tirads_marginLobulated": "Lobulado o irregular",
    "tirads_marginExtrathyroidal": "Extensión extratiroidea",
    "tirads_fociNone": "Ninguno o artefactos de cola de cometa grandes",
    "tirads_fociMacro": "Macrocalcificaciones",
    "tirads_fociPeripheral": "Calcificaciones periféricas (en anillo)",
    "tirads_fociPunctate": "Focos ecogénicos puntiformes",
    "tirads_categoriesTitle": "Categorías y recomendaciones",
    "tirads_categoryCol": "Categoría",
    "tirads_fnaThreshold": "PAAF si",
    "tirads_followUpThreshold": "Seguimiento si",
    "tirads_tr1_name": "TR1 — Benigno",
    "tirads_tr2_name": "TR2 — No sospechoso",
    "tirads_tr3_name": "TR3 — Levemente sospechoso",
    "tirads_tr4_name": "TR4 — Moderadamente sospechoso",
    "tirads_tr5_name": "TR5 — Altamente sospechoso",
    "tirads_scoringNote": "Sumar los puntos de cada categoría (el valor más alto de cada una). Solo se aplica a nódulos ≥ 1 cm o con características sospechosas.",
    "tirads_reference": "Referencia: Tessler FN et al.",
    "tirads_conclusionTR1": "Nódulo tiroideo clasificado como TI-RADS 1 (benigno). No requiere PAAF ni seguimiento según ACR TI-RADS 2017.",
    "tirads_conclusionTR2": "Nódulo tiroideo clasificado como TI-RADS 2 (no sospechoso). No requiere PAAF ni seguimiento según ACR TI-RADS 2017.",
    "tirads_conclusionTR3": "Nódulo tiroideo clasificado como TI-RADS 3 (levemente sospechoso). Se recomienda PAAF si ≥ 2.5 cm o seguimiento si ≥ 1.5 cm según ACR TI-RADS 2017.",
    "tirads_conclusionTR4": "Nódulo tiroideo clasificado como TI-RADS 4 (moderadamente sospechoso). Se recomienda PAAF si ≥ 1.5 cm o seguimiento si ≥ 1 cm según ACR TI-RADS 2017.",
    "tirads_conclusionTR5": "Nódulo tiroideo clasificado como TI-RADS 5 (altamente sospechoso). Se recomienda PAAF si ≥ 1 cm o seguimiento si ≥ 0.5 cm según ACR TI-RADS 2017.",
    "tirads_chooseOne": "Elegir 1",
    "tirads_chooseAll": "Todos los que apliquen",
    "tirads_sumPoints": "Sumar puntos de todas las categorías",
    "tirads_selectOptions": "Selecciona opciones",
    "tirads_recommendationCol": "Recomendación",
    "tirads_noFnaNoFollowUp": "No PAAF · No seguimiento",
    "tirads_tr1_label": "Benigno",
    "tirads_tr2_label": "No sospechoso",
    "tirads_tr3_label": "Levemente sospechoso",
    "tirads_tr4_label": "Moderadamente sospechoso",
    "tirads_tr5_label": "Altamente sospechoso",
    "pirads_classification": "Clasificación PI-RADS",
    "pirads_desc": "Lesiones prostáticas — PI-RADS v2.1",
    "pirads_title": "PI-RADS v2.1 — Clasificación por Zonas",
    "pirads_description": "Sistema de puntuación para la detección de cáncer de próstata clínicamente significativo mediante RM multiparamétrica. Basado en la guía del Radiology Assistant.",
    "pirads_dominant": "Dominante",
    "pirads_secondary": "Secundario",
    "pirads_probabilityCol": "Probabilidad",
    "pirads_refinedV21": "Refinado v2.1",
    "pirads_tabPZ": "Zona Periférica (PZ)",
    "pirads_tabTZ": "Zona Transicional (TZ)",
    "pirads_tabDCE": "DCE y Ajustes",
    "pirads_tabInfo": "Protocolo y TNM",
    "pirads_zonePZ": "Zona Periférica",
    "pirads_zoneTZ": "Zona Transicional",
    "pirads_pr1_legend": "PI-RADS 1 — Muy bajo",
    "pirads_pr2_legend": "PI-RADS 2 — Bajo",
    "pirads_pr3_legend": "PI-RADS 3 — Equívoco",
    "pirads_pr4_legend": "PI-RADS 4 — Alto",
    "pirads_pr5_legend": "PI-RADS 5 — Muy alto",
    "pirads_pr1_label": "Muy bajo",
    "pirads_pr2_label": "Bajo",
    "pirads_pr3_label": "Equívoco",
    "pirads_pr4_label": "Alto",
    "pirads_pr5_label": "Muy alto",
    "pirads_pr1_prob_short": "< 3%",
    "pirads_pr2_prob_short": "~5%",
    "pirads_pr3_prob_short": "~12-18%",
    "pirads_pr4_prob_short": "~25-40%",
    "pirads_pr5_prob_short": "~60-90%",
    "pirads_pz1_dwi": "Sin anomalía visible en ADC ni en DWI de alto valor b.",
    "pirads_pz1_t2w": "Señal hiperintensa homogénea normal.",
    "pirads_pz1_prob": "Muy baja (< 3%)",
    "pirads_pz2_dwi": "Hipointensidad en ADC y/o hiperintensidad en DWI con configuración lineal o en cuña.",
    "pirads_pz2_t2w": "Hipointensidad difusa o en cuña.",
    "pirads_pz2_prob": "Baja (~5%)",
    "pirads_pz3_dwi": "Hipointensidad focal en ADC y/o hiperintensidad focal en DWI. Puede ser marcada en uno pero no en ambos simultáneamente.",
    "pirads_pz3_t2w": "Hipointensidad focal heterogénea, no marcada.",
    "pirads_pz3_prob": "Intermedia (~12-18%)",
    "pirads_pz3_dce_adjust": "Sube a PI-RADS 4 si existe realce focal precoz. Si DCE (−), permanece en 3.",
    "pirads_pz4_dwi": "Hipointensidad marcada focal en ADC y hiperintensidad marcada en DWI.",
    "pirads_pz4_t2w": "Hipointensidad focal marcada.",
    "pirads_pz4_prob": "Alta (~25-40%)",
    "pirads_pz5_dwi": "Igual que score 4 pero ≥ 1.5 cm o extensión extraprostática (EPE) / comportamiento invasivo definitivo.",
    "pirads_pz5_t2w": "Hipointensidad marcada focal con posible invasión.",
    "pirads_pz5_prob": "Muy alta (~60-90%)",
    "pirads_tz1_t2w": "ZT de apariencia normal o nódulo redondeado completamente encapsulado (\"nódulo típico\").",
    "pirads_tz1_dwi": "Normal.",
    "pirads_tz1_prob": "Muy baja (< 2%)",
    "pirads_tz2_t2w": "Nódulo mayormente encapsulado, o nódulo homogéneo circunscrito sin cápsula (\"nódulo atípico\"), o área homogénea levemente hipointensa entre nódulos.",
    "pirads_tz2_dwi": "DWI ≤ 3: no altera score.",
    "pirads_tz2_prob": "Baja (~5%)",
    "pirads_tz2_dwi_adjust": "Sube a PI-RADS 3. Si DWI ≤ 3, permanece en 2.",
    "pirads_tz3_t2w": "Señal heterogénea con márgenes oscurecidos. Incluye hallazgos que no cualifican para categorías 2, 4 o 5.",
    "pirads_tz3_dwi": "DWI < 5: no altera score.",
    "pirads_tz3_prob": "Intermedia (~10-15%)",
    "pirads_tz3_dwi_adjust": "Sube a PI-RADS 4. Si DWI ≤ 4, permanece en 3.",
    "pirads_tz4_t2w": "Lesión lenticular o no circunscrita, homogénea, moderadamente hipointensa.",
    "pirads_tz4_dwi": "Restricción difusión moderada-marcada.",
    "pirads_tz4_prob": "Alta (~25-40%)",
    "pirads_tz5_t2w": "Igual que score 4 pero ≥ 1.5 cm o extensión extraprostática / comportamiento invasivo definitivo.",
    "pirads_tz5_dwi": "Restricción marcada de difusión.",
    "pirads_tz5_prob": "Muy alta (~60-90%)",
    "pirads_dcePositive": "DCE Positivo (+)",
    "pirads_dcePositiveDesc": "Realce focal, precoz o contemporáneo con el realce del tejido prostático normal adyacente, y que corresponda a un hallazgo sospechoso en T2W y/o DWI.",
    "pirads_dceNegative": "DCE Negativo (−)",
    "pirads_dceNeg1": "Ausencia de realce precoz.",
    "pirads_dceNeg2": "Realce difuso, no correspondiente a la lesión focal en T2W/DWI.",
    "pirads_dceNeg3": "Realce focal que corresponde a un nódulo de HBP.",
    "pirads_zoneCol": "Zona",
    "pirads_baseScoreCol": "Score Base",
    "pirads_conditionCol": "Condición",
    "pirads_finalScoreCol": "Score Final",
    "pirads_dce_pz_3_pos_base": "DWI/ADC = 3",
    "pirads_dce_pz_3_pos_cond": "DCE (+) → Realce focal precoz",
    "pirads_dce_pz_3_pos_final": "↑ PI-RADS 4",
    "pirads_dce_pz_3_neg_base": "DWI/ADC = 3",
    "pirads_dce_pz_3_neg_cond": "DCE (−) → Sin realce focal",
    "pirads_dce_pz_3_neg_final": "PI-RADS 3",
    "pirads_dce_tz_2_up_base": "T2W = 2",
    "pirads_dce_tz_2_up_cond": "DWI ≥ 4",
    "pirads_dce_tz_2_up_final": "↑ PI-RADS 3",
    "pirads_dce_tz_2_stay_base": "T2W = 2",
    "pirads_dce_tz_2_stay_cond": "DWI ≤ 3",
    "pirads_dce_tz_2_stay_final": "PI-RADS 2",
    "pirads_dce_tz_3_up_base": "T2W = 3",
    "pirads_dce_tz_3_up_cond": "DWI = 5 (marcadamente intenso ≥ 1.5 cm)",
    "pirads_dce_tz_3_up_final": "↑ PI-RADS 4",
    "pirads_dce_tz_3_stay_base": "T2W = 3",
    "pirads_dce_tz_3_stay_cond": "DWI ≤ 4",
    "pirads_dce_tz_3_stay_final": "PI-RADS 3",
    "pirads_afmsTitle": "Estroma Fibromuscular Anterior (AFMS)",
    "pirads_afmsDesc": "El cáncer de próstata no se origina en el AFMS. Cuando se identifica una lesión sospechosa en esta zona, se deben aplicar los criterios de la zona (PZ o TZ) de donde probablemente se origina la lesión. El AFMS normal muestra forma simétrica en media luna bilateral con señal baja homogénea similar al músculo obturador en T2W, ADC y DWI alto.",
    "pirads_protocolTitle": "Protocolo RM recomendado (v2.1)",
    "pirads_protocolT2W": "Plano axial (u oblicuo perpendicular al eje largo de la próstata) + al menos un plano ortogonal adicional (sagital y/o coronal).",
    "pirads_protocolDWI": "b-value bajo (0-100, preferible 50-100), intermedio (800-1000), y alto (≥ 1400 s/mm²) obligatorio. Mapa ADC calculado.",
    "pirads_protocolDCE": "Resolución temporal ≤ 15 s. Preferiblemente 3D T1W GRE.",
    "pirads_protocolT1W": "Para detectar hemorragia post-biopsia. FOV amplio hasta bifurcación aórtica para ganglios y metástasis óseas.",
    "pirads_csCancerTitle": "Cáncer clínicamente significativo (definición PI-RADS)",
    "pirads_csCancer1": "Gleason score ≥ 7 (incluyendo 3+4 con componente Gleason 4 prominente).",
    "pirads_csCancer2": "Volumen tumoral > 0.5 cc.",
    "pirads_csCancer3": "Extensión extraprostática (EPE).",
    "pirads_volumeTitle": "Volumen Prostático y Densidad de PSA",
    "pirads_ellipsoidFormula": "Fórmula elipsoide",
    "pirads_psaDensity": "Densidad PSA ≥ 0.20 → sospecha de malignidad clínicamente significativa.",
    "pirads_rtLimit": "Límite para radioterapia externa convencional: 55 cc.",
    "pirads_tStagingTitle": "T-staging relevante para imagen",
    "pirads_stageT2": "Tumor confinado a la próstata (T2a: ≤ mitad de un lóbulo; T2b: > mitad de un lóbulo; T2c: ambos lóbulos).",
    "pirads_stageT3a": "Extensión extraprostática (EPE).",
    "pirads_stageT3b": "Invasión de vesículas seminales.",
    "pirads_stageT4": "Invasión de estructuras adyacentes (recto, pared pélvica, esfínter, vejiga).",
    "pirads_stageN1": "Ganglios regionales positivos (pélvicos, hipogástricos, sacros, ilíacos).",
    "pirads_stageM1a": "Ganglios a distancia (aórticos, ilíacos comunes, inguinales).",
    "pirads_nodesTitle": "Ganglios sospechosos (N-staging)",
    "pirads_node1": "Redondo con eje corto ≥ 8 mm.",
    "pirads_node2": "Oval con eje corto ≥ 10 mm.",
    "pirads_node3": "Apariencia heterogénea.",
    "pirads_node4": "Márgenes irregulares.",
    "pirads_node5": "DWI es la mejor secuencia para detección ganglionar.",
    "pirads_changesTitle": "Cambios clave v2.0 → v2.1",
    "pirads_change1": "Nódulos redondos completamente encapsulados en TZ ahora son PI-RADS 1 (antes 2).",
    "pirads_change2": "Criterios más precisos para categoría 2 en TZ y PZ.",
    "pirads_change3": "Actualización recomendaciones b-value DWI y resolución temporal DCE.",
    "pirads_change4": "Consideraciones especiales para AFMS y zona central.",
    "pirads_change5": "Guía mejorada para evaluación de señal de fondo en TZ.",
    "pirads_scoringNote": "La secuencia dominante determina el score base. En PZ la dominante es DWI/ADC; en TZ la dominante es T2W. Los ajustes DCE y DWI pueden modificar el score final.",
    "pirads_reference": "Fuente: Radiology Assistant — PI-RADS v2.1. Solo para uso educativo y de referencia clínica.",
    "pirads_conclusionPR1": "Lesión prostática clasificada como PI-RADS 1 (muy baja probabilidad de cáncer clínicamente significativo). No requiere seguimiento especial.",
    "pirads_conclusionPR2": "Lesión prostática clasificada como PI-RADS 2 (baja probabilidad de cáncer clínicamente significativo). No requiere biopsia.",
    "pirads_conclusionPR3": "Lesión prostática clasificada como PI-RADS 3 (probabilidad equívoca de cáncer clínicamente significativo). Se recomienda correlación clínica y posible seguimiento o biopsia según contexto clínico.",
    "pirads_conclusionPR4": "Lesión prostática clasificada como PI-RADS 4 (alta probabilidad de cáncer clínicamente significativo). Se recomienda biopsia dirigida.",
    "pirads_conclusionPR5": "Lesión prostática clasificada como PI-RADS 5 (muy alta probabilidad de cáncer clínicamente significativo). Se recomienda biopsia dirigida urgente.",
    "bosniak_classification": "Clasificación Bosniak 2019",
    "bosniak_desc": "Masas renales quísticas — Bosniak 2019",
    "bosniak_criteria": "Criterios Bosniak 2019",
    "bosniak_description": "Sistema de clasificación para masas renales quísticas basado en características de pared, septos, realce, calcificación, nodularidad y atenuación por TC/RM.",
    "bosniak_wall": "Pared",
    "bosniak_septa": "Septos",
    "bosniak_enhancement": "Realce",
    "bosniak_calcification": "Calcificación",
    "bosniak_attenuation": "Atenuación / Señal",
    "bosniak_chooseOne": "Elegir 1",
    "bosniak_highestCategory": "Categoría más alta determina la clasificación",
    "bosniak_selectFeatures": "Selecciona características",
    "bosniak_malignancyRisk": "Riesgo de malignidad",
    "bosniak_wallThinSmooth": "Pared delgada (≤ 2 mm) lisa",
    "bosniak_wallThinSmoothWithSepta": "Pared delgada (≤ 2 mm) lisa (con septos o calcificación)",
    "bosniak_wallMinimalThickening3mm": "Engrosamiento mínimo liso (3 mm) con realce",
    "bosniak_wallThickOrIrregular": "Pared gruesa (≥ 4 mm) o irregular con realce",
    "bosniak_wallWithNodule": "Pared con nódulo(s) con realce",
    "bosniak_septaNone": "Sin septos",
    "bosniak_septaFewThin": "Pocos (1–3) septos delgados (≤ 2 mm) con realce",
    "bosniak_septaMinimalThickeningOrMany": "Engrosamiento mínimo (3 mm) de septos o ≥ 4 septos delgados",
    "bosniak_septaThickOrIrregular": "Septos gruesos (≥ 4 mm) o irregulares con realce",
    "bosniak_septaWithNodule": "Septos con nódulo(s) (≥ 4 mm obtuso o cualquier ángulo agudo)",
    "bosniak_enhanceWallOnly": "La pared puede realzar; sin realce interno",
    "bosniak_enhanceSeptaWall": "Septos y pared pueden realzar",
    "bosniak_enhanceSmoothMinimal": "Realce liso de pared o septos (3 mm)",
    "bosniak_enhanceThickIrregular": "Realce de pared o septos gruesos/irregulares",
    "bosniak_enhanceNodular": "Componente(s) nodular(es) con realce",
    "bosniak_calcNone": "Sin calcificación",
    "bosniak_calcAnyType": "Calcificación de cualquier tipo (pared delgada, pocos septos)",
    "bosniak_attenSimpleFluid": "Líquido simple homogéneo (−9 a 20 UH)",
    "bosniak_attenHyperNonContrast": "Hiperatenuante homogéneo (≥ 70 UH) TC sin contraste",
    "bosniak_attenNonEnhancingGt20": "Homogéneo sin realce > 20 UH (protocolo renal TC)",
    "bosniak_attenPortalVenous2130": "Homogéneo 21–30 UH en fase portal venosa",
    "bosniak_attenTooSmall": "Homogéneo de baja atenuación, demasiado pequeño para caracterizar",
    "bosniak_attenHeteroT1Hyper": "Heterogéneo en T1 sin contraste con saturación grasa (hiperintenso)",
    "bosniak_bI_label": "Benigno",
    "bosniak_bII_label": "Mínimamente complejo",
    "bosniak_bIIF_label": "Mínimamente complejo (seguimiento)",
    "bosniak_bIII_label": "Indeterminado",
    "bosniak_bIV_label": "Claramente maligno",
    "bosniak_scoringNote": "La categoría Bosniak final se determina por la característica de mayor grado. No aplicar en lesiones con > 25% de componente sólido, etiología infecciosa/inflamatoria o vascular.",
    "bosniak_reference": "Referencia: Silverman SG et al.",
    "bosniak_conclusionI": "Masa renal quística clasificada como Bosniak I (benigna). No requiere seguimiento según la clasificación Bosniak 2019.",
    "bosniak_conclusionII": "Masa renal quística clasificada como Bosniak II (mínimamente compleja, benigna). Riesgo de malignidad < 1%. No requiere seguimiento según la clasificación Bosniak 2019.",
    "bosniak_conclusionIIF": "Masa renal quística clasificada como Bosniak IIF (mínimamente compleja, requiere seguimiento). Riesgo de malignidad 5–10%. Se recomienda seguimiento con imagen según la clasificación Bosniak 2019.",
    "bosniak_conclusionIII": "Masa renal quística clasificada como Bosniak III (indeterminada). Riesgo de malignidad ~50%. Se recomienda cirugía o vigilancia activa según contexto clínico y la clasificación Bosniak 2019.",
    "bosniak_conclusionIV": "Masa renal quística clasificada como Bosniak IV (claramente maligna). Riesgo de malignidad ~90%. Se recomienda tratamiento quirúrgico según la clasificación Bosniak 2019.",
    "bosniak_tabScoring": "Calculadora",
    "bosniak_tabCategories": "Categorías",
    "bosniak_tabImaging": "Imagen",
    "bosniak_tabInfo": "Info",
    "bosniak_wallDesc": "Evaluación del grosor, regularidad y presencia de nódulos en la pared del quiste renal. El engrosamiento o irregularidad de la pared incrementa la categoría Bosniak.",
    "bosniak_septaDesc": "Valoración del número, grosor y regularidad de los septos intraquísticos. Los septos gruesos o con nódulos sugieren mayor riesgo de malignidad.",
    "bosniak_enhancementDesc": "Patrón de realce tras administración de contraste intravenoso. El realce verdadero (≥ 20 UH) de componentes sólidos es clave para diferenciar masas benignas de malignas.",
    "bosniak_calcificationDesc": "La calcificación por sí sola no cambia la categoría Bosniak en la versión 2019. Se documenta pero no altera la clasificación.",
    "bosniak_attenuationDesc": "Características de atenuación (TC) o señal (RM) del contenido quístico. Los valores de UH y el patrón de señal determinan si el quiste es simple o complejo.",
    "bosniak_typicalFindings": "Hallazgos típicos",
    "bosniak_catI_desc": "Quiste renal simple. Pared delgada e imperceptible, contenido homogéneo de densidad agua (−9 a 20 UH), sin septos, calcificación ni realce interno.",
    "bosniak_catI_finding1": "Pared delgada (≤ 2 mm), lisa, sin realce mural apreciable",
    "bosniak_catI_finding2": "Contenido homogéneo agua (−9 a 20 UH) sin septos",
    "bosniak_catI_finding3": "Señal RM: hiperintensa T2, hipointensa T1 sin restricción difusión",
    "bosniak_catII_desc": "Quiste mínimamente complejo sin realce sospechoso. Incluye quistes con pocos septos delgados, calcificación fina o contenido hiperdenso sin realce.",
    "bosniak_catII_finding1": "Pocos septos delgados (≤ 2 mm) que pueden realzar",
    "bosniak_catII_finding2": "Calcificación de cualquier tipo en pared fina o septos finos",
    "bosniak_catII_finding3": "Quistes hiperdensos ≥ 70 UH o no realzantes > 20 UH",
    "bosniak_catIIF_desc": "Quiste mínimamente complejo que requiere seguimiento. Presenta características ligeramente más complejas que Bosniak II, pero sin realce francamente sospechoso.",
    "bosniak_catIIF_finding1": "Engrosamiento mínimo liso (3 mm) de pared o septos con realce",
    "bosniak_catIIF_finding2": "Múltiples septos delgados (≥ 4) o moderada complejidad",
    "bosniak_catIIF_finding3": "Señal heterogénea en T1 con saturación grasa (hiperintensa)",
    "bosniak_catIII_desc": "Masa quística indeterminada. Presenta hallazgos sospechosos como engrosamiento irregular de pared/septos con realce, pero sin componente claramente nodular.",
    "bosniak_catIII_finding1": "Pared o septos gruesos (≥ 4 mm) o irregulares con realce",
    "bosniak_catIII_finding2": "Realce mesurable de componentes engrosados/irregulares",
    "bosniak_catIII_finding3": "Sin nódulo mural o septal claramente definido",
    "bosniak_catIV_desc": "Masa quística claramente maligna. Contiene componente(s) nodular(es) sólido(s) con realce, indicando carcinoma de células renales hasta demostrar lo contrario.",
    "bosniak_catIV_finding1": "Nódulo(s) mural(es) o septal(es) con realce (componente sólido)",
    "bosniak_catIV_finding2": "Margenes agudos del nódulo (< 90°) con pared o septo",
    "bosniak_catIV_finding3": "Componente sólido realzante, restringido en difusión",
    "bosniak_protocolTitle": "Protocolo TC renal",
    "bosniak_phasePrecontrast": "Fase sin contraste",
    "bosniak_phasePrecontrastDesc": "Medir atenuación basal del quiste (UH). Clave para detectar quistes hiperdensos y calcular realce verdadero.",
    "bosniak_phaseCorticomedullary": "Fase corticomedular",
    "bosniak_phaseCorticomedullaryDesc": "25–70 s post-inyección. Útil para detectar realce precoz, pero la fase nefrográfica es preferida para Bosniak.",
    "bosniak_phaseNephrographic": "Fase nefrográfica",
    "bosniak_phaseNephrographicDesc": "80–180 s post-inyección. Fase óptima para evaluar realce de pared/septos. Es la fase más importante para la clasificación.",
    "bosniak_phaseExcretory": "Fase excretora",
    "bosniak_phaseExcretoryDesc": "≥ 3 min. Valorar relación con sistema colector y descartar divertículo calicial.",
    "bosniak_enhancementCritTitle": "Criterios de realce",
    "bosniak_enhanceCrit1": "Realce verdadero: incremento ≥ 20 UH entre fase sin contraste y nefrográfica",
    "bosniak_enhanceCrit2": "Pseudorealce: incremento < 10 UH por scatter/beam hardening, no verdadero realce",
    "bosniak_enhanceCrit3": "Zona gris (10–20 UH): considerar RM con sustracción para confirmar",
    "bosniak_mriTitle": "Evaluación por RM",
    "bosniak_mriT1": "Pre y post-Gd con saturación grasa. Sustracción obligatoria para detectar realce sutil.",
    "bosniak_mriT2": "Contenido quístico hiperintenso. Los componentes sólidos son relativamente hipointensos.",
    "bosniak_mriDWI": "Útil como complemento. La restricción de difusión puede indicar componente sólido, pero no sustituye al realce.",
    "bosniak_mriSubtraction": "Sustracción",
    "bosniak_mriSubtractionDesc": "Imprescindible en RM. Sustrae T1 pre-Gd del T1 post-Gd para aislar realce verdadero de señal intrínseca T1.",
    "bosniak_pitfallsTitle": "Errores diagnósticos frecuentes",
    "bosniak_pitfall1": "Confundir pseudorealce por scatter con realce verdadero en quistes pequeños (< 2 cm) adyacentes al parénquima",
    "bosniak_pitfall2": "No medir atenuación basal sin contraste — imposible determinar realce verdadero sin referencia",
    "bosniak_pitfall3": "Clasificar quistes hemorrágicos/proteináceos (hiperdensos) como complejos cuando NO realzan",
    "bosniak_pitfall4": "Aplicar Bosniak a masas con > 25% de componente sólido — la clasificación no está diseñada para masas sólidas",
    "bosniak_changesTitle": "Cambios Bosniak 2019 vs. previo",
    "bosniak_change1": "Eliminación de la categoría Bosniak I vs. II basada en calcificación — la calcificación ya no afecta la categoría",
    "bosniak_change2": "Nueva definición de umbrales de grosor: ≤ 2 mm (delgado), 3 mm (mínimamente engrosado), ≥ 4 mm (grueso)",
    "bosniak_change3": "Incorporación formal de RM como modalidad equivalente a TC para la clasificación",
    "bosniak_change4": "Se define claramente que el nódulo mural/septal (componente sólido con realce) = Bosniak IV",
    "bosniak_change5": "La regla del 'máximo grado' persiste: la característica individual más sospechosa determina la categoría final",
    "bosniak_indicationsTitle": "Indicaciones",
    "bosniak_indication1": "Masas renales quísticas incidentales detectadas en TC o RM con contraste",
    "bosniak_indication2": "Seguimiento de quistes previamente clasificados como Bosniak IIF",
    "bosniak_indication3": "Evaluación preoperatoria de masas renales quísticas complejas para planificación quirúrgica",
    "bosniak_limitationsTitle": "Limitaciones",
    "bosniak_limitation1": "No aplicar a masas renales con > 25% de componente sólido (usar clasificación de masas sólidas)",
    "bosniak_limitation2": "No válida sin contraste intravenoso — el realce es pilar fundamental de la clasificación",
    "bosniak_limitation3": "Excluir masas de etiología infecciosa/inflamatoria conocida (abscesos, quistes infectados)",
    "bosniak_limitation4": "No diseñada para masas quísticas de origen vascular (aneurismas, MAV renales)",
    "bosniak_followUpTitle": "Seguimiento recomendado",
    "bosniak_followUp12": "No requiere seguimiento por imagen",
    "bosniak_followUpIIF": "TC o RM a los 6 y 12 meses, luego anual durante 5 años. Si progresa → reclasificar.",
    "bosniak_followUpIII": "Cirugía parcial/radical o vigilancia activa con imagen cada 6 meses según comorbilidades y preferencia del paciente.",
    "bosniak_followUpIV": "Tratamiento quirúrgico (nefrectomía parcial preferida si técnicamente factible). Biopsia si se precisa confirmación preoperatoria.",
    "bosniak_referencesTitle": "Referencias",
    "garden_classification": "Clasificación Garden",
    "garden_desc": "Fracturas subcapitales de cuello femoral — Garden",
    "garden_criteria": "Clasificación de Garden",
    "garden_description": "Sistema de clasificación para fracturas subcapitales de cuello femoral basado en el grado de desplazamiento de los fragmentos óseos en la radiografía AP.",
    "garden_fracturePattern": "Patrón de fractura",
    "garden_trabecularPattern": "Patrón trabecular",
    "garden_chooseOne": "Elegir 1",
    "garden_highestGrade": "El grado más alto determina la clasificación",
    "garden_selectFeatures": "Selecciona características",
    "garden_displacement": "Desplazamiento",
    "garden_fractureIncomplete": "Fractura incompleta (impactación en valgo, solo cortical inferior)",
    "garden_fractureCompleteNondisplaced": "Fractura completa, no desplazada (ambas corticales rotas, alineadas)",
    "garden_fractureCompletePartial": "Fractura completa, parcialmente desplazada",
    "garden_fractureCompleteFull": "Fractura completa, totalmente desplazada (sin contacto entre fragmentos)",
    "garden_trabecularAngulated": "Trabéculas anguladas (patrón de impactación en valgo)",
    "garden_trabecularInterrupted": "Trabéculas interrumpidas, alineadas a través del trazo de fractura",
    "garden_trabecularDisrupted": "Trabéculas disrumpidas con rotación de la cabeza femoral",
    "garden_trabecularNone": "Sin continuidad trabecular (separación completa)",
    "garden_gI_label": "Incompleta / Impactada en valgo",
    "garden_gII_label": "Completa, no desplazada",
    "garden_gIII_label": "Completa, parcialmente desplazada",
    "garden_gIV_label": "Completa, totalmente desplazada",
    "garden_scoringNote": "El grado Garden final se determina por el nivel de desplazamiento observado. En la práctica clínica, los grados I-II (no desplazadas) y III-IV (desplazadas) se agrupan para la toma de decisiones terapéuticas.",
    "garden_reference": "Referencia:",
    "garden_conclusionI": "Fractura subcapital de cuello femoral clasificada como Garden I (fractura incompleta / impactada en valgo). Se recomienda fijación interna con tornillos canulados.",
    "garden_conclusionII": "Fractura subcapital de cuello femoral clasificada como Garden II (fractura completa, no desplazada). Se recomienda fijación interna con tornillos canulados.",
    "garden_conclusionIII": "Fractura subcapital de cuello femoral clasificada como Garden III (fractura completa, parcialmente desplazada). Se recomienda artroplastia parcial o total según edad y nivel de actividad del paciente.",
    "garden_conclusionIV": "Fractura subcapital de cuello femoral clasificada como Garden IV (fractura completa, totalmente desplazada). Se recomienda artroplastia parcial o total según edad y nivel de actividad del paciente.",
    "garden_clickToInsert": "Haz clic para insertar la recomendación en el informe",
    "garden_toggleHighlight": "Mostrar/ocultar resaltado",
    "eaton_classification": "Clasificación Eaton-Littler",
    "eaton_desc": "Artrosis trapeciometacarpiana (rizartrosis) — Eaton-Littler",
    "eaton_criteria": "Clasificación de Eaton-Littler",
    "eaton_description": "Sistema de clasificación radiológica para la artrosis trapeciometacarpiana (rizartrosis) basado en el estrechamiento articular, osteofitos, subluxación y afectación de la articulación escafotrapeciotrapezoide (ETT).",
    "eaton_jointSpace": "Espacio articular",
    "eaton_osteophytes": "Osteofitos",
    "eaton_subluxation": "Subluxación",
    "eaton_sttJoint": "Articulación ETT",
    "eaton_chooseOne": "Elegir 1",
    "eaton_highestStage": "El estadio más alto determina la clasificación",
    "eaton_selectFeatures": "Selecciona características",
    "eaton_jointNormal": "Espacio articular normal o ligeramente ensanchado",
    "eaton_jointSlightNarrowing": "Leve estrechamiento del espacio articular",
    "eaton_jointMarkedNarrowing": "Marcado estrechamiento o destrucción articular",
    "eaton_jointNarrowingBoth": "Estrechamiento marcado de TMC + articulación ETT",
    "eaton_osteoAbsent": "Sin osteofitos",
    "eaton_osteoSmall": "Osteofitos pequeños (< 2 mm)",
    "eaton_osteoLarge": "Osteofitos > 2 mm, esclerosis subcondral/quistes",
    "eaton_osteoBothJoints": "Osteofitos en articulaciones TMC + ETT",
    "eaton_subluxMinimal": "Subluxación ≤ 1/3 de la superficie articular",
    "eaton_subluxSlight": "Leve subluxación de la articulación TMC",
    "eaton_subluxSignificant": "Subluxación significativa (> 1/3)",
    "eaton_subluxFixed": "Subluxación TMC + deformidad fija en aducción",
    "eaton_sttNormalI": "Articulación ETT normal",
    "eaton_sttNormalII": "Articulación ETT normal",
    "eaton_sttNormalIII": "Articulación ETT normal",
    "eaton_sttAffected": "Articulación ETT afectada (estrechamiento, osteofitos, esclerosis)",
    "eaton_eI_label": "Pre-artrósico",
    "eaton_eII_label": "Artrosis leve",
    "eaton_eIII_label": "Artrosis avanzada (solo TMC)",
    "eaton_eIV_label": "Artrosis pantrapezoidal (TMC + ETT)",
    "eaton_scoringNote": "El estadio Eaton-Littler final se determina por el hallazgo radiológico de mayor gravedad. Los estadios I-II generalmente se manejan de forma conservadora, mientras que los estadios III-IV requieren valoración quirúrgica.",
    "eaton_reference": "Referencia:",
    "eaton_conclusionI": "Artrosis trapeciometacarpiana clasificada como Eaton-Littler I (estadio pre-artrósico). Se recomienda tratamiento conservador con férula, antiinflamatorios y rehabilitación.",
    "eaton_conclusionII": "Artrosis trapeciometacarpiana clasificada como Eaton-Littler II (artrosis leve). Se recomienda tratamiento conservador o cirugía según sintomatología clínica.",
    "eaton_conclusionIII": "Artrosis trapeciometacarpiana clasificada como Eaton-Littler III (artrosis avanzada de la articulación TMC). Se recomienda trapeciectomía o artroplastia.",
    "eaton_conclusionIV": "Artrosis trapeciometacarpiana clasificada como Eaton-Littler IV (artrosis pantrapezoidal, afectación TMC + ETT). Se recomienda artrodesis o artroplastia total.",
    "snyder_classification": "Clasificación de Snyder",
    "snyder_desc": "Roturas completas del manguito rotador — Snyder",
    "snyder_criteria": "Clasificación de Snyder",
    "snyder_description": "Sistema de clasificación para roturas completas del manguito rotador (supraespinoso y/o infraespinoso) basado en el diámetro anteroposterior de la rotura y el número de tendones afectados.",
    "snyder_tearSize": "Tamaño de rotura (AP)",
    "snyder_tendonCount": "Tendones afectados",
    "snyder_chooseOne": "Elegir 1",
    "snyder_highestGrade": "El grado más alto determina la clasificación",
    "snyder_selectFeatures": "Seleccione características",
    "snyder_tearSmall": "Rotura completa < 10 mm de diámetro AP",
    "snyder_tearMedium": "Rotura completa de 10–20 mm de diámetro AP",
    "snyder_tearLarge": "Rotura completa > 20 mm de diámetro AP",
    "snyder_tearMassive": "Rotura completa que afecta a ≥ 2 tendones",
    "snyder_tendonSingle": "Un solo tendón (supraespinoso o infraespinoso)",
    "snyder_tendonSingleRetracted": "Un solo tendón con retracción moderada",
    "snyder_tendonSingleAtrophy": "Un solo tendón con retracción/atrofia significativa",
    "snyder_tendonMultiple": "Dos o más tendones afectados",
    "snyder_sC1_label": "Rotura completa pequeña (< 10 mm)",
    "snyder_sC2_label": "Rotura completa mediana (10–20 mm)",
    "snyder_sC3_label": "Rotura completa grande (> 20 mm)",
    "snyder_sC4_label": "Rotura masiva (≥ 2 tendones)",
    "snyder_scoringNote": "El grado Snyder final se determina por el hallazgo de mayor gravedad. C4 tiene prioridad cuando se afectan dos o más tendones, independientemente del tamaño de la rotura.",
    "snyder_reference": "Referencia:",
    "snyder_conclusionC1": "Rotura completa del manguito rotador clasificada como Snyder C1 (rotura pequeña, < 10 mm de diámetro AP). Se recomienda reparación artroscópica.",
    "snyder_conclusionC2": "Rotura completa del manguito rotador clasificada como Snyder C2 (rotura mediana, 10–20 mm de diámetro AP). Se recomienda reparación artroscópica o mini-open.",
    "snyder_conclusionC3": "Rotura completa del manguito rotador clasificada como Snyder C3 (rotura grande, > 20 mm de diámetro AP). Se recomienda reparación abierta o artroscópica según retracción y calidad tisular.",
    "snyder_conclusionC4": "Rotura completa del manguito rotador clasificada como Snyder C4 (rotura masiva que afecta a dos o más tendones). Valorar transferencia tendinosa o artroplastia inversa de hombro.",
    "herbert_classification": "Clasificación de Herbert-Fisher",
    "herbert_desc": "Fracturas del escafoides carpiano — Herbert-Fisher",
    "herbert_criteria": "Escafoides carpiano · Herbert y Fisher, 1984",
    "herbert_description": "Clasifica las fracturas del escafoides carpiano según su estabilidad y evolución (Herbert y Fisher, 1984) y orienta el manejo.",
    "herbert_acutePattern": "Fractura aguda",
    "herbert_instability": "Criterio de inestabilidad",
    "herbert_chronicity": "Evolución",
    "herbert_chooseOne": "Elegir 1",
    "herbert_optional": "Opcional",
    "herbert_highestGrade": "El tipo de mayor gravedad determina la clasificación",
    "herbert_selectFeatures": "Seleccione características",
    "herbert_a1Tubercle": "Fractura del tubérculo",
    "herbert_a2WaistNondisplaced": "Cintura no desplazada (confirmada por TC)",
    "herbert_b1DistalOblique": "Oblicua del tercio distal",
    "herbert_b2WaistDisplaced": "Cintura desplazada o móvil",
    "herbert_b3ProximalPole": "Polo proximal",
    "herbert_b4Perilunate": "Fractura-luxación transescafoperilunar",
    "herbert_b5Comminuted": "Conminuta",
    "herbert_instDisplacement": "Desplazamiento > 1 mm",
    "herbert_instDisi": "DISI: ángulo escafolunar > 60°",
    "herbert_instAngle": "Ángulo intraescafoideo lateral > 35°",
    "herbert_instComminution": "Conminución",
    "herbert_instPerilunate": "Parte de una lesión perilunar",
    "herbert_cDelayed": "Retardo de consolidación",
    "herbert_d1Fibrous": "Pseudoartrosis fibrosa (polo proximal habitualmente viable)",
    "herbert_d2Mobile": "Pseudoartrosis móvil",
    "herbert_d3Sclerotic": "Pseudoartrosis esclerótica, con defecto y deformidad en joroba",
    "herbert_d4Avn": "Necrosis avascular con colapso y pérdida de arquitectura",
    "herbert_extB3a": "Ángulo escafolunar < 60°",
    "herbert_extB3b": "Ángulo escafolunar > 60°",
    "herbert_extShortLt2": "Acortamiento < 2 mm",
    "herbert_extShortGt2": "Acortamiento > 2 mm",
    "herbert_extSlac": "Con cambios SLAC",
    "herbert_tA_label": "Aguda estable",
    "herbert_tB_label": "Aguda inestable",
    "herbert_tC_label": "Retardo de consolidación",
    "herbert_tD_label": "Pseudoartrosis establecida",
    "herbert_recA": "Tratamiento conservador o fijación percutánea.",
    "herbert_recB": "Fijación quirúrgica.",
    "herbert_recC": "Cirugía, a menudo con injerto óseo.",
    "herbert_recD": "Cirugía, a menudo con injerto óseo.",
    "herbert_scoringNote": "El tipo final se determina por el hallazgo de mayor gravedad. Cualquiera de estos criterios hace la fractura aguda inestable (B): desplazamiento > 1 mm, ángulo escafolunar > 60° (DISI), ángulo intraescafoideo lateral > 35°, conminución o lesión perilunar. El polo proximal (B3) es siempre inestable por su vascularización retrógrada. Confirmar A2 frente a B2 con TC.",
    "herbert_reference": "Referencia:",
    "herbert_conclusion": "Fractura del escafoides carpiano clasificada como Herbert {{subtype}} ({{label}}). {{recommendation}}",
    "herbertUi": {
      "modeLabel": "Modo de clasificación",
      "modeGuided": "Guiado",
      "modeDirect": "Directo",
      "hintGuided": "Paso a paso hasta el subtipo.",
      "hintDirect": "Todos los subtipos a la vista, un solo clic.",
      "reset": "Limpiar",
      "directTitle": "Elige el subtipo",
      "phaseTitle": "¿En qué momento está la fractura?",
      "groupTitleAcute": "¿Es estable?",
      "groupLedeAcute": "Estable: tubérculo o fisura incompleta. Inestable: trazo completo, desplazamiento, polo proximal, conminución o lesión perilunar.",
      "groupTitleEvo": "¿Cómo ha evolucionado?",
      "groupLedeEvo": "Retardo si aún puede consolidar; pseudoartrosis si la falta de unión está establecida.",
      "subtypeTitle": "Subtipo",
      "subtypeTitleD": "Tipo de pseudoartrosis",
      "groupBadge": "Grupo {{group}}",
      "selected": "Seleccionado:",
      "aiSuggested": "IA",
      "imgAlt": "Ilustración: {{name}}",
      "next": {
        "direct": "Elige el subtipo que ves en la imagen.",
        "phase": "Empieza eligiendo si la fractura es aguda o ya en evolución.",
        "groupAcute": "Indica si la fractura es estable o inestable.",
        "groupEvo": "Indica si es un retardo de consolidación o una pseudoartrosis.",
        "sub": "Elige el subtipo del grupo {{group}}.",
        "done": "Clasificación completa: Herbert {{code}}. Copia el texto para el informe."
      },
      "panel": {
        "finalType": "Tipo final",
        "mgmt": "Manejo orientativo",
        "scale": "Escala",
        "path": "Recorrido",
        "report": "Texto para el informe",
        "copy": "Copiar",
        "copied": "Copiado",
        "disclaimer": "Orientación general. La decisión terapéutica corresponde al equipo clínico."
      },
      "report": {
        "c": "Fractura del escafoides carpiano tipo C de la clasificación de Herbert: retardo de consolidación.",
        "sub": "Fractura del escafoides carpiano tipo {{code}} de la clasificación de Herbert ({{group}}): {{rep}}."
      },
      "phases": {
        "aguda": { "name": "Fractura aguda", "text": "Traumatismo reciente. Se valora la estabilidad del trazo." },
        "evo": { "name": "Evolución", "text": "La fractura no ha consolidado en el tiempo esperable." }
      },
      "groups": {
        "A": { "name": "Aguda estable", "tile": "Estable", "text": "Tubérculo o fisura incompleta de la cintura.", "desc": "Fracturas agudas estables, que pueden tratarse de forma conservadora.", "mgmt": "Inmovilización. Elige el subtipo para concretar." },
        "B": { "name": "Aguda inestable", "tile": "Inestable", "text": "Trazo completo, desplazado, del polo proximal, conminuto o con luxación.", "desc": "Fracturas agudas inestables, con riesgo de desplazamiento y pseudoartrosis.", "mgmt": "Habitualmente fijación interna con tornillo de compresión." },
        "C": { "name": "Retardo de consolidación", "tile": "Retardo de consolidación", "text": "Sigue sin consolidar, con ensanchamiento del trazo.", "desc": "La fractura no ha consolidado en el plazo esperable. El trazo persiste, con bordes irregulares, ensanchamiento o quistes.", "mgmt": "Fijación con tornillo de compresión, con o sin injerto óseo." },
        "D": { "name": "Pseudoartrosis establecida", "tile": "Pseudoartrosis", "text": "Ausencia de consolidación establecida: fibrosa o esclerótica.", "desc": "Falta de unión establecida entre los fragmentos.", "mgmt": "Tratamiento quirúrgico. Elige el subtipo para concretar." }
      },
      "types": {
        "A1": { "name": "Fractura del tubérculo", "short": "Tubérculo", "desc": "Fractura del tubérculo distal, extraarticular y bien vascularizada.", "mgmt": "Conservador: férula o yeso durante 4–6 semanas.", "rep": "fractura del tubérculo" },
        "A2": { "name": "Fractura incompleta de la cintura", "short": "Cintura incompleta", "sub": "Fisura sin desplazamiento", "desc": "Fisura que no atraviesa toda la cintura y no tiene desplazamiento.", "mgmt": "Yeso 6–8 semanas, o fijación percutánea con tornillo si se busca una vuelta rápida a la actividad.", "rep": "fractura incompleta, no desplazada, de la cintura" },
        "B1": { "name": "Fractura oblicua del tercio distal", "short": "Oblicua tercio distal", "desc": "Trazo oblicuo largo en el tercio distal, sometido a fuerzas de cizallamiento.", "mgmt": "Fijación con tornillo de compresión.", "rep": "fractura oblicua del tercio distal" },
        "B2": { "name": "Fractura completa de la cintura", "short": "Cintura completa", "desc": "Trazo completo a través de la cintura, con o sin desplazamiento.", "mgmt": "Fijación con tornillo de compresión, percutánea o abierta según el desplazamiento.", "rep": "fractura completa de la cintura" },
        "B3": { "name": "Fractura del polo proximal", "short": "Polo proximal", "desc": "Fragmento proximal pequeño que depende de la vascularización retrógrada.", "mgmt": "Fijación quirúrgica precoz, habitualmente por vía dorsal.", "rep": "fractura del polo proximal" },
        "B4": { "name": "Fractura-luxación transescafoperilunar", "short": "Transescafo\u00adperilunar", "desc": "Fractura del escafoides asociada a luxación perilunar del carpo.", "mgmt": "Urgente: reducción inmediata, después reducción abierta con fijación y reparación ligamentosa.", "rep": "fractura-luxación transescafoperilunar del carpo" },
        "B5": { "name": "Fractura conminuta", "short": "Conminuta", "desc": "Múltiples fragmentos en el foco de fractura.", "mgmt": "Fijación con tornillo, con o sin injerto óseo. La TC ayuda a planificar.", "rep": "fractura conminuta" },
        "D1": { "name": "Pseudoartrosis fibrosa", "short": "Fibrosa", "sub": "Unión fibrosa estable", "desc": "Unión fibrosa entre los fragmentos, sin esclerosis ni deformidad relevante.", "mgmt": "Tornillo de compresión, con o sin injerto esponjoso.", "rep": "pseudoartrosis fibrosa" },
        "D2": { "name": "Pseudoartrosis esclerótica", "short": "Esclerótica", "sub": "Bordes escleróticos y quistes", "desc": "Foco abierto con bordes escleróticos y quistes; puede asociar deformidad en joroba.", "mgmt": "Resección del tejido esclerótico, injerto corticoesponjoso y fijación. Injerto vascularizado si el polo proximal no es viable.", "rep": "pseudoartrosis esclerótica" }
      },
      "alerts": {
        "A1": { "h": "Buen pronóstico", "t": "Extraarticular y bien vascularizada; consolida con inmovilización." },
        "B2": { "h": "Medir desplazamiento", "t": "Más de 1 mm de separación o escalón orienta a fijación abierta." },
        "B3": { "h": "Riesgo de necrosis avascular", "t": "El polo proximal recibe la sangre de forma retrógrada desde distal." },
        "B4": { "h": "Urgencia", "t": "Lesión perilunar asociada: requiere reducción inmediata." },
        "B5": { "h": "Planificar con TC", "t": "Define el número y tamaño de los fragmentos antes de la cirugía." },
        "C": { "h": "Seguimiento", "t": "Valora con TC el puente óseo y la aparición de quistes." },
        "D1": { "h": "Polo proximal viable", "t": "Suele conservar la vascularización: buen pronóstico con fijación." },
        "D2": { "h": "Deformidad en joroba", "t": "Valora la flexión del escafoides y la inestabilidad carpiana (DISI)." },
        "D2b": { "h": "Viabilidad", "t": "Estudia el polo proximal con RM con contraste antes de planificar el injerto." }
      },
      "hints": {
        "A2": { "h": "¿El trazo es completo o está desplazado?", "t": "Entonces no es A2 sino B2. Si la radiografía no lo aclara, confirma con TC.", "btn": "Es B2" },
        "B2": { "h": "¿Es solo una fisura incompleta y sin desplazamiento?", "t": "Entonces es A2, una fractura estable. Si dudas, confirma con TC.", "btn": "Es A2" },
        "B3": { "h": "El polo proximal siempre es B3", "t": "Aunque el trazo no esté desplazado: su vascularización retrógrada lo hace inestable." }
      }
    },
    "tnm_lung_classification": "Clasificación TNM Pulmón",
    "tnmLungName": "TNM Pulmón",
    "tnm_lung_desc": "Cáncer de pulmón no microcítico — TNM 7ª edición",
    "tnm_lung_criteria": "Clasificación TNM Pulmón",
    "tnm_lung_description": "Sistema de estadificación para el cáncer de pulmón no microcítico basado en descriptores de tumor primario (T), ganglios linfáticos regionales (N) y metástasis a distancia (M), según la 7ª edición TNM (IASLC/UICC/AJCC, 2010).",
    "tnm_lung_tumorDescriptor": "Tumor primario (T)",
    "tnm_lung_nodeDescriptor": "Ganglios linfáticos regionales (N)",
    "tnm_lung_metastasisDescriptor": "Metástasis a distancia (M)",
    "tnm_lung_chooseOne": "Elegir 1",
    "tnm_lung_stageGrouping": "Determinación del estadio",
    "tnm_lung_stage": "Estadio",
    "tnm_lung_selectDescriptors": "Seleccione los descriptores T, N y M",
    "tnm_lung_survival5y": "Supervivencia 5 años",
    "tnm_lung_scoringNote": "El estadio TNM final se determina combinando los descriptores T, N y M. En presencia de M1, el estadio es siempre IV independientemente de T y N.",
    "tnm_lung_reference": "Referencia:",
    "tnm_lung_tTX": "TX — Tumor primario no valorable",
    "tnm_lung_tT0": "T0 — Sin evidencia de tumor primario",
    "tnm_lung_tTis": "Tis — Carcinoma in situ",
    "tnm_lung_tT1a": "T1a — Tumor ≤ 2 cm",
    "tnm_lung_tT1b": "T1b — Tumor > 2 cm y ≤ 3 cm",
    "tnm_lung_tT2a": "T2a — Tumor > 3 cm y ≤ 5 cm",
    "tnm_lung_tT2b": "T2b — Tumor > 5 cm y ≤ 7 cm",
    "tnm_lung_tT3": "T3 — Tumor > 7 cm, o invasión de pared torácica / diafragma / nervio frénico, o nódulo(s) en el mismo lóbulo",
    "tnm_lung_tT4": "T4 — Invasión de mediastino, corazón, grandes vasos, tráquea, carina, esófago, vértebra; o nódulo(s) en lóbulo ipsilateral diferente",
    "tnm_lung_nNX": "NX — Ganglios regionales no valorables",
    "tnm_lung_nN0": "N0 — Sin metástasis en ganglios regionales",
    "tnm_lung_nN1": "N1 — Metástasis en ganglios peribronquiales / hiliares ipsilaterales",
    "tnm_lung_nN2": "N2 — Metástasis en ganglios mediastínicos / subcarinales ipsilaterales",
    "tnm_lung_nN3": "N3 — Metástasis en ganglios mediastínicos / hiliares contralaterales, escalenos o supraclaviculares",
    "tnm_lung_mM0": "M0 — Sin metástasis a distancia",
    "tnm_lung_mM1a": "M1a — Nódulo(s) en pulmón contralateral, derrame pleural / pericárdico maligno",
    "tnm_lung_mM1b": "M1b — Metástasis a distancia (extratorácica)",
    "tnm_lung_conclusionOculto": "Cáncer de pulmón en estadio Oculto (TX N0 M0). Se recomienda completar el estudio de extensión.",
    "tnm_lung_conclusion0": "Cáncer de pulmón en estadio 0 (Tis N0 M0, carcinoma in situ). Se recomienda resección quirúrgica.",
    "tnm_lung_conclusionIA": "Cáncer de pulmón en estadio IA (T1a-T1b N0 M0). Se recomienda resección quirúrgica (lobectomía). Supervivencia a 5 años: 73%.",
    "tnm_lung_conclusionIB": "Cáncer de pulmón en estadio IB (T2a N0 M0). Se recomienda resección quirúrgica con quimioterapia adyuvante opcional. Supervivencia a 5 años: 58%.",
    "tnm_lung_conclusionIIA": "Cáncer de pulmón en estadio IIA (T1-T2a N1, T2b N0). Se recomienda resección quirúrgica más quimioterapia adyuvante. Supervivencia a 5 años: 46%.",
    "tnm_lung_conclusionIIB": "Cáncer de pulmón en estadio IIB (T2b N1, T3 N0). Se recomienda resección quirúrgica más quimioterapia adyuvante. Supervivencia a 5 años: 36%.",
    "tnm_lung_conclusionIIIA": "Cáncer de pulmón en estadio IIIA (T1-T2 N2, T3 N1-N2, T4 N0-N1). Se recomienda quimiorradioterapia con valoración quirúrgica. Supervivencia a 5 años: 24%.",
    "tnm_lung_conclusionIIIB": "Cáncer de pulmón en estadio IIIB (T4 N2, cualquier T N3). Se recomienda quimiorradioterapia. Supervivencia a 5 años: 9%.",
    "tnm_lung_conclusionIV": "Cáncer de pulmón en estadio IV (cualquier T, cualquier N, M1). Se recomienda tratamiento sistémico (quimioterapia / terapia dirigida / inmunoterapia). Supervivencia a 5 años: 13%.",
    "tnm_lung_matrixTitle": "Matriz de estadificación (T × N)",
    "tnm_lung_matrixDesc": "Estadio resultante de la combinación de los descriptores T y N cuando M = M0. En presencia de M1a o M1b, el estadio es siempre IV independientemente de T y N.",
    "tnm_lung_matrixM1Note": "Cualquier T, cualquier N — siempre Estadio IV",
    "tnm_lung_matrixOccult": "Oculto",
    "smartBarPlaceholder": "Escribe aquí...",
    "noCommandsUnderstood": "No he entendido bien lo que quieres que haga, ¿podrías ser más específico, por favor?",
    "bold": "Negrita",
    "italic": "Cursiva",
    "underline": "Subrayado",
    "textColor": "Color del texto",
    "custom": "Personalizado",
    "untitled": "Reporte sin título",
    "facturationRate": "Facturación semanal",
    "billedReports": "informes facturados",
    "vsLastWeek": "vs semana pasada",
    "weeklyCompletionRate": "Informes semanales",
    "byPeriod": {
      "month":  { "facturationRate": "Facturación del mes",            "avgEditTimeSub": "{{count}} informes este mes" },
      "week":   { "facturationRate": "Facturación semanal",            "avgEditTimeSub": "{{count}} informes esta semana" },
      "day":    { "facturationRate": "Facturación de hoy",             "avgEditTimeSub": "{{count}} informes hoy" },
      "last30": { "facturationRate": "Facturación últimos 30 días",      "avgEditTimeSub": "{{count}} informes en los últimos 30 días" }
    },
    "activitySummary": "Resumen de actividad",
    "viewMoreStats": "Ver más estadísticas",
    "avgEditTime": "Tiempo medio por informe",
    "avgEditTimeSub": "{{count}} informes esta semana",
    "avgEditTimeEmpty": "Sin datos de edición",
    "countDrafts": "{{count}} borradores",
    "countBatches": "{{count}} lotes",
    "countSent": "{{count}} enviados",
    "countShared": "{{count}} compartidos",
    "workHistoryTitle": "Historial de trabajo",
    "viewGroupWorkHistory": "Ver historial de trabajo del grupo",
    "sent": "Enviados",
    "moreStats": "Ver todas las estadísticas",
    "moreStatsDesc": "Analiza tu productividad y tendencias",
    "versionHistory": "Historial de versiones",
    "closePanel": "Cerrar panel",
    "saveDocToSeeHistory": "Guarda el documento para ver el historial.",
    "noVersionsSaved": "No hay versiones guardadas aún.",
    "restoring": "Restaurando…",
    "restoreThisVersion": "Restaurar esta versión",
    "loadMore": "Cargar más",
    "comparingDiffs": "Comparando diferencias",
    "previewingVersion": "Vista previa de versión",
    "restoreAction": "Restaurar",
    "exitPreview": "Salir de vista previa",
    "versionRestored": "Versión restaurada",
    "versionRestoreError": "No se pudo restaurar la versión",
    "triggerAutosave": "Autoguardado",
    "triggerManualSave": "Guardado manual",
    "triggerAiGeneration": "Generación IA",
    "triggerVoiceCommand": "Comando de voz",
    "triggerMagicWrite": "Escritura mágica",
    "triggerTemplateInserted": "Plantilla insertada",
    "triggerTemplateChange": "Cambio de plantilla",
    "sourceMagicWriting": "Escritura mágica",
    "sourceManual": "Manual",
    "sourceDictation": "Dictado",
    "triggerVersionRestored": "Versión restaurada",
    "standardTemplateHint": "No has indicado ninguna plantilla, así que he usado la plantilla estándar.\n Si quieres, dime qué plantilla usar y la aplicaré al instante.\n Por ejemplo: «Usa la plantilla TC TÓRAX. En el parénquima pulmonar se identifica ...».",
    "patientData": "Datos del paciente",
    "patientHistory": "Historial del paciente",
    "closePatientPanel": "Cerrar panel de paciente",
    "demographics": "Demografía",
    "birth": "Nacimiento",
    "age": "Edad",
    "sex": "Sexo",
    "studySection": "Estudio",
    "date": "Fecha",
    "descriptionLabel": "Descripción",
    "clinic": "Clínica",
    "reportHistory": "Historial de informes",
    "signed": "Firmado",
    "reportIssueTitle": "Reportar un problema",
    "reportIssueThanks": "¡Gracias por tu reporte!",
    "reportIssueReview": "Lo revisaremos lo antes posible y trabajaremos en solucionarlo.",
    "reportIssueDescribe": "Describe el problema",
    "reportIssuePlaceholder": "Describe con detalle qué ocurrió, en qué pantalla o acción y cómo reproducirlo...",
    "reportIssueSendError": "No se pudo enviar el problema. Inténtalo de nuevo.",
    "reportIssueConsent": "Acepto que el equipo de Ainovis se ponga en contacto conmigo para obtener más detalles",
    "reportIssueDisclaimer": "Usaremos esta información únicamente para mejorar nuestra herramienta y resolver el problema reportado.",
    "reportIssueSubmit": "Enviar reporte",
    "menuFile": "Archivo",
    "menuInsert": "Insertar",
    "menuClassifications": "Clasificaciones",
    "menuTemplates": "Plantillas",
    "menuSupport": "Soporte",
    "menuCopy": "Copiar",
    "menuShare": "Compartir",
    "menuVersionHistory": "Historial de versiones",
    "menuDownloadPdf": "Descargar como PDF",
    "menuPrint": "Imprimir",
    "menuRename": "Cambiar nombre",
    "menuDelete": "Eliminar",
    "menuLanguage": "Idioma",
    "menuImage": "Imagen",
    "menuTable": "Tabla",
    "insertTable": "Insertar tabla",
    "menuDivider": "Línea divisoria",
    "menuChart": "Gráfico",
    "menuShortcuts": "Atajos de teclado",
    "menuAskCarolina": "Preguntar a Carolina",
    "menuReportIssue": "Reportar un problema",
    "menuExploreTemplates": "Explorar plantillas",
    "menuUseAinovisTemplates": "Usar plantillas de Ainovis",
    "menuCreateTemplate": "Crear plantilla",
    "saveAsTemplate": "Guardar como plantilla",
    "templateNameInvalid": "El nombre solo puede contener letras, números, espacios, guiones, apóstrofes y puntos",
    "templateNameAinovis": "Ya existe una plantilla de Ainovis con ese nombre. Elige otro nombre.",
    "templateNameGroup": "El nombre de la plantilla no puede contener el nombre de tu grupo.",
    "templateName": "Nombre de la plantilla",
    "contentCopiedToClipboard": "Contenido copiado al portapapeles",
    "errorCopyingContent": "No se pudo copiar el contenido",
    "noSavedDocToDelete": "No hay un documento guardado para eliminar.",
    "deleteDocumentTitle": "Eliminar documento",
    "confirmDeleteDocument": "¿Estás seguro de que quieres eliminar este documento? Esta acción no se puede deshacer.",
    "documentDeleted": "Documento eliminado correctamente.",
    "errorDeletingDocument": "No se pudo eliminar el documento.",
    "errorDeleteForbidden": "No tienes permiso para eliminar este borrador.",
    "draftNoAccessTitle": "No tienes acceso a este borrador",
    "draftNoAccessMessage": "Pide a su autor que lo comparta contigo.",
    "draftNotFoundTitle": "Este borrador no existe",
    "draftNotFoundMessage": "Puede que su autor lo haya eliminado.",
    "noContentToExport": "No hay contenido para exportar.",
    "browserBlockedPopup": "El navegador bloqueó la ventana emergente.",
    "saveTemplate": "Guardar plantilla",
    "backToReports": "Volver a informes",
    "untitledTemplate": "Plantilla sin título",
    "templateTitleRequired": "Debes añadir un título a la plantilla",
    "actionVersions": "Versiones",
    "actionPatients": "Pacientes",
    "actionReportsHistory": "Reportes previos",
    "patientsSidebarTitlePatient": "Datos del paciente",
    "patientsSidebarTitleHistory": "Historial del paciente",
    "patientsSidebarClose": "Cerrar panel de paciente",
    "patientsSidebarNotConnected": "No conectado",
    "patientsSidebarTabPatient": "Datos del paciente",
    "patientsSidebarTabHistory": "Historial de informes",
    "patientsSidebarSectionDemographics": "Demografía",
    "patientsSidebarSectionStudy": "Estudio actual",
    "patientsSidebarSectionClinical": "Clínica",
    "patientsSidebarLabelBirth": "Nacimiento",
    "patientsSidebarLabelAge": "Edad",
    "patientsSidebarLabelSex": "Sexo",
    "patientsSidebarLabelModality": "Modalidad",
    "patientsSidebarLabelDate": "Fecha",
    "patientsSidebarLabelAccession": "Nº Acceso",
    "patientsSidebarLabelDescription": "Descripción",
    "patientsSidebarLabelReferring": "Médico solicitante",
    "patientsSidebarLabelReason": "Motivo de petición",
    "patientsSidebarAddReason": "Añadir motivo de petición",
    "patientsSidebarAddReasonShort": "Añadir",
    "patientsSidebarReasonHint": "Necesitas estar conectado a un sistema externo (RIS/PACS) para añadir esta funcionalidad.",
    "patientsSidebarStudyUid": "Study UID",
    "patientsSidebarSexMale": "Masculino",
    "patientsSidebarSexFemale": "Femenino",
    "patientsSidebarYearsOld": "{{years}} años",
    "patientsSidebarNoPatientName": "Paciente sin nombre",
    "patientsSidebarReportFallbackTitle": "Informe",
    "patientsSidebarNoReport": "Sin informe",
    "patientsSidebarHistoryEmpty": "Sin informes previos disponibles",
    "patientsSidebarHistoryUnread": "No se han podido cargar los informes",
    "patientsSidebarHistoryCount": "{{studies}} estudios · {{reports}} informes",
    "priorViewerClose": "Cerrar informe previo",
    "priorViewerNoContent": "Este informe no tiene contenido disponible.",
    "priorViewerConclusion": "Conclusión",
    "patientSummaryButton": "Resumir",
    "patientSummaryButtonHint": "Resumen de los informes previos generado por Carolina",
    "patientSummaryTitle": "Resumen del paciente",
    "patientSummaryRegenerate": "Regenerar",
    "patientSummaryCollapse": "Plegar resumen",
    "patientSummaryExpand": "Desplegar resumen",
    "patientSummaryShowMore": "Ver todo",
    "patientSummaryShowLess": "Ver menos",
    "patientSummaryStepAnalyzing": "Analizando informes previos ({{count}})…",
    "patientSummaryStepWriting": "Redactando resumen…",
    "patientSummaryNoPriors": "No hay informes previos con texto que se puedan analizar.",
    "patientSummaryNoFindings": "No se han encontrado antecedentes relevantes en los informes previos.",
    "patientSummaryStale": "Los informes previos han cambiado desde que se generó este resumen.",
    "patientSummaryRetry": "Reintentar",
    "patientSummaryErrorGeneric": "No se ha podido generar el resumen.",
    "patientSummaryErrorTimeout": "El resumen ha tardado demasiado. Inténtalo de nuevo.",
    "patientSummaryErrorLimits": "Hay demasiados informes previos para resumirlos de una vez.",
    "patientSummaryErrorUnavailable": "El servicio de resumen no está disponible en este momento.",
    "patientSummaryDisclaimer": "Generado por Carolina a las {{time}} · Verifica las referencias",
    "patientSummaryReferences": "Referencias ({{count}})",
    "patientSummaryViewInReport": "Ver en informe",
    "actionAiAssistant": "Asistente IA",
    "actionMicQr": "Micrófono del móvil",
    "micQrSidebarTitle": "Micrófono del móvil",
    "micQrSidebarClose": "Cerrar panel de micrófono",
    "micQrStep1": "Abre la cámara del teléfono.",
    "micQrStep2": "Escanea el código QR.",
    "micQrStep3": "Acepta el permiso del micrófono.",
    "micQrStep4": "Pulsa el botón de grabar.",
    "micQrNeedsPermission": "Acepta el permiso de micrófono en el móvil antes de grabar.",
    "micQrLoading": "Generando código…",
    "micQrError": "No se pudo crear el código. Inténtalo de nuevo.",
    "micQrExpired": "El código ha caducado",
    "micQrExpiresIn": "Caduca en {{minutes}} min",
    "micQrHttpsHint": "El teléfono necesita HTTPS (o localhost) para usar el micrófono.",
    "micQrRefresh": "Generar otro código",
    "micQrWaiting": "Esperando al teléfono…",
    "micQrStartRemote": "Conectado al micrófono del móvil. Pulsa para grabar.",
    "micQrConnected": "Teléfono conectado",
    "micQrConnectedHint": "Pulsa el botón de grabar.",
    "micQrDisconnect": "Desconectar",
    "useTemplate": "Usar plantilla",
    "newChat": "Nuevo chat",
    "closeAiPanel": "Cerrar panel de IA",
    "aiHeroText": "Pregúntame cualquier duda que tengas sobre Ainovis",
    "aiPlaceholder": "Escribe un mensaje...",
    "aiErrorMessage": "Lo siento, no he podido procesar tu pregunta. Inténtalo de nuevo.",
    "aiQuestion1": "¿Cómo genero un informe con la SmartBar?",
    "aiQuestion2": "¿Cómo inicio el dictado por voz?",
    "aiQuestion3": "¿Qué clasificaciones médicas puedo usar?",
    "toolbarParagraphStyle": "Estilo de párrafo",
    "toolbarFontFamily": "Fuente",
    "toolbarStyleNormal": "Texto normal",
    "toolbarStyleH1": "Encabezado 1",
    "toolbarStyleH2": "Encabezado 2",
    "toolbarStyleH3": "Encabezado 3",
    "toolbarStyleH4": "Encabezado 4",
    "toolbarStyleH5": "Encabezado 5",
    "toolbarApplyStyleToAll": "Aplicar a todos: \"{{style}}\"",
    "toolbarBold": "Negrita (Ctrl+B)",
    "toolbarItalic": "Cursiva (Ctrl+I)",
    "toolbarUnderline": "Subrayado (Ctrl+U)",
    "toolbarStrikethrough": "Tachado",
    "toolbarTextColor": "Color de texto",
    "toolbarHighlightColor": "Color de resaltado",
    "toolbarHighlight": "Resaltado",
    "toolbarNoColor": "Ninguno",
    "toolbarPresetColors": "Colores predeterminados",
    "toolbarCustomColors": "Colores personalizados",
    "toolbarAddCustomColor": "Color personalizado...",
    "toolbarAlignLeft": "Alinear a la izquierda",
    "toolbarAlignCenter": "Centrar",
    "toolbarAlignRight": "Alinear a la derecha",
    "toolbarJustify": "Justificar",
    "toolbarBulletList": "Lista con viñetas",
    "toolbarNumberedList": "Lista numerada",
    "toolbarLineSpacing": "Interlineado",
    "toolbarRemoveSpaceBefore": "Eliminar espacio antes del párrafo",
    "toolbarAddSpaceBefore": "Añadir espacio antes del párrafo",
    "toolbarRestoreSpaceAfter": "Restaurar espacios después del párrafo",
    "toolbarRemoveSpaceAfter": "Eliminar espacios después del párrafo",
    "toolbarCustomSpacing": "Espaciado personalizado…",
    "toolbarKeepWithNext": "Mantener con el siguiente",
    "toolbarKeepLinesTogether": "Mantener líneas juntas",
    "toolbarAvoidOrphans": "Evitar líneas aisladas",
    "toolbarPageBreakBefore": "Añadir salto de página antes",
    "toolbarDecreaseSize": "Reducir tamaño",
    "toolbarIncreaseSize": "Aumentar tamaño",
    "toolbarAlignment": "Alineación",
    "toolbarSingleSpacing": "Simple",
    "toolbarDoubleSpacing": "Doble",
    "toolbarZoom": "Zoom",
    "toolbarZoomOut": "Reducir zoom",
    "toolbarZoomIn": "Aumentar zoom",
    "toolbarUndo": "Deshacer (Ctrl+Z)",
    "toolbarRedo": "Rehacer (Ctrl+Y)",
    "toolbarMoreOptions": "Más opciones de formato",
    "toolbarFindingsMode": "Modo de hallazgos",
    "toolbarFindingsFirst": "Hallazgos al inicio",
    "toolbarFindingsFirstDesc": "Los hallazgos se colocan encima de los normales",
    "toolbarFindingsInside": "Hallazgos dentro del texto",
    "toolbarFindingsInsideDesc": "Los hallazgos se integran en el cuerpo del informe",
    "toolbarHighlightFindings": "Resaltar hallazgos",
    "toolbarLineSpacingSingle": "Simple",
    "toolbarLineSpacingDouble": "Doble",
    "toolbarLanguagePlaceholder": "Idioma"
  },
  "inconsistencies": {
    "label": "Inconsistencia",
    "show": "Mostrar",
    "hide": "Descartar",
    "mixedLateralityTerm": "Lateralidades mixtas",
    "mixedLateralityReason": "Se detectaron lateralidades diferentes (RIGHT y LEFT) en el mismo estudio. Verifique que sea correcto.",
    "missingLateralityTerm": "Lateralidad ausente",
    "missingLateralityReason": "El procedimiento requiere lateralidad pero no se detectó ninguna (derecha o izquierda) en la técnica."
  },
  "settings": {
    "title": "Configuración",
    "subtitle": "Personaliza el idioma y formato de los informes",
    "profile": "Perfil",
    "account": "Cuenta",
    "preferences": "Preferencias",
    "language": "Idioma",
    "languageDescription": "Selecciona el idioma de la interfaz de usuario",
    "theme": "Tema",
    "themeDescription": "Elige el tema de color de la aplicación",
    "themeOptions": {
      "light": "Claro",
      "dark": "Oscuro",
      "system": "Sistema"
    },
    "notifications": "Notificaciones",
    "security": "Seguridad",
    "changePassword": "Cambiar contraseña",
    "currentPassword": "Contraseña actual",
    "privacyPolicy": "Política de privacidad",
    "termsOfService": "Términos de servicio",
    "audio": "Audio",
    "audioDescription": "Configura el dispositivo de entrada de audio para el dictado",
    "audioDevice": "Dispositivo de audio",
    "audioDeviceDescription": "Selecciona el micrófono que deseas usar para el dictado",
    "selectMicrophone": "Seleccionar micrófono",
    "selectedDevice": "Dispositivo seleccionado",
    "microphone": "Micrófono",
    "onboarding": "Tutorial",
    "onboardingDescription": "Vuelve a ver el tutorial de la aplicación",
    "onboardingText": "Si quieres volver a ver el tutorial guiado de la aplicación, pulsa el botón para reactivarlo. Se mostrará la próxima vez que accedas a las pantallas correspondientes.",
    "onboardingButton": "Reactivar tutorial",
    "onboardingResetSuccess": "Tutorial reactivado correctamente",
    "session": "Sesión",
    "sessionDescription": "Gestiona tu sesión actual",
    "logoutText": "Al cerrar sesión, serás redirigido a la página de inicio de sesión",
    "signature": "Firma",
    "signatureDescription": "Escribe el texto que se insertará al firmar un informe",
    "defaultSignatureName": "Dr. Nombre Apellido",
    "signedBy": "Firmado por",
    "colegiadoLabel": "Nº colegiado",
    "signatureHint": "Configura tu nº de colegiado y título profesional en la sección de administración de usuarios.",
    "signatureSaved": "Firma guardada",
    "deleteSignature": "Eliminar firma",
    "generateSignature": "Generar firma",
    "ainovisTemplates": "Plantillas de Ainovis",
    "ainovisTemplatesDescription": "Usa las plantillas predefinidas de Ainovis al generar informes",
    "ainovisTemplatesText": "Activa esta opción para usar las plantillas de Ainovis. Si la desactivas, solo se usarán tus plantillas personales."
  },
  "users": {
    "professionalTitle": "Título",
    "professionalTitlePlaceholder": "Dr., Dra., etc.",
    "practitionerIdentifier": "Nº Colegiado",
    "practitionerIdentifierPlaceholder": "Ej: 282812345",
    "practitionerIdentifierSystem": "Sistema de identificación",
    "practitionerIdentifierSystemPlaceholder": "URI del colegio o registro profesional",
    "title": "Usuarios",
    "user": "usuario",
    "usersPlural": "usuarios",
    "userList": "Lista de usuarios",
    "addUser": "Agregar usuario",
    "editUser": "Editar usuario",
    "deleteUser": "Eliminar usuario",
    "userDetails": "Detalles del usuario",
    "newUser": "Nuevo Usuario",
    "management": "Gestión de Usuarios",
    "subtitle": "Administra y visualiza la información de usuarios del sistema",
    "searchPlaceholder": "Buscar por nombre, email o código...",
    "sortBy": "Ordenar por",
    "defaultSort": "Por defecto (Nombre)",
    "nameAsc": "Nombre (A-Z)",
    "nameDesc": "Nombre (Z-A)",
    "surnameAsc": "Apellido (A-Z)",
    "emailAsc": "Email (A-Z)",
    "emailDesc": "Email (Z-A)",
    "roleAsc": "Rol (A-Z)",
    "roleDesc": "Rol (Z-A)",
    "noUsers": "No hay usuarios disponibles",
    "showing": "Mostrando",
    "of": "de",
    "firstName": "Nombre",
    "lastName": "Apellido",
    "role": "Rol",
    "roleSuper": "Super",
    "roleAdmin": "Admin",
    "roleSupervisor": "Supervisor",
    "roleUser": "Usuario",
    "status": "Estado",
    "active": "Activo",
    "inactive": "Inactivo",
    "verified": "Verificado",
    "pending": "Pendiente",
    "lastLogin": "Último acceso",
    "createSuccess": "Usuario creado exitosamente",
    "createError": "Error al crear el usuario",
    "updateSuccess": "Usuario actualizado exitosamente",
    "deleteSuccess": "Usuario eliminado exitosamente",
    "notVerified": "Usuario no verificado",
    "notVerifiedDescription": "Este usuario aún no ha verificado su correo electrónico",
    "resendVerification": "Reenviar email de verificación",
    "resending": "Reenviando...",
    "emailSentSuccess": "Email enviado correctamente",
    "basicInfo": "Información Básica",
    "personalInfo": "Información Personal",
    "assignments": "Asignaciones",
    "code": "Código",
    "primaryEmail": "Email Principal",
    "secondaryEmail": "Email Secundario",
    "nationalId": "ID Nacional",
    "birthDate": "Fecha de Nacimiento",
    "address": "Dirección",
    "account": "Cuenta",
    "notSpecified": "No especificado",
    "required": "*",
    "optional": "(opcional)",
    "namePlaceholder": "Nombre del usuario",
    "surnamePlaceholder": "Apellido del usuario",
    "emailPlaceholder": "usuario@ejemplo.com",
    "email2Placeholder": "opcional@ejemplo.com",
    "searchAccountPlaceholder": "Buscar cuenta...",
    "roleRadiologist": "Radiólogo",
    "roleRadiologistDesc": "Acceso básico al sistema",
    "roleSupervisorDesc": "Supervisa y revisa informes",
    "roleAdminDesc": "Gestiona usuarios de su cuenta",
    "roleSuperDesc": "Acceso total al sistema",
    "nameRequired": "El nombre es requerido",
    "nameMinLength": "El nombre debe tener al menos 2 caracteres",
    "nameMaxLength": "El nombre es demasiado largo (máximo 100 caracteres)",
    "nameInvalidChars": "El nombre contiene caracteres no válidos",
    "surnameRequired": "El apellido es requerido",
    "surnameMinLength": "El apellido debe tener al menos 2 caracteres",
    "surnameMaxLength": "El apellido es demasiado largo (máximo 100 caracteres)",
    "surnameInvalidChars": "El apellido contiene caracteres no válidos",
    "emailRequired": "El email es requerido",
    "emailInvalid": "El formato del email es inválido",
    "emailMaxLength": "El email es demasiado largo (máximo 255 caracteres)",
    "email2Invalid": "El formato del email secundario es inválido",
    "email2MaxLength": "El email secundario es demasiado largo (máximo 255 caracteres)",
    "roleRequired": "El rol es requerido",
    "accountRequired": "La cuenta es requerida",
    "saving": "Guardando...",
    "create": "Crear Usuario",
    "createWithoutInvite": "Crear sin invitar",
    "update": "Actualizar"
  },
  "accounts": {
    "moreActions": "M?s acciones",
    "noLicenseLimits": "Sin límites de licencias",
    "modifiedOn": "Modificada · {{date}}",
    "title": "Cuentas",
    "account": "cuenta",
    "accountsPlural": "cuentas",
    "accountList": "Lista de cuentas",
    "addAccount": "Agregar cuenta",
    "editAccount": "Editar cuenta",
    "accountDetails": "Detalles de cuenta",
    "accountName": "Nombre de cuenta",
    "accountType": "Tipo de cuenta",
    "newAccount": "Nueva cuenta",
    "management": "Gestión de cuentas",
    "subtitle": "Administra hospitales, usuarios y licencias",
    "searchPlaceholder": "Buscar por nombre o @dominio...",
    "sortBy": "Ordenar por",
    "defaultSort": "Por defecto (Actualización)",
    "nameAsc": "Nombre (A-Z)",
    "nameDesc": "Nombre (Z-A)",
    "newestFirst": "Más recientes",
    "oldestFirst": "Más antiguos",
    "recentlyModified": "Recientemente modificados",
    "notModified": "Sin modificar",
    "noAccounts": "No se encontraron cuentas",
    "tryDifferentSearch": "Intenta con otros términos de búsqueda",
    "createFirstAccount": "Crea tu primera cuenta para comenzar",
    "page": "Página",
    "of": "de",
    "domains": "Dominios de correo",
    "noDomains": "Sin dominios configurados",
    "licenseLimits": "Límites de licencias",
    "administrators": "Administradores",
    "supervisors": "Supervisores",
    "radiologists": "Radiólogos",
    "unlimited": "Ilimitado",
    "metadata": "Metadatos",
    "createdAt": "Creado el",
    "updatedAt": "Actualizado el",
    "deleteConfirm": "¿Estás seguro de que deseas eliminar esta cuenta?",
    "deleteWarning": "Esta acción no se puede deshacer y eliminará todos los datos asociados",
    "deletion": {
      "title": "Eliminar la cuenta {{name}}",
      "lead": "El borrado arrastra todo lo que cuelga de la cuenta. No se puede deshacer.",
      "loading": "Calculando el alcance...",
      "planFailed": "No se ha podido calcular el alcance del borrado.",
      "groups": "grupos",
      "usersToDelete": "usuarios se eliminarán",
      "usersToDeactivate": "usuarios se desactivarán (tienen historial clínico)",
      "gateways": "gateways se desactivarán en el Hub",
      "hubUnreachable": "El Hub de integración no responde. Sin desactivar antes sus gateways no se puede borrar la cuenta.",
      "confirm": "Eliminar en cascada",
      "success": "Cuenta eliminada: {{groups}} grupos, {{deleted}} usuarios borrados y {{deactivated}} desactivados."
    },
    "deleteSuccess": "Cuenta eliminada exitosamente",
    "createSuccess": "Cuenta creada exitosamente",
    "updateSuccess": "Cuenta actualizada exitosamente",
    "nameRequired": "El nombre es requerido",
    "invalidNumber": "Debe ser un número positivo",
    "invalidDomain": "Formato inválido. Debe ser como @dominio.com",
    "domainExists": "Este dominio ya fue agregado",
    "addDomain": "Agregar dominio",
    "domainPlaceholder": "@ejemplo.com",
    "optional": "(Opcional, dejar vacío para ilimitado)",
    "generalInfo": "Información General",
    "additionalInfo": "Información adicional",
    "creationDate": "Fecha de creación",
    "lastUpdate": "Última actualización",
    "deleteAccount": "¿Eliminar cuenta?",
    "deleteAccountMessage": "Esta acción eliminará permanentemente la cuenta {name} y no se puede deshacer.",
    "cancel": "Cancelar",
    "confirmDelete": "Sí, eliminar",
    "accountNameField": "Nombre de la cuenta",
    "requiredField": "*",
    "domainsDescription": "Agrega los dominios de correo permitidos para esta cuenta",
    "domainInputPlaceholder": "Ej: @hospital.com",
    "limitsDescription": "Define el máximo de usuarios por rol",
    "maxAdmins": "Máximo de administradores",
    "maxSupervisors": "Máximo de supervisores",
    "maxRadiologists": "Máximo de radiólogos",
    "distributorTitle": "Distribuidor",
    "distributorDescription": "Selecciona el distribuidor asociado a esta cuenta. Puedes crear nuevos distribuidores.",
    "distributor": "Distribuidor",
    "hierarchy": {
      "title": "Estructura organizativa",
      "manage": "Administrar organización",
      "manageHint": "Grupos, equipo, plantillas institucionales y políticas, en el panel de organización."
    },
    "distributorDefault": "Por defecto",
    "distributorCreate": "Crear distribuidor…",
    "distributorCreatePlaceholder": "Ej: NUEVO_DISTRIBUIDOR",
    "distributorNameRequired": "Introduce un nombre válido"
  },
  "groups": {
    "management": "Gestión de grupos",
    "subtitle": "Administra los grupos médicos de la plataforma",
    "newGroup": "Nuevo grupo",
    "editGroup": "Editar grupo",
    "searchPlaceholder": "Buscar por nombre o NIF...",
    "group": "grupo",
    "groupsPlural": "grupos",
    "noGroups": "No se encontraron grupos",
    "tryDifferentSearch": "Intenta con otros términos de búsqueda",
    "createFirstGroup": "Crea tu primer grupo para comenzar",
    "generalInfo": "Información General",
    "contactInfo": "Información de Contacto",
    "accountInfo": "Información de Cuenta",
    "code": "Código",
    "groupName": "Nombre del grupo",
    "groupNamePlaceholder": "Ej: Grupo de Diagnóstico Norte",
    "nationalId": "NIF / CIF",
    "nationalIdPlaceholder": "Ej: B12345678",
    "address": "Dirección",
    "addressPlaceholder": "Ej: Avenida Salud 45",
    "email": "Email de contacto",
    "emailPlaceholder": "Ej: contacto@grupo.com",
    "phone": "Teléfono de contacto",
    "phonePlaceholder": "Ej: +34 912 345 678",
    "account": "Cuenta",
    "selectAccount": "Seleccionar cuenta...",
    "delete": "Eliminar",
    "edit": "Editar",
    "cancel": "Cancelar",
    "saving": "Guardando...",
    "update": "Actualizar",
    "create": "Crear grupo",
    "deleteSuccess": "Grupo eliminado exitosamente",
    "createSuccess": "Grupo creado exitosamente",
    "updateSuccess": "Grupo actualizado exitosamente",
    "nameRequired": "El nombre es requerido",
    "addressRequired": "La dirección es requerida",
    "emailRequired": "El email es requerido",
    "phoneRequired": "El teléfono es requerido",
    "accountRequired": "La cuenta es requerida",
    "invalidEmail": "Formato de email inválido",
    "notSpecified": "No especificado",
    "notAssigned": "No asignada",
    "close": "Cerrar",
    "loadError": "Error al cargar grupos"
  },
  "validation": {
    "required": "Este campo es requerido",
    "invalidEmail": "Email inválido",
    "passwordTooShort": "La contraseña debe tener al menos 8 caracteres",
    "passwordMismatch": "Las contraseñas no coinciden",
    "invalidFormat": "Formato inválido"
  },
  "navigation": {
    "home": "Inicio",
    "dashboard": "Panel",
    "reports": "Informes",
    "templates": "Plantillas",
    "users": "Usuarios",
    "accounts": "Cuentas",
    "settings": "Configuración"
  },
  "templates": {
    "title": "Plantillas",
    "preparationNoticeLabel": "Hay plantillas guardándose.",
    "preparationNoticeHint": "Espera antes de usarlas en el dictado.",
    "preparationNoticeDetail": "Las plantillas ya se han guardado, pero aún se están preparando para el dictado. Espera a que desaparezca este aviso.",
    "galleryTitle": "Galería de plantillas",
    "viewAllTemplates": "Ver todas las plantillas",
    "count": "{{count}} plantillas",
    "all": "Todas",
    "personal": "Personales",
    "emptyPersonal": "No tienes plantillas asociadas.",
    "createFirst": "Crear nueva plantilla",
    "newTemplate": "Nueva plantilla",
    "searchPlaceholder": "Buscar plantilla...",
    "allTypes": "Todos los tipos",
    "allSources": "Todos los orígenes",
    "allLanguages": "Todos los idiomas",
    "customSelect": "Seleccionar idioma",
    "showing": "Mostrando",
    "template": "plantilla",
    "templates_plural": "plantillas",
    "searching": "Buscando plantillas...",
    "loadingMore": "Cargando más plantillas...",
    "empty": "No se han encontrado plantillas",
    "emptyHint": "Añade nuevas plantillas",
    "newTemplateTitle": "Nueva plantilla",
    "details": "Detalles",
    "selectTemplate": "Selecciona una plantilla",
    "templateName": "Nombre de plantilla",
    "templateNameLabel": "Nombre de la Plantilla",
    "templatePlaceholder": "Ej: RM_RODILLA_CONTRASTE",
    "isBlock": "¿Es plantilla patológica?",
    "no": "No (Normalidad)",
    "yes": "Sí (Patológica)",
    "activationWord": "Palabra de activación",
    "activationWordLabel": "Palabra de activación",
    "activationWordPlaceholder": "Ej: TUMOR, LESION, etc.",
    "activationWordInfo": "La palabra de activación permite distinguir plantillas de una misma zona anatómica. Por ejemplo, para pancreatitis puedes usar 'PANCREATITIS' para diferenciarla de otras plantillas de páncreas",
    "autoUppercase": "Se convertirá a mayúsculas automáticamente",
    "standard": "Estándar",
    "defaultBadge": "Estándar",
    "setDefault": "Usar «{{name}}» como plantilla estándar",
    "unsetDefault": "Dejar de usar «{{name}}» como plantilla estándar",
    "defaultSet": "«{{name}}» es ahora tu plantilla estándar",
    "defaultUnset": "Ya no tienes plantilla estándar propia",
    "defaultError": "No se pudo cambiar la plantilla estándar",
    "standardInfoTitle": "Plantilla Estándar",
    "standardInfoBody": "",
    "standardInfoIntro": "La plantilla estándar está diseñada para estudios radiológicos generales. Utiliza marcadores dinámicos en la técnica que se sustituyen automáticamente al generar el informe.",
    "standardInfoTechniqueTitle": "Técnica",
    "standardInfoTechniqueBody": "La técnica incluye marcadores dinámicos entre corchetes dobles (como [[lateralidad]], [[secuencias]], [[regiones_anatomicas]]) que el sistema reemplaza automáticamente con los valores correspondientes al generar el informe.",
    "standardInfoTechniqueExample": "Se realiza TC [[regiones_anatomicas]] con técnica helicoidal [[protocolo]].",
    "standardInfoFindingsTitle": "Hallazgos",
    "standardInfoFindingsBody": "Los hallazgos se redactan como texto descriptivo continuo en formato de prosa, describiendo las estructuras evaluadas y sus características de forma narrativa.",
    "standardInfoUseCaseTitle": "¿Cuándo usarla?",
    "standardInfoUseCaseBody": "Ideal para estudios radiológicos generales: TC de extremidades, RM de rodilla, columna, abdomen, ecografías, radiografías, etc.",
    "infoExample": "Ej:",
    "content": "3. Contenido de la Plantilla",
    "contentPlaceholder": "Arrastra un archivo .txt aquí o escribe el contenido",
    "dragFile": "📄 Arrastra un archivo .txt aquí",
    "referenceIf": "4. Referencia de Activación (REFERENCE_IF)",
    "alwaysActive": "Siempre activa (ALWAYS)",
    "referenceIfWarning": "⚠️ No pueden existir dos REFERENCE_IF = ALWAYS para el mismo procedimiento",
    "activationWordRequired": "Palabra de activación:",
    "activationWordInputPlaceholder": "Ej: PATOLOGÍA, URGENTE...",
    "language": "Código de Idioma",
    "type": "Tipo",
    "saving": "Guardando...",
    "saveChanges": "Guardar Cambios",
    "createTemplate": "Crear Plantilla",
    "creating": "Creando plantilla...",
    "nameRequired": "El nombre de la plantilla es obligatorio",
    "activationRequired": "Debe ingresar una palabra de activación para plantillas patológicas",
    "activationOrAlways": "Debe ingresar una palabra de activación o marcar \"Siempre activa\"",
    "supportsBilaterality": "ℹ️ Soporta unilateralidad y bilateralidad",
    "viewOtherTechnique": "Revisar plantilla con bilateralidad/unilateralidad contraria",
    "relatedTechnique": "Técnica relacionada (Bilateral/Unilateral)",
    "contentRequired": "El contenido de la plantilla no puede estar vacío",
    "techniqueRequired": "El contenido de la técnica no puede estar vacío",
    "findingsRequired": "El contenido de hallazgos no puede estar vacío",
    "conclusionRequired": "El contenido de la conclusión no puede estar vacío",
    "technique": "Técnica",
    "techniquePlaceholder": "Escribe el contenido de la técnica",
    "techniquePlaceholderStandard": "Ej: Se realiza RM de la rodilla [[lateralidad]] [[secuencias]].",
    "findings": "Hallazgos",
    "findingsBlocks": "Hallazgos",
    "findingsPlaceholder": "Escribe el contenido de hallazgos",
    "findingsPlaceholderStandard": "Ej: Estructuras óseas con señal medular normal, sin edema ni lesiones focales.",
    "conclusion": "Conclusión",
    "conclusionPlaceholder": "Escribe el contenido de la conclusión",
    "conclusionPlaceholderStandard": "Ej: Exploración sin hallazgos significativos.",
    "noProcedures": "No existen procedimientos asociados a tu plantilla",
    "templateCreated": "Plantilla creada exitosamente",
    "errorSaving": "Error al guardar la plantilla",
    "normal": "Normal",
    "pathology": "Patología",
    "urgent": "Urgente",
    "followUp": "Seguimiento",
    "pediatric": "Pediátrico",
    "USER": "Usuario",
    "STANDARD": "Estándar",
    "AINOVIS": "Ainovis",
    "procedureAssignment": "Asignar Procedimientos",
    "procedureAssignmentExplanation": "Cuando generes un reporte y se detecte uno de los procedimientos asignados, se utilizará automáticamente esta plantilla para generar el informe",
    "groupFull": "Grupo lleno",
    "principal": "Principal",
    "complementary": "Complementario",
    "procedure": "Procedimiento",
    "addPrincipalFirst": "Primero añade un procedimiento principal",
    "dragOrAssign": "Arrastra o asigna procedimientos",
    "suggestedProcedures": "Procedimientos sugeridos",
    "availableProcedures": "Procedimientos disponibles",
    "highRelevance": "Alta relevancia",
    "mediumRelevance": "Media relevancia",
    "assignAsPrincipal": "Asignar como Principal",
    "assignAsComplementary": "Asignar como Complementario",
    "confirmSelection": "Confirmar selección",
    "remove": "Remover",
    "resolving": "Resolviendo plantilla con procedimientos...",
    "contentLabel": "Plantilla",
    "groupsDescription": "Crea grupos de procedimientos para asociar a esta plantilla",
    "assignedGroups": "Grupos de procedimientos",
    "group": "Grupo",
    "groupsPlural": "grupos",
    "groupsExamples": "Ejemplos de grupos",
    "singleExample": "Único",
    "singleExampleValue": "Rodilla → Un solo procedimiento",
    "multiExample": "Multi",
    "multiExampleValue": "Rodilla + Pierna → Varios procedimientos juntos",
    "clickToAddProcedure": "Haz clic o arrastra un procedimiento para añadirlo",
    "single": "Único",
    "multi": "Multi",
    "removeGroup": "Eliminar grupo",
    "selectGroup": "Seleccionar grupo",
    "whereToAdd": "¿Dónde quieres añadir",
    "createNewGroup": "Crear nuevo grupo",
    "add": "Añadir",
    "assigned": "Asignado",
    "dropHere": "Suelta aquí para crear un grupo",
    "dropToCreateGroup": "Suelta aquí para nuevo grupo",
    "expandList": "Expandir lista",
    "collapseList": "Contraer lista",
    "activationReference": "Referencia de activación",
    "alwaysActiveDesc": "La plantilla se activa siempre",
    "customReference": "Referencia personalizada",
    "customReferenceDesc": "Escribe una palabra clave de activación",
    "customActivation": "Activación personalizada",
    "selectDestination": "Seleccionar destino",
    "addToExisting": "Añadir a existente",
    "willCreateMulti": "Creará un Multiprocedimiento",
    "willCreateSingle": "Creará un Procedimiento único",
    "full": "Lleno",
    "createNewSection": "Crear nuevo",
    "createNewProcedure": "Crear como Procedimiento único",
    "assignedProcedures": "Procedimientos asignados",
    "item": "elemento",
    "items": "elementos",
    "examples": "Ejemplos",
    "singleProcedure": "Procedimiento único",
    "multiProcedure": "Multiprocedimiento",
    "collapse": "Colapsar",
    "expand": "Expandir",
    "dropToCreate": "Suelta aquí para crear nuevo",
    "templateContent": "Contenido de la plantilla",
    "block": "Patológica",
    "howToTemplates": "Cómo funcionan las plantillas",
    "chipLegendSelector": "Selector",
    "chipLegendPlaceholder": "Placeholder",
    "chipInsertHint": "Haz clic en un campo o escribe <kbd>/</kbd> para insertar",
    "stepConfigureTemplate": "Configurar",
    "stepSelectMarkers": "Marcadores",
    "stepAssignProcedures": "Procedimientos",
    "analyzeTemplate": "Analizar plantilla",
    "assignProcedures": "Asignar procedimientos",
    "saveTemplate": "Guardar plantilla",
    "blocksHint": "Las plantillas patológicas solo requieren hallazgos y una palabra de activación. Técnica y conclusión se omiten.",
    "normalHint": "Las plantillas de normalidad incluyen técnica, hallazgos y conclusión.",
    "standardHint": "Texto libre para describir hallazgos sin estructura fija.",
    "cancelConfirmTitle": "¿Descartar cambios?",
    "cancelConfirmMessage": "Tienes cambios sin guardar. ¿Qué deseas hacer?",
    "discardChanges": "Descartar",
    "keepEditing": "Seguir editando",
    "draftSaved": "Borrador guardado",
    "draftSavedJustNow": "Borrador guardado",
    "fieldRequired": "Este campo es obligatorio",
    "procedureStepIntro": "Paso 1: Haz clic en un procedimiento para asignarlo.",
    "procedureStepGroup": "Paso 2: Si ya hay grupos, elige dónde añadirlo.",
    "procedureStepConfirm": "Paso 3: Confirma la selección cuando termines.",
    "confirmDelete": "¿Estás seguro de que deseas eliminar esta plantilla? Se eliminarán todas las versiones asociadas (bilateral/unilateral) y sus relaciones con procedimientos.",
    "voiceChipTemplate": "Usa la plantilla",
    "voiceChipTemplatesHint": "Dicta «Usa la plantilla ...» o selecciona",
    "copyAsPersonal": "Copiar como personal",
    "copying": "Copiando...",
    "copySuccess": "¡Copiada!",
    "copyError": "Error al copiar la plantilla",
    "copyConflictTitle": "Conflicto de procedimientos",
    "copyConflictMessage": "Ya existen plantillas personales para los procedimientos asignados a esta plantilla:",
    "copyConflictHint": "Para usar esta plantilla, debes asignar una palabra de activación que la diferencie de las existentes.",
    "copyWithActivation": "Copiar con activación",
    "help": {
      "title": "Cómo crear plantillas",
      "intro": "Las plantillas permiten generar informes radiológicos de forma rápida y consistente. Escribe el texto base del informe y añade <strong>campos variables</strong> donde necesites valores dinámicos.",
      "selectorTitle": "Selector",
      "selectorDesc": "Define una lista de opciones posibles para un campo. Al generar el informe, se elegirá una de ellas. Opcionalmente puedes marcar un <strong>valor por defecto</strong> que se usará si no se indica otro.",
      "exampleInEditor": "Ejemplo en el editor:",
      "selectorExampleChip": "conservada / aumentada / disminuida: *conservada*",
      "selectorDetail": "Esto significa: las opciones son «conservada», «aumentada» y «disminuida». Si no se especifica otra cosa, se usará <strong>«conservada»</strong> como valor por defecto. El default es opcional — si no lo indicas, simplemente se mostrarán las opciones sin valor preseleccionado.",
      "placeholderTitle": "Placeholder",
      "placeholderDesc": "Un marcador genérico que será <strong>sustituido</strong> por un valor concreto al generar el informe (una descripción, una medida, un hallazgo, etc.).",
      "placeholderExampleChip": "hallazgo",
      "placeholderDetail": "Este marcador se reemplazará por el texto correspondiente cuando se genere el informe final.",
      "tipTitle": "💡 Consejo",
      "tipText": "Escribe <kbd>/</kbd> en el editor para abrir el menú rápido de inserción de campos, o usa los botones de la barra superior de cada sección.",
      "ok": "Entendido"
    },
    "source": "Origen",
    "galleryNormalPrefix": "Galería de ",
    "galleryBlockPrefix": "Galería de ",
    "galleryBlockSuffix": "",
    "gallerySubtitle": "Gestiona tus plantillas y bloques de informe",
    "countShown": "{{count}} plantillas",
    "countShown_one": "{{count}} plantilla",
    "countShown_other": "{{count}} plantillas",
    "blocksCountShown": "{{count}} bloques",
    "blocksCountShown_one": "{{count}} bloque",
    "blocksCountShown_other": "{{count}} bloques",
    "blocksWord": "Bloques",
    "templatesWord": "plantillas",
    "myTemplates": "Tus plantillas",
    "import": "Importar plantilla",
    "importTemplates": "Importar plantillas",
    "importDropTitle": "Suelta un DOCX, PDF o TXT aquí",
    "importDropActive": "Suelta los archivos aquí",
    "importDropHint": "O haz clic para seleccionar los archivos",
    "importAddMore": "Añade más archivos o continúa",
    "importFilesCount": "{{count}} archivos",
    "importTotalSize": "{{count}} archivos · {{size}} de {{limit}}",
    "importTotalTooLarge": "El tamaño total de los archivos supera el límite de {{limit}}",
    "importProcessingN": "Procesando documento {{current}} de {{total}}…",
    "importFormats": "Formatos soportados: .docx, .pdf, .txt · Máx. 25 MB en total",
    "importInvalidFormat": "Formato no soportado. Usa un archivo .docx, .pdf o .txt",
    "importProcessing": "Procesando documento…",
    "importSaving": "Importando…",
    "importSaveFailed": "No se pudieron importar las plantillas",
    "importPartialFailure": "No se pudieron importar: {{titles}}",
    "importDone": "{{created}} plantillas creadas y {{replaced}} sustituidas",
    "importSkippedAinovis": "Descartadas por coincidir con plantillas de Ainovis: {{titles}}",
    "importFailed": "No se pudo procesar el documento",
    "importEmpty": "No se ha encontrado ninguna plantilla en el documento.",
    "importRemoveFile": "Quitar archivo",
    "importSplitTitle": "Dividir documento",
    "importSplitHint": "Elige cómo separar las plantillas del documento.",
    "importSplitAi": "Detección IA",
    "importSplitAiHint": "La IA detecta cada plantilla del documento.",
    "importSplitPageBreaks": "Saltos de página",
    "importSplitPageBreaksHint": "Una plantilla por cada página del documento.",
    "importSplitHorizontalLine": "Línea horizontal",
    "importSplitHorizontalLineHint": "Divide el documento en cada línea horizontal.",
    "importPreviewTitle": "Vista previa",
    "importFoundCount": "{{count}} plantillas encontradas",
    "importSplitBy": "Dividir por",
    "importNameLabel": "Nombre de la plantilla",
    "importWordCount": "{{count}} palabras",
    "importNoConflict": "No existe ninguna plantilla con este nombre.",
    "importReplaces": "Sustituye a «{{name}}»",
    "importAinovisConflict": "Ya existe una plantilla de Ainovis con ese nombre",
    "importAinovisConflictFull": "Ya existe una plantilla de Ainovis con ese nombre. Cámbialo para poder importarla.",
    "importDuplicateInDocument": "Nombre repetido en este documento",
    "importDuplicateInDocumentFull": "Otra plantilla de este documento ya usa ese nombre. Cámbialo para poder importarla.",
    "importEmptyName": "Ponle un nombre para poder importarla",
    "importUntitled": "Sin nombre",
    "importBlocked": "Corrige {{count}} nombre(s) para poder importar",
    "importFilledPerReport": "Se rellena en cada informe",
    "importSummary": "{{total}} de {{found}} seleccionadas",
    "importChooseAnother": "Elegir otro archivo",
    "importConfirm": "Importar {{count}} plantillas",
    "tabMine": "Personales",
    "tabShared": "Institucionales",
    "tabAinovis": "Ainovis",
    "filterStandard": "Estándar",
    "loading": "Cargando plantillas...",
    "editTitle": "Editar plantilla",
    "saveEdit": "Guardar cambios",
    "filterSource": "Origen",
    "filterLanguage": "Idioma",
    "normalTab": "Plantillas",
    "blocksTab": "Bloques",
    "filters": "Filtros",
    "deleteTitle": "Eliminar plantilla",
    "deleteConfirm": "¿Estás seguro de que deseas eliminar <strong>{{name}}</strong>? Esta acción eliminará todas las versiones de esta plantilla y no se puede deshacer.",
    "deleting": "Eliminando…",
    "delete": "Eliminar",
    "bulkDeleteTitle": "Eliminar plantillas",
    "bulkDeleteMessage": "¿Estás seguro de que deseas eliminar {{count}} plantillas? Esta acción eliminará todas sus versiones y no se puede deshacer.",
    "selectedCount": "{{count}} seleccionadas",
    "selectTemplate": "Seleccionar «{{name}}»",
    "tabNormal": "Plantillas",
    "tabBlocks": "Bloques",
    "previewLabel": "Vista previa:",
    "apply": "Aplicar",
    "cancel": "Cancelar"
  },
  "recommendations": {
    "title": "Sugerencias",
    "show": "Mostrar sugerencias",
    "hide": "Ocultar sugerencias",
    "list": "Sugerencias disponibles",
    "block": "Bloque",
    "classification": "Clasificación",
    "loading": "Cargando sugerencias…",
    "error": "No se pudieron actualizar todas las sugerencias.",
    "noTemplate": "Selecciona una plantilla para ver sugerencias.",
    "empty": "Todavía no hay usos con esta plantilla.",
    "expandName": "Leer nombre completo",
    "collapseName": "Contraer nombre",
    "remove": "Quitar {{name}} de sugerencias"
  },
  "blocks": {
    "sectionContentPlaceholder": "Escribe aquí el contenido que se insertará en la sección...",
    "namePlaceholder": "Nombre del bloque (ej: Pancreatitis aguda)",
    "createHint": "Este contenido se insertará dentro de la sección donde lo arrastres.",
    "empty": "Sin bloques",
    "createFirst": "Crear bloque",
    "createCard": "Crear bloque",
    "deleteTitle": "Eliminar bloque",
    "deleteConfirm": "¿Estás seguro de que deseas eliminar <strong>{{name}}</strong>? Esta acción no se puede deshacer.",
    "deleting": "Eliminando…",
    "delete": "Eliminar",
    "cancel": "Cancelar",
    "sidebarTitle": "Bloques",
    "searchToPin": "Buscar bloque...",
    "noResults": "Sin resultados",
    "expand": "Expandir",
    "collapse": "Cerrar",
    "addToTemplate": "Añadir",
    "unpin": "Desfijar",
    "pinnedLoadError": "Fijados no disponibles. Puedes seguir usando los bloques.",
    "preview": "Vista previa",
    "removeAssociation": "Quitar de la lista"
  },
  "classificationCarousel": {
    "searchPlaceholder": "Buscar clasificación...",
    "empty": "No se encontraron clasificaciones",
    "descriptions": {
      "FLEISCHNER": "Seguimiento de nódulos pulmonares incidentales en TC.",
      "TI-RADS": "Riesgo de malignidad de nódulos tiroideos por ecografía.",
      "PI-RADS": "Sospecha de cáncer de próstata clínicamente significativo en RM.",
      "BOSNIAK_2019": "Estratificación de masas renales quísticas por TC o RM.",
      "GARDEN": "Fracturas subcapitales de cuello femoral según el desplazamiento.",
      "EATON_LITTLER": "Estadificación de la rizartrosis trapeciometacarpiana.",
      "SNYDER": "Roturas completas del manguito rotador según tamaño y tendones afectados.",
      "HERBERT_FISCHER": "Fracturas del escafoides carpiano según estabilidad y evolución."
    }
  },
  "classificationRequest": {
    "title": "Solicitar clasificación",
    "close": "Cerrar",
    "successTitle": "¡Gracias por tu solicitud!",
    "successSub": "Revisaremos tu sugerencia y trabajaremos en añadir la clasificación.",
    "intro": "¿Consideras que falta una clasificación? Cuéntanos cuál necesitas y la evaluaremos para añadirla.",
    "descriptionLabel": "Describe la clasificación que necesitas",
    "descriptionPlaceholder": "Indica el nombre de la clasificación, en qué especialidad o tipo de estudio se utiliza y cualquier detalle relevante...",
    "submitError": "No se pudo enviar la solicitud. Inténtalo de nuevo.",
    "allowContact": "Acepto que el equipo de Ainovis se ponga en contacto conmigo para obtener más detalles",
    "disclaimer": "Usaremos esta información únicamente para evaluar y desarrollar nuevas clasificaciones.",
    "submitting": "Enviando…",
    "submit": "Enviar solicitud",
    "requestClassification": "Solicitar clasificación"
  },
  "keyboardShortcuts": {
    "title": "Atajos de teclado",
    "close": "Cerrar",
    "groupDictation": "Dictado",
    "dictationStart": "Empezar a grabar",
    "dictationSend": "Enviar audio",
    "dictationSendAlt": "Enviar audio",
    "dictationPauseResume": "Pausar / reanudar dictado",
    "dictationCancel": "Cancelar audio",
    "groupTextFormat": "Formato de texto",
    "bold": "Negrita",
    "italic": "Cursiva",
    "underline": "Subrayado",
    "strikethrough": "Tachado",
    "groupAlignment": "Alineación",
    "alignLeft": "Alinear a la izquierda",
    "alignCenter": "Centrar",
    "alignRight": "Alinear a la derecha",
    "justify": "Justificar",
    "groupEditing": "Edición",
    "undo": "Deshacer",
    "redo": "Rehacer",
    "selectAll": "Seleccionar todo",
    "copy": "Copiar",
    "cut": "Cortar",
    "paste": "Pegar",
    "save": "Guardar",
    "groupIndent": "Sangría",
    "indent": "Aumentar sangría",
    "unindent": "Reducir sangría",
    "groupView": "Vista",
    "zoomIn": "Aumentar zoom",
    "zoomOut": "Reducir zoom",
    "zoomReset": "Restablecer zoom",
    "key_space": "Espacio",
    "key_enter": "Intro",
    "key_esc": "Esc",
    "key_tab": "Tab",
    "key_shift": "Mayús"
  },
  "aiSidebar": {
    "title": "Carolina",
    "newChat": "Nuevo chat",
    "closePanel": "Cerrar panel de IA",
    "heroText": "Pregúntame cualquier duda que tengas sobre Ainovis",
    "inputPlaceholder": "Escribe un mensaje...",
    "errorMessage": "Lo siento, no he podido procesar tu pregunta. Inténtalo de nuevo.",
    "question1": "¿Cómo genero un informe con la SmartBar?",
    "question2": "¿Cómo inicio el dictado por voz?",
    "question3": "¿Qué clasificaciones médicas puedo usar?"
  },
  "diffModal": {
    "badge": "Conversión a plantilla",
    "progressOptions": "opciones",
    "title": "Marcadores detectados en el texto",
    "subtitle": "Revisa los cambios propuestos para convertir este informe en una plantilla reutilizable",
    "closeLabel": "Cerrar modal",
    "selectMarkers": "Elegir marcadores",
    "slotsTitle": "Opciones de construcción de plantilla",
    "slotsSubtitle": "Selecciona qué marcadores deseas aplicar. Los textos coincidentes serán reemplazados",
    "globalMode": "Modo Global",
    "individualMode": "Modo Individual",
    "useGlobalMarker": "Usar marcador global",
    "globalMarkerDescription": "Aplicará el mismo marcador para todas las regiones anatómicas",
    "finalResult": "Resultado final",
    "previewBadge": "Vista previa",
    "defaultValue": "Valor por defecto",
    "unspecified": "Sin especificar",
    "defaultHint": "Las partes resaltadas usan valores por defecto. Selecciona todas las opciones para confirmar",
    "infoTitle": "¿Qué son los marcadores?",
    "infoDescription": "Los marcadores (ej: [region anatomica], [lateralidad]) son campos que se rellenarán automáticamente al usar esta plantilla, permitiendo reutilizarla para diferentes casos",
    "warningTitle": "Completa todas las selecciones",
    "warningDescription": "Faltan {count} opciones por seleccionar. Los slots sin seleccionar están resaltados",
    "keepOriginal": "Mantener original",
    "applyTemplate": "Aplicar plantilla",
    "lateralityDisabledByRegion": "Las lateralidades están deshabilitadas porque las regiones anatómicas ya las incluyen",
    "regionDisabledByLaterality": "Las regiones anatómicas están deshabilitadas porque hay lateralidades seleccionadas",
    "flexibilityTitle": "Plantilla más flexible",
    "flexibilityDescription": "Al elegir marcadores, tu informe será más versátil. Los campos marcados se rellenarán automáticamente según el procedimiento, permitiéndote reutilizar esta plantilla para múltiples casos sin necesidad de editar manualmente",
    "noMarkersTitle": "Sin marcadores seleccionados",
    "noMarkersDescription": "Selecciona al menos un marcador para aplicar cambios a la técnica, o continúa para usar el texto original",
    "replace": "Reemplazar",
    "insert": "Insertar"
  },
  "editor": {
    "sectionTitleEditToast": "Le recuerdo que puede editar los títulos por defecto desde configuración"
  },
  "errors": {
    "authInvalidCredentials": "Email o contraseña incorrectos",
    "authInvalidToken": "Sesión inválida o expirada",
    "authTokenExpired": "Tu sesión ha expirado. Por favor, inicia sesión nuevamente",
    "authMissingToken": "Debes iniciar sesión para acceder",
    "authUserNotFound": "Usuario no encontrado",
    "authUserAlreadyExists": "Este usuario ya existe",
    "authInactiveUser": "Tu cuenta está desactivada. Contacta al administrador",
    "authInsufficientPermissions": "No tienes permisos suficientes para esta acción",
    "authValidationError": "Error en la validación de datos",
    "validationError": "Por favor verifica los datos ingresados",
    "templateNotFound": "Plantilla no encontrada",
    "templateValidationError": "Error en los datos de la plantilla",
    "templateRetrievalError": "Error al obtener las plantillas",
    "templateAlreadyExists": "Ya existe una plantilla con ese nombre",
    "templateNameDuplicate": "Ya existe una plantilla con ese nombre para este usuario",
    "templateReferenceIfConflictAlways": "Ya existe una plantilla \"{{templateName}}\" para la combinación de procedimientos: {{procedureNames}}. Solo puede existir una plantilla por defecto por combinación de procedimientos.",
    "templateReferenceIfConflict": "Ya existe una plantilla \"{{templateName}}\" con la palabra de activación \"{{referenceIf}}\" para la combinación de procedimientos: {{procedureNames}}. Por favor, utiliza una palabra de activación diferente.",
    "templateNoTemplatesFound": "No se encontraron plantillas para este usuario",
    "templateInvalidFormat": "Formato de plantilla inválido",
    "templateAccessDenied": "No tienes acceso a esta plantilla",
    "blockLimitReached": "Has alcanzado el límite de {{limit}} bloques. Elimina alguno para poder crear otro.",
    "reportNotFound": "Reporte no encontrado",
    "reportValidationError": "Error en los datos del reporte",
    "reportGenerationError": "Error al generar el reporte",
    "reportSaveError": "Error al guardar el reporte",
    "reportAlreadyExists": "Ya existe un reporte con ese identificador",
    "reportRetrievalError": "Error al obtener los reportes",
    "reportModalityNotFound": "La modalidad seleccionada no existe",
    "reportAccessDenied": "No tienes acceso a este reporte",
    "reportDataInvalid": "Los datos del reporte no son válidos",
    "reportMissingField": "Faltan campos requeridos en el reporte",
    "reportInvalidFormat": "Formato de reporte inválido",
    "reportInvalidGenerationRequest": "Solicitud de generación inválida",
    "reportApiError": "Error al conectar con el servicio de reportes",
    "reportServiceError": "Error en el servicio de reportes",
    "reportAlignmentError": "Error durante la alineación del reporte",
    "reportNoModalityOrRegions": "No se pudo detectar la modalidad ni regiones anatómicas en el texto",
    "reportTemplatesNotFoundForProcedure": "No se encontraron plantillas para tu procedimiento e idioma",
    "reportTemplatesFoundForDifferentType": "No se encontraron plantillas del tipo solicitado para tu procedimiento, pero sí existen plantillas de tipo {{availableType}}",
    "reportTemplateType_STANDARD": "hallazgos al inicio o hallazgos dentro del texto",
    "reportsTemplateNotFound": "No hay plantilla disponible para este descriptivo. Puedes crear una para usarlo",
    "reportsTemplateIncomplete": "La plantilla está incompleta y no puede usarse para generar el reporte",
    "reportsTemplateContentNotFound": "No se encontró el contenido de la plantilla",
    "reportsTemplateContentIncomplete": "El contenido de la plantilla está incompleto",
    "reportsPromptNotFound": "No se encontró el prompt necesario para la generación",
    "reportsFindingsGenerationError": "Error al generar los hallazgos del reporte",
    "reportsConclusionGenerationError": "Error al generar la conclusión del reporte",
    "reportsSectionGenerationError": "Error al generar una sección del reporte",
    "reportsParallelGenerationError": "Error durante la generación paralela del reporte",
    "reportsInvalidGenerationParameters": "Parámetros de generación inválidos",
    "reportsAlignmentError": "Error durante la alineación del reporte",
    "reportsPreSaveReviewError": "Error en la revisión previa al guardado",
    "reportsLlmServiceError": "Error en el servicio de inteligencia artificial",
    "reportLanguageCodeNotFound": "No se encontró el código de idioma solicitado",
    "reportInactiveTemplate": "La plantilla seleccionada está inactiva",
    "reportProcedureNotFound": "No se encontró el procedimiento solicitado",
    "reportAnatomicalRegionNotFound": "No se encontró la región anatómica solicitada",
    "reportVariantNotFound": "No se encontró la variante solicitada",
    "reportTemplateNotFound": "No se encontró la plantilla para el reporte",
    "ainovisApiError": "Error en el servicio de IA",
    "ainovisConnectionError": "Error de conexión con el servicio de IA",
    "ainovisTimeoutError": "El servicio de IA tardó demasiado en responder",
    "ainovisInvalidAudioFormat": "Formato de audio no válido",
    "ainovisAudioFileSizeExceeded": "El archivo de audio es demasiado grande",
    "ainovisMissingAudioFile": "No se proporcionó archivo de audio",
    "sttServiceError": "Error en el servicio de transcripción",
    "sttValidationError": "Error en la validación de los datos de transcripción",
    "sttMissingField": "Faltan campos requeridos para la transcripción",
    "sttProcessingError": "Error al procesar el audio",
    "sttApiError": "Error al conectar con el servicio de transcripción",
    "sttNoVoiceDetected": "No se ha detectado voz en el audio",
    "sttAudioProcessingError": "Error al procesar el archivo de audio",
    "sttNoAudioChunks": "No se generaron fragmentos de audio válidos",
    "sttTranscriptionError": "Error en la transcripción de voz a texto",
    "sttNoTranscriptionResults": "No se obtuvieron resultados de transcripción",
    "sttEmptyTranscript": "La transcripción resultó vacía",
    "sttInvalidAudioFile": "El archivo de audio es inválido o está corrupto",
    "sttAudioFormatNotSupported": "El formato de audio no está soportado",
    "emailSendFailed": "Error al enviar el correo",
    "emailInvalidConfig": "Configuración de correo inválida",
    "emailInvalidAddress": "Dirección de correo inválida",
    "emailTemplateNotFound": "Plantilla de correo no encontrada",
    "emailTemplateRenderError": "Error al renderizar el correo",
    "emailConnectionError": "Error de conexión con el servidor de correo",
    "emailAuthenticationError": "Error de autenticación con el servidor de correo",
    "networkError": "Error de conexión. Verifica tu conexión a internet",
    "noResponse": "El servidor no responde. Intenta nuevamente",
    "requestSetupError": "Error al procesar la solicitud",
    "unexpectedError": "Ha ocurrido un error inesperado"
  },
  "billing": {
    "studies": "Estudios",
    "revenue": "Facturación (€)",
    "modality": {
      "rx": "Radiografía",
      "eco": "Ecografía",
      "tc": "TC",
      "rm": "RM"
    }
  },
  "statistics": {
    "dateRange": "Ene 15 – Feb 15, 2026",
    "sections": {
      "productionVolume": "Producción y volumen",
      "performanceEfficiency": "Rendimiento y eficiencia",
      "billing": "Facturación",
      "realtimeActivity": "Actividad en tiempo real"
    },
    "kpi": {
      "reportsToday": "Reportes hoy",
      "activeRadiologists": "Radiólogos activos",
      "averageTime": "Tiempo promedio",
      "templateUsage": "Uso de plantillas",
      "vsYesterday": "12.3% vs ayer",
      "thisWeek": "+2 esta semana",
      "vsAvg": "0.8 min vs prom.",
      "thisMonth": "5% este mes"
    },
    "charts": {
      "reportsPerMonth": "Reportes generados por mes",
      "reportsPerMonthSubtitle": "Últimos 30 días — Total: 22,487",
      "reportsPerMonthBadge": "+18% mensual",
      "billing": "Facturación por modalidad",
      "billingSubtitle": "Tarifa oro · Volumen y facturación",
      "billingBadge": "🪩 Tarifa oro",
      "billingMonthly": "Tendencia de ingresos mensuales",
      "billingMonthlySubtitle": "Últimos 6 meses · Ingresos por modalidad",
      "topRadiologists": "Métricas por radiólogo",
      "topRadiologistsSubtitle": "Reportes esta semana por radiólogo",
      "mostUsedTemplates": "Procedimientos más informados",
      "mostUsedTemplatesSubtitle": "Distribución por tipo",
      "anatomicalRegions": "Hallazgos por procedimiento",
      "anatomicalRegionsSubtitle": "Número de hallazgos por procedimiento",
      "heatmap": "Comparativa por radiólogo",
      "heatmapSubtitle": "Reportes por radiólogo y modalidad",
      "reportsByModality": "Reportes por modalidad",
      "reportsByModalitySubtitle": "Distribución estadística (caja y bigotes)",
      "timePerRadiologist": "Tiempo generación por radiólogo",
      "timePerRadiologistSubtitle": "Min. promedio vs volumen",
      "correlationMatrix": "Matriz de correlación diagnóstica",
      "correlationMatrixSubtitle": "Concordancia Pearson entre radiólogos (20 estudios)",
      "correlationLegend": "Coeficiente de correlación (Pearson)",
      "frequentFindings": "Hallazgos frecuentes",
      "frequentFindingsSubtitle": "Frecuencia por tipo de hallazgo",
      "weeklyComparison": "Comparativa semanal",
      "weeklyComparisonSubtitle": "Top 5 — Actual vs anterior",
      "realtimeFeed": "Feed en tiempo real",
      "realtimeFeedSubtitle": "Últimos reportes",
      "live": "En vivo",
      "average": "Promedio",
      "reports": "reportes",
      "currentMonth": "Mes actual",
      "previousMonth": "Mes anterior",
      "currentWeek": "Semana actual",
      "previousWeek": "Semana anterior",
      "reportsLabel": "Reportes",
      "avgMinutes": "Min. promedio",
      "volume": "Volumen",
      "timeMins": "Tiempo (min)",
      "time": "Tiempo"
    },
    "days": {
      "mon": "Lun",
      "tue": "Mar",
      "wed": "Mié",
      "thu": "Jue",
      "fri": "Vie",
      "sat": "Sáb",
      "sun": "Dom"
    },
    "specialties": {
      "neuroradiology": "Neurorradiología",
      "musculoskeletal": "Musculoesquelético",
      "chest": "Tórax",
      "abdomen": "Abdomen",
      "breast": "Mama"
    },
    "templateNames": {
      "ctBrain": "TC Cerebro",
      "xrayChest": "RX Tórax",
      "mriKnee": "RM Rodilla",
      "ctAbdomen": "TC Abdomen",
      "usThyroid": "Eco Tiroides",
      "other": "Otras"
    },
    "regions": {
      "head": "Cabeza",
      "chest": "Tórax",
      "abdomen": "Abdomen",
      "spine": "Columna",
      "extremities": "Extremidades",
      "pelvis": "Pelvis"
    },
    "findings": {
      "noFindings": "Sin hallazgos",
      "pulmonaryNodule": "Nódulo pulmonar",
      "discHerniation": "Hernia discal",
      "pleuralEffusion": "Derrame pleural",
      "fracture": "Fractura",
      "renalMass": "Masa renal",
      "aneurysm": "Aneurisma",
      "stenosis": "Estenosis",
      "calcification": "Calcificación",
      "hepaticCyst": "Quiste hepático"
    },
    "feed": {
      "minAgo": "Hace {{value}} min"
    },
    "additionalTemplate": {
      "title": "Generar versión complementaria",
      "infoBanner": "Se ha detectado que esta plantilla podría tener una versión complementaria (bilateral/unilateral). A la izquierda, indica qué tipo de versión estás escribiendo aquí. La plantilla original se guardará automáticamente como la versión contraria. Por ejemplo, si eliges 'Unilateral', lo que escribas aquí será la versión unilateral y la plantilla original se guardará como bilateral.",
      "selectVersion": "¿Qué tipo de versión es?",
      "selectionHint": "Indica si la versión complementaria que vas a escribir es bilateral o unilateral.",
      "bilateral": "Bilateral",
      "bilateralDescription": "La versión complementaria aplica a ambos lados (ambas rodillas, ambos hombros, etc.)",
      "unilateral": "Unilateral",
      "unilateralDescription": "La versión complementaria aplica a un solo lado con etiqueta [lateralidad].",
      "selectedVersion": "Versión {{option}} seleccionada",
      "noSelection": "Selecciona un tipo de versión",
      "editContent": "Contenido de la versión complementaria",
      "edited": "Editado",
      "editHint": "Modifica los campos para definir el contenido de la versión complementaria. Este será el contenido que se guardará.",
      "technique": "Técnica",
      "techniquePlaceholder": "Escribe la técnica de la versión complementaria...",
      "findings": "Hallazgos",
      "findingsPlaceholder": "Escribe los hallazgos de la versión complementaria...",
      "impression": "Conclusión",
      "impressionPlaceholder": "Escribe la conclusión de la versión complementaria...",
      "skipGeneration": "Continuar sin adicional",
      "save": "Guardar versión"
    }
  },
  "onboarding": {
    "skip": "Omitir",
    "next": "Siguiente",
    "previous": "Anterior",
    "finish": "¡Entendido!",
    "tryIt": "¡Pruébalo!",
    "example": "Ejemplo",
    "interactionPending": "Escribe en el editor para continuar",
    "interactionDone": "¡Perfecto! Puedes continuar",
    "welcomeTitle": "¡Bienvenido a Ainovis!",
    "welcomeDesc": "Parece que es tu primera vez aquí. ¿Te gustaría hacer un recorrido rápido para conocer las herramientas principales?",
    "skipTour": "Ahora no",
    "startTour": "Iniciar recorrido",
    "reportCreate": {
      "editorTitle": "Editor de dictado",
      "editorDesc": "Aquí es donde aparecerá tu dictado. Puedes escribir directamente o usar el micrófono para dictar el estudio.",
      "micTitle": "Dictado por voz",
      "micDesc": "Pulsa el micrófono para iniciar el dictado por voz. El micrófono funciona en el idioma de la aplicación. Si no te sientes cómodo, puedes cambiar el idioma en los ajustes.",
      "generateTitle": "Generar informe",
      "generateDesc": "Una vez que hayas dictado o escrito la descripción del estudio, pulsa este botón para generar el informe automáticamente.",
      "modeTitle": "Modo automático / manual",
      "modeDesc": "Alterna entre modo automático (Ainovis selecciona la plantilla) y manual (tú eliges la plantilla a usar).",
      "speedModeTitle": "Velocidad de generación",
      "speedModeDesc": "Elige entre modo rápido (menor latencia) o preciso (mayor calidad en la generación del informe).",
      "settingsTitle": "Configuración del informe",
      "settingsDesc": "Configura el idioma, tipo de plantilla y tipo de conclusión antes de generar tu informe.",
      "tryRomTitle": "¡Ahora pruébalo tú!",
      "tryRomDesc": "Escribe en el editor una resonancia magnética (RM) de rodilla. Puedes copiar el ejemplo o escribir lo que quieras. Esto nos ayudará a mostrarte cómo Ainovis genera un informe.",
      "tryRomHint": "Escribe una RM de rodilla...",
      "tryRomExample": "RM rodilla. Normal",
      "tryGenerateTitle": "¡Genera tu primer informe!",
      "tryGenerateDesc": "Ahora pulsa el botón de enviar para generar tu informe. Ainovis procesará lo que has escrito y creará un informe completo."
    },
    "reportEdit": {
      "lateralMenuTitle": "Menú lateral",
      "lateralMenuDesc": "En este panel lateral encontrarás los parámetros del informe. Si vienes de la pantalla de creación, los ajustes que configuraste (idioma, tipo de plantilla, modo) ya estarán aplicados aquí.",
      "lateralMenuParamsTitle": "Regenerar con nuevos parámetros",
      "lateralMenuParamsDesc": "Desde aquí puedes cambiar el idioma, tipo de informe, tipo de conclusión o velocidad y regenerar el informe con los nuevos parámetros. También puedes crear nuevas versiones directamente.",
      "patientBannerTitle": "Datos del paciente",
      "patientBannerDesc": "Aquí puedes asociar los datos del paciente al informe: nombre, ID, edad, sexo, fecha del estudio y motivo de consulta. También puedes acceder a estudios previos del paciente para comparar o reutilizar informes anteriores.",
      "mainEditorTitle": "Editor del informe",
      "mainEditorDesc": "Este es el editor principal donde se muestra el informe generado, dividido en secciones (Técnica, Hallazgos, Conclusión). Puedes editar el texto libremente, dictar por voz, y los cambios se guardan automáticamente como borrador.",
      "versionTabsTitle": "Versiones del informe",
      "versionTabsDesc": "Cada vez que regeneras el informe o creas un lienzo en blanco, se crea una nueva versión. Las pestañas de la parte inferior te permiten navegar entre versiones, cerrar las que no necesites o crear una nueva versión vacía con el botón +.",
      "actionsTitle": "Acciones del informe",
      "actionsDesc": "Usa 'Copiar' para copiar el informe al portapapeles, 'Enviar' para guardar el informe como definitivo, o 'Eliminar' para descartar el borrador por completo."
    },
    "home": {
      "welcomeTitle": "Tu panel de control",
      "welcomeDesc": "Este es tu panel principal. Desde aquí puedes crear nuevos informes, subir audios para dictado por lotes y acceder a todo tu historial de trabajo.",
      "createBtnTitle": "Crear informe",
      "createBtnDesc": "Pulsa este botón para crear un nuevo informe desde cero. Se abrirá el editor donde podrás dictar o escribir el estudio.",
      "uploadBtnTitle": "Cargar audio",
      "uploadBtnDesc": "Sube archivos de audio con múltiples dictados. Ainovis los transcribirá y separará automáticamente en estudios individuales.",
      "performanceTitle": "Resumen de actividad",
      "performanceDesc": "Aquí puedes ver tus estadísticas: informes creados, tiempo ahorrado, y tendencias de productividad. Pulsa 'Ver más estadísticas' para acceder al panel completo.",
      "templatesTitle": "Plantillas",
      "templatesDesc": "En la pestaña Plantillas encontrarás tus plantillas de informe completas, listas para usar al generar un informe. Puedes crear nuevas, editar existentes o usar las compartidas por tu equipo.",
      "blocksTitle": "Bloques",
      "blocksDesc": "Cambia a la pestaña Bloques: aquí ves los bloques, fragmentos reutilizables (párrafos, hallazgos, descripciones) que puedes insertar en cualquier informe para redactar más rápido.",
      "reportListTitle": "Historial de trabajo",
      "reportListDesc": "Aquí encontrarás todos tus borradores, informes guardados, informes compartidos contigo y lotes de dictado. Usa las pestañas para filtrar."
    },
    "reportEditV2": {
      "smartBarTitle": "SmartBar — Tu barra inteligente",
      "smartBarDesc": "La SmartBar es tu herramienta principal. Escribe texto descriptivo del estudio o dicta por voz y pulsa enviar para generar el informe automáticamente con Carolina. También puedes usarla para editar secciones específicas.",
      "canvasTitle": "Editor del informe",
      "canvasDesc": "Este es el editor principal donde se muestra el informe generado, dividido en secciones editables. Puedes modificar el texto libremente y los cambios se guardan automáticamente.",
      "toolbarTitle": "Barra de herramientas",
      "toolbarDesc": "Personaliza el formato del texto: fuente, tamaño, negrita, cursiva, alineación, listas y más. Funciona como cualquier editor de texto enriquecido.",
      "findingsModeTitle": "Modos de redacción",
      "findingsModeDesc": "Desde aquí eliges cómo se redactan los hallazgos: «Hallazgos al inicio» los agrupa arriba, por encima del texto normal; «Hallazgos dentro del texto» los integra en el cuerpo del informe. Puedes cambiar de modo en cualquier momento.",
      "menuBarTitle": "Barra de menú",
      "menuBarDesc": "Accede a todas las funciones: gestión de archivos, inserción de elementos (imágenes, tablas, gráficos), clasificaciones médicas, plantillas y soporte.",
      "classificationsTitle": "Clasificaciones médicas",
      "classificationsDesc": "Accede a clasificaciones estandarizadas como Fleischner, TI-RADS, PI-RADS, Bosniak y más. Selecciona los parámetros y la clasificación se insertará automáticamente en tu informe.",
      "versionsTitle": "Historial de versiones",
      "versionsDesc": "Este es el historial de versiones del informe. Cada vez que envías, regeneras o aplicas una plantilla se guarda una versión aquí. Los pasos que cambiaron cada versión se agrupan por fecha para que puedas comparar, previsualizar y restaurar cualquier versión anterior.",
      "patientsTitle": "Pacientes",
      "patientsDesc": "Desde este panel buscáis y asociáis el paciente del estudio. Al seleccionarlo, sus datos y sus estudios previos quedan conectados al informe para consultarlo o reutilizar informes anteriores.",
      "patientsNotIntegrated": "Esta funcionalidad todavía no está integrada. Para ver los datos y el historial del paciente, el informe debe abrirse desde un sistema externo (RIS/PACS).",
      "reportsHistoryTitle": "Reportes previos",
      "reportsHistoryDesc": "Aquí ves el historial de informes guardados y puedes consultarlos para comparar hallazgos con estudios anteriores.",
      "micQrTitle": "Micrófono del móvil",
      "micQrDesc": "Escanea este código con el móvil para usarlo como micrófono de dictado inalámbrico. El código caduca pasado un tiempo; si se desconecta, vuelve a generarlo desde aquí.",
      "aiBtnTitle": "Asistente IA — Carolina",
      "aiBtnDesc": "Abre el panel de Carolina, tu asistente de IA. Puedes hacerle preguntas sobre el informe, pedirle sugerencias o consultarle dudas médicas relacionadas.",
      "testReportExample": "Usa la plantilla {{template}} y añade el bloque {{block}}",
      "testTemplateTitle": "Crea tu primera plantilla",
      "testTemplateDesc": "Haz clic en la tarjeta «CREAR PLANTILLA»: rellenaremos el nombre y un informe de ejemplo por ti.",
      "testTemplateSaveTitle": "Guarda tu plantilla",
      "testTemplateSaveDesc": "Ya tienes la plantilla rellena con un informe de RM de rodilla de ejemplo. Pulsa «Guardar plantilla» para terminar.",
      "testTemplatePending": "Guarda la plantilla para continuar",
      "autoFillTemplateName": "RM rodilla test",
      "autoFillTemplateSectionTechnique": "TÉCNICA",
      "autoFillTemplateTechniqueBody": "Estudio de RM de rodilla derecha en secuencias DP FS y T1 en los tres planos del espacio, sin administración de contraste intravenoso.",
      "autoFillTemplateSectionFindings": "HALLAZGOS",
      "autoFillTemplateFindingsBody": "Meniscos de morfología e intensidad de señal normales, sin evidencia de rotura. Ligamentos cruzados y colaterales íntegros. Cartílago articular conservado. No se observa derrame articular significativo. Médula ósea de señal normal.",
      "autoFillTemplateSectionConclusion": "CONCLUSIÓN",
      "autoFillTemplateConclusionBody": "Estudio de RM de rodilla derecha dentro de la normalidad.",
      "testBlockTitle": "Crea tu primer bloque",
      "testBlockDesc": "Pulsa la tarjeta «Crear bloque»: rellenaremos un fragmento reutilizable de ejemplo por ti. Solo tienes que pulsar «Guardar».",
      "testBlockPending": "Guarda el bloque para continuar",
      "autoFillBlockName": "Rotura menisco interno",
      "autoFillBlockContent": "Rotura horizontal del cuerno posterior del menisco interno, con extensión a la superficie articular inferior.",
      "testReportTitle": "Díctale a Carolina tu primer informe",
      "testReportDesc": "Pulsa el micrófono y di en voz alta el comando de abajo. Así es como trabajarás a diario: hablando, no escribiendo.",
      "testReportPending": "Di el comando en voz alta para continuar",
      "voiceGateIdle": "Pulsa el micrófono y di el comando en voz alta.",
      "voiceGateSayThis": "Di en voz alta:",
      "voiceGateNoMic": "No puedo usar el micrófono",
      "voiceGatePlaceholder": "Usa el micrófono →",
      "voiceGateChecking": "Escuchando lo que has dicho…",
      "voiceGateHeard": "He entendido:",
      "voiceGateMissingTemplate": "Falta nombrar tu plantilla.",
      "voiceGateMissingBlock": "Falta nombrar tu bloque.",
      "voiceGateRetry": "Repite el comando tal cual aparece arriba.",
      "voiceGateTypeFallback": "También puedes escribirlo en la barra.",
      "voiceGateError": "No se pudo transcribir el audio. Inténtalo otra vez."
    }
  },
  "voiceHelp": {
    "title": "Comandos de voz",
    "intro": "Mientras grabas puedes usar comandos de voz para editar el informe. También puedes simplemente dictar texto y se insertará en la posición del cursor. Aquí tienes los comandos disponibles:",
    "deleteTitle": "Borrar texto",
    "deleteDesc": "Elimina texto del informe. Puedes especificar una sección concreta.",
    "deleteEx1": "Borra el paciente presenta dolor",
    "deleteEx2": "Elimina en la sección hallazgos la masa hepática",
    "updateTitle": "Modificar texto",
    "updateDesc": "Reemplaza un texto por otro. Usa 'por' para indicar el nuevo valor.",
    "updateEx1": "Cambia paciente por individuo",
    "updateEx2": "Sustituye en el apartado técnica secuencia FLAIR por secuencia T2",
    "insertTitle": "Insertar texto",
    "insertDesc": "Añade texto nuevo al informe. Puedes indicar una sección o una posición relativa (antes/después de).",
    "insertEx1": "Inserta el paciente presenta buen estado general",
    "insertEx2": "Añade en la sección hallazgos masa de 3 cm",
    "insertEx3": "Inserta en la sección técnica con secuencias en T1 después de RM de rodilla",
    "insertEx4": "Añade este contenido antes de hallazgos",
    "insertSectionTitle": "Insertar sección",
    "insertSectionDesc": "Crea una nueva sección en el informe. Puedes indicar la posición relativa a otra sección.",
    "insertSectionEx1": "Inserta una nueva sección técnica",
    "insertSectionEx2": "Añade sección notas antes de la conclusión",
    "selectTitle": "Seleccionar opciones",
    "selectDesc": "Cuando el sistema muestra opciones numeradas, puedes seleccionar, cambiar o borrar opciones concretas por número.",
    "selectEx1": "Selecciona el uno y el dos",
    "selectEx2": "Elige desde el 1 hasta el 4",
    "selectEx3": "Cambia el primero",
    "selectEx4": "Borra el 4",
    "selectEx5": "Cambia todos",
    "generateTitle": "Generar informe",
    "generateDesc": "Genera o regenera el informe completo.",
    "generateEx1": "Generar informe",
    "dictationTitle": "Dictado y puntuación",
    "dictationDesc": "Puedes dictar signos de puntuación y formato con la voz.",
    "dictationEx1": "punto → .",
    "dictationEx2": "coma → ,",
    "dictationEx3": "dos puntos → :",
    "dictationEx4": "nueva línea → salto de línea",
    "dictationEx5": "nuevo párrafo → salto de párrafo",
    "tip": "💡 Los comandos funcionan con prefijos opcionales como el nombre del asistente (Carolina), expresiones de cortesía (por favor) o saludos informales (oye). También toleran puntuación generada por el reconocimiento de voz."
  },
  "batch": {
    "title": "Dictado por lotes",
    "uploadSubtitle": "Sube un archivo de audio con múltiples informes",
    "transcribingSubtitle": "Transcribiendo audio...",
    "reviewSubtitle": "Revisa y corrige los estudios detectados",
    "generatingSubtitle": "Generando informes...",
    "stepUpload": "Subir audio",
    "stepReview": "Revisar",
    "transcriptionComplete": "Transcripción completada — {{count}} estudios detectados",
    "transcriptionError": "Error al transcribir el audio",
    "noStudies": "No se encontraron estudios. Asegúrate de usar el formato [Paciente ID].",
    "batchSaved": "Lote guardado correctamente — {{count}} estudios",
    "saveError": "Error al guardar el lote",
    "invalidFormat": "Formato no soportado. Usa archivos .wav, .mp3, .ogg o .webm",
    "durationExceeded": "La duración total de los archivos no puede superar los 30 minutos",
    "transcribingAudio": "Transcribiendo audio...",
    "transcribingHint": "El audio se está procesando. Esto puede tardar unos segundos.",
    "dropHere": "Suelta el archivo aquí",
    "uploadTitle": "Sube tu archivo de audio",
    "uploadHint": "Arrastra un archivo aquí o haz clic para seleccionar",
    "supportedFormats": "Formatos soportados: .wav, .mp3, .ogg, .webm",
    "useMockData": "Usar datos de ejemplo",
    "processAudio": "Procesar audio",
    "pause": "Pausar",
    "playAll": "Reproducir todo",
    "unifiedHint": "Cada estudio está separado por [Paciente ID]. Pulsa ▶ junto a cada paciente para escuchar su segmento de audio.",
    "studiesDetected": "{{count}} estudios detectados",
    "scrollToBottom": "Ir al final",
    "goToEnd": "Ir al final",
    "saving": "Guardando lote...",
    "playSegment": "Reproducir segmento",
    "unifiedPlaceholder": "[Paciente 12345678]\nDescriptivo del estudio...\n\n[Paciente 87654321]\nOtro estudio...",
    "generateAll": "Generar todos"
  },
  "voiceCommands": {
    "noTextToDelete": "No se especificó texto a eliminar",
    "editorNotAvailable": "Editor no disponible",
    "completeUpdatesBeforeDelete": "Completa o cancela las actualizaciones pendientes antes de hacer eliminaciones",
    "textNotFound": "No se encontró \"{{text}}\"",
    "textNotFoundInDocument": "No se encontró \"{{text}}\" en el documento",
    "couldNotDeleteText": "No se pudo eliminar el texto",
    "noPendingOperations": "No hay operaciones pendientes. Usa el comando DELETE, UPDATE o INSERT primero.",
    "noMatchesFound": "No se encontraron coincidencias marcadas",
    "noIndicesSpecified": "No se especificaron índices",
    "invalidIndices": "Índices inválidos: {{indices}}. Rango válido: 1-{{max}}",
    "noMatchesForIndices": "No se encontraron coincidencias con los índices especificados",
    "noMatchesForIndicesDetail": "No se encontraron coincidencias con los índices especificados: {{indices}}",
    "noTextToUpdate": "No se especificó texto a actualizar",
    "noReplacementText": "No se especificó texto de reemplazo",
    "completeDeletesBeforeUpdate": "Completa o cancela las eliminaciones pendientes antes de hacer actualizaciones",
    "couldNotUpdateText": "No se pudo actualizar el texto",
    "updateExtensionNotAvailable": "La extensión de actualización no está disponible",
    "noMarkedElements": "No se encontraron elementos marcados en el documento",
    "noPendingOperationsSimple": "No hay operaciones pendientes",
    "couldNotFindInsertPosition": "No se pudo encontrar la posición de inserción",
    "noContentToInsert": "No hay contenido para insertar",
    "noReferenceText": "No se especificó el texto de referencia",
    "completeDeletesBeforeInsert": "Completa o cancela las eliminaciones pendientes antes de hacer inserciones",
    "completeUpdatesBeforeInsert": "Completa o cancela las actualizaciones pendientes antes de hacer inserciones",
    "insertExtensionNotAvailable": "La extensión de inserción no está disponible",
    "couldNotGenerateReport": "No se pudo generar el informe",
    "textInsertedInReport": "Texto insertado en el informe",
    "textInsertedInDescription": "Texto insertado en la descripción",
    "textInsertedAtEndOfReport": "Texto insertado al final del informe",
    "textUpdated": "Texto actualizado",
    "textDeleted": "Texto eliminado",
    "matchesFoundClickToUpdate": "{{count}} coincidencias encontradas. Haz clic en el texto subrayado para actualizarlo.",
    "matchesFoundUseSelect": "{{count}} coincidencias encontradas. Usa 'selecciona' para elegir cuáles eliminar.",
    "matchesDeleted": "{{count}} coincidencia(s) eliminada(s)",
    "matchesUpdated": "{{count}} coincidencia(s) actualizada(s)",
    "couldNotProcessDeletions": "No se pudieron procesar las eliminaciones",
    "couldNotProcessUpdates": "No se pudieron procesar las actualizaciones",
    "generateReportOnlyFromDescription": "El comando generar informe solo funciona desde la descripción o con índices",
    "generatingReport": "Generando informe...",
    "voiceInputProcessingError": "Error al procesar la entrada de voz",
    "deleteExtensionNotAvailable": "La extensión de eliminación no está disponible",
    "textNotFoundInValidSection": "No se encontró \"{{text}}\" dentro de una sección válida",
    "textNotFoundForInsert": "No se encontró \"{{text}}\" para insertar",
    "noSectionSpecified": "No se especificó la sección",
    "sectionNotFound": "No se encontró la sección \"{{section}}\"",
    "textNotFoundInSection": "No se encontró \"{{text}}\" en la sección \"{{section}}\"",
    "sectionTitleRequired": "Se requiere un título para la sección",
    "referenceSectionRequired": "Se requiere especificar la sección de referencia",
    "cannotAddSection": "No se puede añadir la sección",
    "couldNotInsertSection": "No se pudo insertar la sección",
    "errorInsertingSection": "Error al insertar la sección",
    "couldNotDetermineInsertPosition": "No se pudo determinar la posición de inserción en \"{{section}}\"",
    "errorInsertingTextInSection": "Error al insertar el texto en la sección",
    "noCommandRecognized": "No se reconoció ningún comando"
  },
  "share": {
    "me": "Yo",
    "sharedWith": "Compartido con",
    "title": "Compartir borrador",
    "tabUsers": "Personas",
    "tabLink": "Enlace",
    "searchUser": "Buscar usuario por nombre o email...",
    "userAdded": "Usuario añadido correctamente",
    "cannotShareSelf": "No puedes compartir contigo mismo",
    "differentAccount": "Solo puedes compartir con usuarios de tu misma cuenta",
    "errorSharing": "Error al compartir",
    "userRemoved": "Acceso revocado",
    "errorRemoving": "Error al revocar acceso",
    "errorUpdating": "Error al actualizar permisos",
    "linkEnabled": "Enlace activado",
    "errorLink": "Error al actualizar enlace",
    "linkCopied": "Enlace copiado al portapapeles",
    "errorCopyLink": "Error al copiar enlace",
    "tokenRegenerated": "Enlace regenerado",
    "errorRegenerate": "Error al regenerar enlace",
    "owner": "Propietario",
    "addedBy": "Añadido por",
    "permView": "Ver",
    "permEdit": "Editar",
    "targetNotFound": "No se encontró al usuario con quien quieres compartir",
    "linkInvalid": "Enlace no válido o desactivado",
    "linkOtherAccount": "Este enlace es de otra cuenta y no puedes abrirlo",
    "joinError": "Error al acceder al borrador compartido",
    "goToReports": "Ir a informes",
    "joining": "Accediendo al borrador compartido...",
    "noUsersFound": "No se encontraron usuarios",
    "noUsersShared": "No se ha compartido con nadie todavía",
    "shareLinkTitle": "Compartir por enlace",
    "shareLinkDesc": "Cualquier persona con el enlace puede acceder",
    "linkPermission": "Permiso del enlace",
    "removeAccess": "Revocar acceso",
    "addUser": "Compartir",
    "copy": "Copiar",
    "copyLink": "Copiar enlace",
    "errorUpdatingLink": "Error al actualizar el enlace"
  },
  "collaboration": {
    "connected": "En vivo",
    "connecting": "Conectando...",
    "invite": "Invitar",
    "inviteMore": "Invitar a más personas"
  },
  "workHistory": {
    "title": "Historial de trabajo",
    "subtitle": "Historial de trabajo",
    "sent": "Enviados",
    "drafts": "Borradores",
    "empty": "No hay informes en esta sección.",
    "error": "No se pudo cargar el historial."
  },
  "groupReports": {
    "exportFileName": "historial_trabajo",
    "titlePrefix": "Historial de ",
    "titleAccent": "trabajo",
    "subtitle": "Informes enviados y borradores de los miembros del grupo.",
    "subtitleAccount": "Informes enviados y borradores de los miembros de la cuenta.",
    "subtitleSelf": "Tus informes enviados y borradores.",
    "kind": "Tipo de informe",
    "sent": "Enviados",
    "drafts": "Borradores",
    "author": "Autor",
    "allAuthors": "Todo el grupo",
    "scope": "Ámbito",
    "scopeAccount": "Toda la cuenta",
    "scopeSearch": "Buscar grupo o persona…",
    "scopeExpand": "Ver usuarios del grupo",
    "scopeNoMatches": "Sin coincidencias.",
    "scopeEmptyGroup": "Grupo sin usuarios.",
    "search": "Buscar",
    "searchPlaceholder": "Buscar por título…",
    "from": "Desde",
    "to": "Hasta",
    "clearFilters": "Limpiar filtros",
    "count": "{{count}} resultados",
    "searchModality": "Modalidad…",
    "searchRegion": "Región…",
    "modalities": "Modalidades",
    "regions": "Regiones",
    "allTags": "Ver todas las etiquetas",
    "exportReports": "Descargar informes",
    "exportPreviewTitle": "Descargar informes",
    "exportPreviewSubtitle": "Previsualización del archivo Excel que se va a descargar.",
    "exportSheetName": "historial_trabajo",
    "exportRowCount": "{{count}} filas",
    "exportMoreRows": "+ {{count}} filas más en la descarga",
    "exportCol_title": "Título",
    "exportCol_author": "Autor",
    "exportCol_group": "Grupo",
    "exportCol_date": "Fecha",
    "exportCol_modality": "Modalidad",
    "exportCol_region": "Región",
    "exportDownload": "Descargar Excel",
    "exportError": "No se pudieron cargar los informes para descargar.",
    "exportErrorDownload": "No se pudo generar el archivo Excel.",
    "processingLabel": "{{count}} informe(s) procesándose",
    "processingTooltip": "Hay {{count}} informe(s) procesándose. El listado se actualizará solo al terminar.",
    "untitled": "Sin título",
    "noMatches": "Ningún informe coincide con los filtros.",
    "empty": "Todavía no hay informes en tu grupo.",
    "emptySelf": "Todavía no tienes informes.",
    "error": "No se pudieron cargar los informes del grupo.",
    "errorSelf": "No se pudieron cargar tus informes."
  },
  "radiologistInsights": {
    "periodCustom": "Periodo personalizado",
    "title": "Tus métricas",
    "subtitle": "Actividad de {{name}}",
    "groupFallbackName": "grupo",
    "scopeLabel": "Ámbito de las estadísticas",
    "scopePersonal": "Área personal",
    "scopeGroup": "Área del grupo",
    "groupPlaceholderTitle": "Estadísticas del grupo",
    "groupPlaceholderText": "Las estadísticas agregadas del grupo estarán disponibles próximamente.",
    "correlationTitle": "Actividad conjunta de radiólogos",
    "correlationSubtitle": "Actividad conjunta respecto al radiólogo con más informes del grupo (0–1)",
    "correlationPairCount": "{{count}} comparaciones",
    "correlationPairOne": "1 comparación",
    "correlationNoPairs": "Se necesitan al menos dos radiólogos para comparar su actividad.",
    "correlationError": "No se pudieron cargar los radiólogos del grupo.",
    "correlationEmpty": "No hay radiólogos en el grupo.",
    "groupError": "No se pudieron cargar las estadísticas del grupo.",
    "groupOverviewSection": "Visión del grupo",
    "groupRadiologistsSection": "Radiólogos",
    "groupProductionTitle": "Producción del grupo",
    "groupProductionSubtitle": "{{total}} informes en el periodo seleccionado",
    "groupModalityTitle": "Informes por modalidad",
    "groupModalitySubtitle": "Distribución del grupo",
    "topRadiologistsTitle": "Radiólogos más productivos",
    "topRadiologistsSubtitle": "Informes realizados por radiólogo",
    "timePerRadiologistTitle": "Tiempo medio por radiólogo",
    "timePerRadiologistSubtitle": "Minutos de edición por informe",
    "snomedTooltip": "Todos los hallazgos son estandarizados usando el código internacional SNOMED CT",
    "processingLabel": "{{count}} informe(s) procesándose",
    "processingTooltip": "Hay {{count}} informe(s) procesándose. Los gráficos se actualizarán automáticamente cuando finalice.",
    "periodMonth": "Este mes",
    "periodWeek": "Esta semana",
    "periodLast30": "Últimos 30 días",
    "periodDay": "Hoy",
    "kpi": {
      "reportsMonth": "Informes este mes",
      "reportsRange": "Informes del periodo",
      "vsPrevRange": "vs periodo anterior",
      "reportsWeek": "Informes esta semana",
      "reportsDay": "Informes hoy",
      "reportsLast30": "Informes últimos 30d",
      "vsLastMonth": "vs mes anterior",
      "vsLastWeek": "vs semana anterior",
      "vsYesterday": "vs ayer",
      "vsPrev30": "vs 30 días previos",
      "topModality": "Tu modalidad top",
      "topRegion": "Tu región top",
      "reportsCount": "{{count}} informes",
      "percentOfTotal": "{{percent}}% del total",
      "findingsPerReport": "Hallazgos por informe",
      "billing": "Facturación",
      "accumulated": "Acumulado del mes",
      "topRadiologist": "Radiólogo con más informes",
      "groupTotalReports": "Informes del grupo",
      "thisMonth": "este mes",
      "activeRadiologists": "Radiólogos activos",
      "inTheGroup": "en el grupo",
      "groupAvgEditTime": "Tiempo medio de edición",
      "perReport": "por informe"
    },
    "reportsPerDay": "Informes por día",
    "dailyAverage": "Tu media diaria: {{average}} informes",
    "reports": "informes",
    "dayLabel": "Día {{day}}",
    "today": "hoy",
    "average": "media",
    "modalities": "Tus modalidades",
    "periodDistribution": "Distribución del periodo",
    "noData": "Sin datos",
    "frequentFindings": "Hallazgos más frecuentes",
    "seeAll": "Ver todos →",
    "inYourReports": "En tus informes · {{total}} menciones totales",
    "findingsBy": "Hallazgos por",
    "searchModality": "Buscar modalidad...",
    "searchRegion": "Buscar región...",
    "noFindingsForFilters": "No hay hallazgos para estos filtros en el periodo.",
    "filter": "Filtrar:",
    "yourReportsCount": "{{count}} informes tuyos",
    "billing": "Tu facturación",
    "billingMeta": "{{range}} · <strong>{{accumulated}}</strong> acumulado · proyección fin de mes {{projection}}",
    "billingMetaWeek": "{{range}} · <strong>{{accumulated}}</strong> acumulado · proyección fin de semana {{projection}}",
    "billingMetaDay": "{{range}} · <strong>{{accumulated}}</strong> acumulado hoy",
    "billingMetaLast30": "{{range}} · <strong>{{accumulated}}</strong> acumulado en los últimos 30 días",
    "billingDaily": "Ingresos diarios",
    "billingDailySubtitle": "Lo facturado en cada jornada del periodo",
    "editTimeSection": "Tiempo de edición",
    "reportsSection": "Informes",
    "findingsSection": "Hallazgos",
    "billingSection": "Facturación",
    "editTimeAvgCard": "Tiempo medio por informe",
    "editTimeCardSub": "{{reports}} informes · {{total}} total",
    "editTimeEmpty": "Sin datos de edición en este periodo",
    "editTimeMedianCard": "Mediana por informe",
    "editTimeMedianSub": "Valor central de {{reports}} informes",
    "editTimeLastCard": "Último informe",
    "editTimeLastSub": "Tiempo del informe más reciente",
    "editTime": "Tiempo dedicado al día",
    "editTimeAvg": "Media por informe: {{average}} · Total: {{total}} en {{reports}} informes",
    "editTimeLabel": "tiempo",
    "presave": {
      "sectionTitle": "Inconsistencias y avisos",
      "overrideRate": "Tasa de envíos forzados",
      "overrideTrendTooltip": "Variación respecto al periodo anterior (puntos porcentuales)",
      "overrideSub": "{{count}} decisiones",
      "totalWarnings": "Avisos del grupo",
      "totalSub": "{{forced}} enviados igualmente",
      "warningsPerReport": "Inconsistencias por informe",
      "perReport": "densidad",
      "topOverride": "Mayor tasa de envíos forzados",
      "topOverrideSub": "{{pct}}% · {{forced}} enviados igualmente",
      "timelineTitle": "Inconsistencias por día",
      "timelineSubtitle": "Reparto diario entre Revisar (verde) y Enviar igualmente (rojo)",
      "splitTitle": "Reparto de decisiones",
      "splitSubtitle": "Proporción de envíos forzados sobre el total decidido",
      "radiologistsTitle": "Tasa de inconsistencias sin resolver por radiólogo",
      "radiologistsSubtitle": "% de avisos enviados igualmente sobre el total decidido",
      "radiologistsVolumeTitle": "Radiólogos con más inconsistencias",
      "radiologistsVolumeSubtitle": "Total de avisos emitidos por cada radiólogo del grupo",
      "templatesTitle": "Plantillas con más avisos",
      "templatesSubtitle": "Procedimientos donde se origina la inconsistencia",
      "listTitle": "Eventos de inconsistencias",
      "listMeta": "{{total}} avisos",
      "colDate": "Fecha",
      "colRadiologist": "Radiólogo",
      "colJustification": "Justificación",
      "colDecision": "Decisión",
      "review": "Revisar",
      "forceSend": "Enviar igualmente",
      "pending": "Pendiente",
      "override": "Forzados",
      "empty": "Sin avisos en el período seleccionado.",
      "loadMore": "Cargar más ({{remaining}} restantes)",
      "collapse": "Contraer"
    }
  },
  "voice": {
    "recoveryTitle": "Grabación sin procesar",
    "recoveryDescription": "No se pudo procesar tu grabación después de varios intentos. Puedes reintentar o descartar la grabación.",
    "recoveryRetry": "Reintentar",
    "recoveryDownload": "Descargar audio",
    "recoveryDiscard": "Descartar",
    "recoveryConfirmDiscard": "¿Seguro? Pulsa de nuevo",
    "hardLimitReached": "Se alcanzó el límite máximo de grabación (1h 30m). El audio se está procesando.",
    "importBusy": "Termina o cancela el dictado en curso antes de importar un audio.",
    "importMultipleFiles": "Suelta un único archivo de audio.",
    "importUnsupportedType": "Solo se admiten archivos de audio.",
    "importTooLarge": "El archivo supera el máximo de {{maxMb}} MB.",
    "importTooLong": "El audio supera el máximo de {{maxMin}} minutos.",
    "importDecodeFailed": "No se pudo leer el audio. Prueba con otro formato.",
    "importNoVoice": "No se detectó voz en el audio importado.",
    "importNoEncoder": "Este navegador no puede preparar audio importado. Actualízalo o usa otro navegador.",
    "importError": "No se pudo preparar el audio importado.",
    "importComposeFailed": "No se pudo unir el audio. El dictado sigue en pausa: vuelve a enviarlo.",
    "importPreparing": "Preparando audio…",
    "importDropHint": "Suelta el audio para cargarlo",
    "softLimitWarning": "La grabación lleva más de 10 minutos",
    "errorTimeout": "El servidor tardó demasiado. Tu audio está guardado, puedes reintentar.",
    "errorDisconnected": "Se perdió la conexión con el servidor. Tu audio está guardado.",
    "errorGeneration": "Error al generar el informe. Tu audio está guardado, puedes reintentar.",
    "errorGeneric": "Error al procesar el audio. Tu audio está guardado.",
    "generationInProgress": "Ya hay una generación en curso. Espera a que termine.",
    "errorAfterApplied": "La generación terminó con un error. Revisa el contenido aplicado en el informe.",
    "dictationNoAccess": "No tienes acceso a este borrador.",
    "dictationTooLarge": "El audio supera el tamaño máximo para dictar.",
    "audioSaved": "Audio recibido",
    "templateNotFound": "No se encontró la plantilla \"{{templateName}}\".",
    "processingDictation": "Procesando dictado…",
    "holdCancel": "Cancelar",
    "holdLock": "Bloquear",
    "holdSend": "Mandar",
    "traditionalDictation": "Dictado tradicional",
    "holdRightClickHint": "Mantén para dictar"
  },
  "micPage": {
    "title": "Micrófono del móvil",
    "connecting": "Conectando…",
    "needPermission": "Debes aceptar el permiso de micrófono en el móvil antes de grabar. Pulsa para permitirlo.",
    "allowMic": "Permitir micrófono",
    "retryMic": "Reintentar permiso de micrófono",
    "permissionBlocked": "Has denegado el acceso al micrófono. Actívalo en los ajustes del navegador del móvil y vuelve a pulsar.",
    "micNotFound": "No se ha detectado ningún micrófono en este móvil.",
    "micBusy": "Otra aplicación está usando el micrófono. Ciérrala e inténtalo de nuevo.",
    "micUnavailable": "No se pudo acceder al micrófono del móvil. Vuelve a pulsar para intentarlo.",
    "ready": "Listo. Pulsa el botón para grabar.",
    "waitingDesktop": "Esperando al escritorio…",
    "recording": "Grabando…",
    "paused": "En pausa",
    "processing": "Procesando audio…",
    "processingHint": "Silero está recortando silencios…",
    "record": "Grabar",
    "pause": "Pausa",
    "resume": "Reanudar",
    "stop": "Enviar",
    "cancel": "Cancelar",
    "desktopConnected": "Escritorio conectado",
    "desktopWaiting": "Escritorio no conectado",
    "desktopBusy": "El escritorio está grabando. Espera a que termine.",
    "missingToken": "Falta el enlace de emparejamiento. Escanea el QR de nuevo.",
    "invalidToken": "El enlace no es válido. Genera otro código en el escritorio.",
    "expiredToken": "El código ha caducado. Genera otro en el escritorio.",
    "roomFull": "Ya hay un teléfono conectado a este código.",
    "permissionDenied": "No se pudo acceder al micrófono. Revisa el permiso del navegador.",
    "insecureOrigin": "El micrófono necesita HTTPS (o localhost).",
    "disconnected": "Se perdió la conexión con el escritorio.",
    "helloTimeout": "No se pudo unir a la sala. Inténtalo de nuevo.",
    "idle": "La sala se cerró por inactividad.",
    "recordingLimit": "Se alcanzó el límite de grabación.",
    "relayError": "No se pudo conectar. Genera otro código en el escritorio."
  },
  "orgAdmin": {
    "backToApp": "Volver a Ainovis",
    "loadError": "No se pudo cargar la información.",
    "saveError": "No se pudo guardar. Revisa los datos e inténtalo de nuevo.",
    "comingSoon": "Próximamente",
    "shell": {
      "eyebrow": "Administración",
      "pageTitlePrefix": "Panel de ",
      "pageTitleAccent": "administración",
      "pageSubtitle": "Administra toda la cuenta {{name}}",
      "meta": "{{groups}} grupos · {{users}} usuarios"
    },
    "rail": {
      "title": "Cuenta",
      "groups": "Grupos",
      "account": "Toda la cuenta",
      "accountPicker": "Cuenta",
      "emptyAccount": "Aún no hay grupos. Añadir el primero",
      "usersTooltip": "Usuarios del grupo"
    },
    "confirm": {
      "deleteGroupHint": "Sus usuarios se quedarán sin grupo asignado. No se puede deshacer.",
      "irreversible": "Esta acción no se puede deshacer."
    },
    "nav": {
      "overview": "Resumen",
      "stats": "Estadísticas",
      "groups": "Grupos",
      "users": "Usuarios",
      "templates": "Plantillas",
      "settings": "Permisos",
      "usage": "Consumo"
    },
    "usage": {
      "title": "Consumo del paquete",
      "cycle": "Ciclo",
      "cycleRange": "{{from}} – {{to}}",
      "status": {
        "current": "En curso",
        "pending": "Pendiente de cierre",
        "closed": "Cerrado"
      },
      "loadError": "No se ha podido cargar el consumo.",
      "noSubscription": "Sin paquete asignado: la cuenta tiene todo gratis y no se factura el consumo.",
      "level": {
        "none": "Paquete ilimitado",
        "ok": "Dentro del paquete ({{pct}} %)",
        "warn": "Cerca del límite ({{pct}} %)",
        "full": "Paquete agotado ({{pct}} %)",
        "over": "Por encima del paquete ({{pct}} %)"
      },
      "package": "Paquete «{{name}}»",
      "free": "Gratis",
      "shadow": "Modo observación",
      "shadowHint": "Se mide el consumo pero no se bloquea nada.",
      "closedNote": "Cifras del cierre del ciclo: ya no cambian.",
      "pendingNote": "El ciclo ha terminado; las cifras pueden variar hasta que se cierre.",
      "kpi": {
        "contratados": "Informes contratados",
        "enviados": "Informes enviados",
        "iteraciones": "Iteraciones consumidas",
        "penalizaciones": "Penalizaciones de lote",
        "facturables": "Informes facturables",
        "extras": "Informes extra"
      },
      "unlimited": "Ilimitado",
      "bolsa": "Bolsa: {{count}} iteraciones",
      "overQuota": "+{{count}} enviados sin bolsa",
      "iteracionesHint": "1 informe = {{n}} iteraciones",
      "penalizacionesHint": "Estudios de lote sin usar con IA en el plazo",
      "formula": "máx(enviados, ⌈iteraciones / {{n}}⌉)",
      "amount": "Importe: {{amount}}",
      "noCharge": "Sin cargo",
      "centerTitle": "Centro {{name}}",
      "centerHint": "El paquete y la facturación son de toda la institución; aquí, la parte de este centro.",
      "share": "({{pct}} % de la institución)",
      "byCenter": "Por centro",
      "byUser": "Por usuario",
      "emptyRows": "Sin actividad en este ciclo.",
      "col": {
        "center": "Centro",
        "user": "Usuario",
        "enviados": "Enviados",
        "iteraciones": "Iteraciones",
        "penalizaciones": "Penalizaciones",
        "consumidas": "Total consumido",
        "share": "% iteraciones"
      },
      "removedCenter": "Centro eliminado",
      "noCenter": "Sin centro",
      "removedUser": "Usuario eliminado",
      "summary": {
        "title": "Consumo del ciclo",
        "figures": "{{facturables}} de {{contratados}} informes facturables · {{enviados}} enviados · {{iteraciones}} iteraciones",
        "extras": "{{count}} extra",
        "open": "Ver consumo"
      }
    },
    "period": {
      "month": "Mes",
      "week": "Semana",
      "day": "Día",
      "last30": "Últimos 30 días"
    },
    "overview": {
      "title": "Resumen",
      "subtitle": "Actividad de {{name}}",
      "reports": "Informes",
      "activeUsers": "Usuarios activos",
      "avgEdit": "Edición media",
      "topUser": "Usuario destacado",
      "reportsCount": "{{count}} informes",
      "activity": "Actividad",
      "contact": "Datos de contacto",
      "noContact": "Sin datos de contacto.",
      "parent": "Cuenta",
      "shortcuts": "Ir a",
      "groupsTitle": "Grupos",
      "topGroup": "Grupo con más informes",
      "fastestGroup": "Grupo más rápido"
    },
    "groups": {
      "title": "Grupos",
      "subtitle": "Grupos de la cuenta",
      "addGroup": "Añadir grupo",
      "emptyGroups": "Esta cuenta aún no tiene grupos.",
      "usersCount": "{{active}}/{{count}} usuarios",
      "deleteGroupConfirm": "¿Eliminar el grupo {{name}}?",
      "editGroup": "Editar grupo"
    },
    "form": {
      "name": "Nombre",
      "surname": "Apellidos",
      "nationalId": "NIF",
      "nameRequired": "El nombre es obligatorio.",
      "address": "Dirección",
      "professionalTitle": "Título profesional (opcional)",
      "email": "Email",
      "phone": "Teléfono",
      "namePlaceholder": "Ej: María",
      "surnamePlaceholder": "Ej: García López",
      "emailPlaceholder": "Ej: maria@hospital.com",
      "nationalIdPlaceholder": "Ej: 12345678A",
      "addressPlaceholder": "Ej: Calle Mayor 1, Madrid",
      "professionalTitlePlaceholder": "Dr., Dra., ...",
      "phonePlaceholder": "Ej: +34 912 345 678"
    },
    "users": {
      "title": "Usuarios",
      "searchPlaceholder": "Buscar por nombre o email",
      "allRoles": "Todos los roles",
      "allStatuses": "Todos los estados",
      "filters": "Filtros",
      "columnUser": "Usuario",
      "columnRole": "Rol",
      "columnGroup": "Grupo",
      "columnStatus": "Estado",
      "statusActive": "Activo",
      "statusPending": "Pendiente",
      "statusInactive": "Inactivo",
      "noGroup": "Sin grupo",
      "count": "{{count}} usuarios",
      "empty": "Esta cuenta aún no tiene usuarios.",
      "emptyFiltered": "Ningún usuario coincide con los filtros.",
      "selected": "{{count}} seleccionados",
      "selectAll": "Seleccionar todos",
      "bulkLabel": "Plantillas personales:",
      "bulkDone": "Actualizados {{count}} usuarios.",
      "bulkPartial": "No se pudieron actualizar {{count}} usuarios.",
      "columnActions": "Acciones",
      "add": "Añadir usuario",
      "addHint": "Recibirá un correo para verificar su cuenta y elegir contraseña.",
      "sendInvite": "Crear e invitar",
      "createOnly": "Crear sin invitar",
      "edit": "Editar usuario",
      "editHint": "El rol y el grupo se cambian desde la tabla.",
      "emailLocked": "El email de acceso no se puede cambiar.",
      "updated": "Usuario actualizado.",
      "formRequired": "Completa todos los campos obligatorios.",
      "resend": "Reenviar invitación",
      "activate": "Activar",
      "deactivate": "Desactivar",
      "activated": "Usuario activado.",
      "deactivated": "Usuario desactivado.",
      "roleChanged": "Rol actualizado.",
      "groupChanged": "Usuario trasladado de grupo.",
      "inviteSent": "Invitación enviada.",
      "deleted": "Usuario eliminado.",
      "deleteTitle": "¿Eliminar a {{name}}?",
      "deleteHint": "Se borran también sus borradores, plantillas y ajustes.",
      "loadMore": "Cargar más ({{remaining}} restantes)",
      "endOfList": "No hay más usuarios.",
      "page": "Página {{page}} de {{totalPages}}",
      "loadError": "No se han podido cargar los usuarios.",
      "accessTitle": "Acceso y permisos",
      "accessSelfHint": "No puedes cambiar tu propio rol ni tus permisos."
    },
    "templates": {
      "title": "Plantillas",
      "total": "{{count}} plantillas",
      "upload": "Subir",
      "uploadScope": "Ámbito",
      "uploadScopePlaceholder": "Elige un ámbito…",
      "scopeEverything": "Cuenta y grupos",
      "scopeAll": "{{name}}",
      "scopeOnlyAccount": "Solo la cuenta",
      "hintAll": "{{total}} plantillas en {{count}} grupos",
      "hintAccount": "Visible para los {{count}} grupos de la cuenta {{name}} · {{total}} plantillas",
      "hintGroup": "Visible solo para el equipo de {{name}} · {{total}} plantillas",
      "searchPlaceholder": "Buscar plantilla",
      "selected": "{{count}} seleccionadas",
      "moveTo": "Mover a",
      "edit": "Editar plantilla",
      "select": "Seleccionar {{name}}",
      "page": "Página {{page}} de {{totalPages}}",
      "emptyAccount": "Esta cuenta aún no tiene plantillas institucionales.",
      "emptyGroup": "Este grupo no tiene plantillas propias.",
      "emptyGroupHint": "También ve las {{count}} de la cuenta {{name}}.",
      "emptyFiltered": "Ninguna plantilla coincide con la búsqueda.",
      "confirmDelete": "¿Eliminar {{count}} plantillas? No se puede deshacer.",
      "confirmPromote": "Vas a hacer visibles {{count}} plantillas para los {{groups}} grupos de la cuenta {{name}}.",
      "loadError": "No se han podido cargar las plantillas.",
      "moveError": "No se han podido mover las plantillas.",
      "languageError": "No se ha podido cambiar el idioma de la plantilla.",
      "deleteError": "No se han podido eliminar las plantillas.",
      "processing": "Guardando",
      "processingHint": "La plantilla ya se ha guardado. Se está terminando de preparar para el dictado; hasta entonces no se podrá detectar automáticamente."
    },
    "scope": {
      "account": "Toda la cuenta",
      "group": "Grupo"
    },
    "settings": {
      "title": "Configuración",
      "applyNote": "Sobrescribe la política de los {{count}} grupos existentes con los valores de arriba."
    },
    "policy": {
      "title": "Política de plantillas",
      "groupNote": "Se aplica a los usuarios de este grupo que no tengan permisos personalizados.",
      "personalTitle": "Plantillas personales",
      "personalHint": "Permite a los radiólogos usar, crear y editar sus propias plantillas y bloques. Al desactivarlo dejan de verse también las plantillas personales que ya tuvieran.",
      "ainovisTitle": "Plantillas de Ainovis",
      "ainovisHint": "Permite acceder a las plantillas de Ainovis. Si se desactiva, dejarán de estar disponibles en la aplicación.",
      "institutionalTitle": "Plantillas institucionales",
      "institutionalHint": "Permite acceder a las plantillas del grupo y de la cuenta. Si se desactiva, dejarán de estar disponibles en la aplicación.",
      "allowed": "Permitido",
      "blocked": "Bloqueado",
      "inherit": "Heredado del grupo ({{state}})",
      "inheritShort": "Heredado del grupo",
      "groupPolicy": "Heredado del grupo",
      "legend": "Permitido / Bloqueado / Heredado del grupo: qué significa cada valor.",
      "legendAllowed": "esta persona siempre puede usarlo, aunque el grupo lo prohíba.",
      "legendBlocked": "esta persona nunca puede usarlo, aunque el grupo lo permita.",
      "legendGroup": "esta persona no tiene decisión propia; se aplica lo que haya decidido su grupo (se muestra al lado).",
      "legendNoGroup": "esta persona no tiene grupo asignado; se aplica la política por defecto de la cuenta.",
      "alwaysAllowed": "Siempre permitido",
      "exemptHint": "Los administradores siempre pueden crear plantillas.",
      "saved": "Política actualizada.",
      "defaultsTitle": "Permisos de plantillas",
      "defaultsWarning": "Estos permisos se aplicarán a los nuevos grupos. Los grupos existentes no se modificarán.",
      "applyToGroups": "Aplicar permisos a grupos existentes",
      "applyConfirm": "Se sobrescribirá la política de todos los grupos de la cuenta. ¿Continuar?",
      "applied": "Aplicado a {{count}} grupos."
    },
    "sentReportPolicy": {
      "title": "Informes enviados",
      "note": "Qué puede hacer el autor con un informe ya enviado. Coordínalo con la integración de la cuenta.",
      "modeTitle": "Modo",
      "positionTitle": "Posición de la adenda",
      "markedNoIntegration": "No se envía a la integración (RIS/PACS): las versiones con cambios marcados solo quedan en Ainovis. No uses este modo en cuentas integradas.",
      "targetTitle": "Aplicar a",
      "target": {"ainovis": "Informes guardados en Ainovis", "integration": "Integración (RIS/PACS)"},
      "targetDesc": {"ainovis": "Los informes guardados en Ainovis se corrigen desde la lista de informes enviados. Las revisiones no se envían al PACS.", "integration": "Al abrir desde el PACS un estudio que ya tiene informe, se trae ese informe y se corrige o se le añade una adenda; al enviarlo sustituye o completa al del PACS. Los informes guardados en Ainovis no se pueden revisar."},
      "positionDesc": "Dónde se coloca la adenda respecto al informe anterior. Es igual para todos los usuarios de la cuenta.",
      "position": { "top": "Encima del informe", "bottom": "Debajo del informe" },      "saved": "Política de informes enviados actualizada.",
      "mode": { "none": "Inmutable", "edit": "Editar", "marked": "Cambios marcados", "addendum": "Adenda" },
      "desc": {
        "none": "Un informe enviado no se puede modificar.",
        "edit": "El autor puede corregir un informe enviado; se crea una versión nueva y se conservan las anteriores.",
        "marked": "El autor puede corregir un informe enviado; lo que borre queda tachado y se crea una versión nueva.",
        "addendum": "El autor puede añadir una adenda; el informe original queda intacto."
      }
    },
    "classifications": {
      "title": "Política de clasificaciones",
      "note": "Decide quién puede usar las clasificaciones en esta cuenta y qué escalas están disponibles.",
      "groupNote": "Lo que se aplica a los usuarios de este grupo, salvo que tengan un permiso propio.",
      "defaultsWarning": "Valores de partida de los grupos nuevos. Los grupos existentes mantienen los suyos.",
      "userTitle": "Clasificaciones",
      "userHint": "Permite a esta persona usar las clasificaciones, al margen de lo que decida su grupo.",
      "scalesTitle": "Clasificaciones disponibles",
      "scalesCount": "{{active}} de {{total}} activas",
      "scalesUserTitle": "Elegir una a una",
      "scalesUserHint": "Excepciones para esta persona; lo que no se toca sigue al grupo.",
      "audienceTitle": "Quién puede clasificar",
      "saved": "Política de clasificaciones actualizada.",
      "audience": {
        "nobody": "Nadie",
        "admins": "Solo administradores",
        "everyone": "Toda la cuenta"
      },
      "audienceDesc": {
        "nobody": "Nadie de la cuenta puede clasificar.",
        "admins": "Comportamiento actual: solo los administradores pueden clasificar.",
        "everyone": "Cualquier usuario de la cuenta puede clasificar."
      },
      "hints": {
        "FLEISCHNER": "Nódulo pulmonar",
        "TI-RADS": "Tiroides",
        "PI-RADS": "Próstata",
        "BOSNIAK_2019": "Quiste renal",
        "GARDEN": "Fractura de cadera",
        "EATON_LITTLER": "Rizartrosis (mano)",
        "SNYDER": "Manguito rotador (hombro)",
        "HERBERT_FISCHER": "Fractura de escafoides (muñeca)"
      }
    },
    "permissions": {
      "column": "Permisos",
      "edit": "Editar permisos",
      "title": "Permisos de {{name}}",
      "bulkTitle": "Permisos de {{count}} usuarios",
      "bulkHint": "Los cambios se aplican a todos los usuarios seleccionados.",
      "inherited": "Heredados",
      "custom": "Personalizados",
      "mixed": "Varios valores",
      "partialExempt": "{{count}} de los seleccionados lo tienen siempre permitido."
    },
    "group": {
      "back": "Volver a grupos",
      "title": "Grupo",
      "subtitle": "Actividad y equipo del grupo",
      "team": "Equipo",
      "emptyTeam": "Este grupo aún no tiene usuarios.",
      "active": "Activo",
      "inactive": "Inactivo"
    },
    "roles": {
      "user": "Usuario",
      "admin": "Admin",
      "supervisor": "Supervisor",
      "super": "Super"
    }
  },
  "jobsIA": {
    "interrumpido": "La generación con IA se interrumpió.",
    "reintentar": "Reintentar",
    "descartar": "Descartar aviso",
    "confirmarTitulo": "¿Reintentar la generación?",
    "confirmarMensaje": "El borrador se editó después de la interrupción. Si reintentas, volverá al estado anterior al paso interrumpido y se perderán esos cambios.",
    "yaReintentado": "Otra persona ya reintentó esta generación.",
    "ocupado": "El borrador está ocupado con otra generación. Inténtalo en unos segundos.",
    "noReintentable": "Esta generación ya no se puede reintentar.",
    "noDisponible": "El servicio no está disponible ahora. Inténtalo más tarde.",
    "noEncontrado": "No se encontró la generación.",
    "errorRed": "No se pudo reintentar. Comprueba tu conexión.",
    "procesando": "Procesando"
  },
  "usageAlert": {
    "warn": "La cuenta ha usado el {{value}} % de los informes del ciclo",
    "full": "La cuenta ha usado todos los informes del ciclo",
    "over": "La cuenta ha superado los informes del ciclo: {{extras}} extras",
    "capNear": "La cuenta se acerca al tope de informes extra: {{extras}} de {{cap}}",
    "capReached": "La cuenta ha alcanzado el tope de {{cap}} informes extra",
    "detail": "{{facturables}} de {{contratados}} informes · el ciclo termina el {{date}}",
    "viewUsage": "Ver consumo",
    "dismiss": "Cerrar aviso",
    "levelOver": "Exceso",
    "levelCap": "Tope",
    "levelTitle": "Consumo del ciclo en curso"
  },
  "quota": {
    "exceeded": "Créditos agotados, contacta con tu administrador",
    "notInPackage": "Esta funcionalidad no está incluida en el paquete de tu institución"
  }
}
